const stringsEN = {
    errorBoundaryTitle: "Oops! Something went wrong.",
    errorBoundaryMessage: "An unexpected error occurred.\nIf the problem persists, please contact the support team.",
    errorBoundaryRetryButton: "Try Again",
    tableCode: "Table code",
    viewDetailsOf: "Details of {part}",
    editDetailsOf: "Edit {part}",
    Código: "Code",
    Nombre: "Name",
    occupants: "occupants",
    highlightWorkplaces: "Highlight workplaces",
    highlightManagement: "Highlight management",
    editPosition: "Edit position",
    viewPosition: "View position details",
    selectBranch: "Select branch",
    orientation: "Orientation",
    up: "Up",
    left: "Left",
    on: "on",
    at: "at",
    builtWithAI: "Built with AI",
    testQuery: "Test query",
    testQueryResults: "Test results",
    testValueForParameter: "Test value",
    totalPending: "Total pending",
    totalOverdue: "Total overdue",
    totalTruncated: "Total truncated",
    anonymousFemaleLowercase: "anonymous",
    obligatoryValueType: "Reported value type is required",
    seniorityError: '"Seniority to" must be greater than or equal to "Seniority from"',
    valueMustBeGreaterThanZeroTableType: "The value must be greater than or equal to 0",
    checkTimeFormat: "Check the format. It must be, for example, 09:00.",
    timeGreaterThanCollaboratorWorktime: "The entered time exceeds the collaborator's workday",
    timeGreaterThan2359: "The entered time exceeds the maximum (23:59)",
    commaSeparatorThreeDecimalsNoZero:
        "Only 3 decimals are allowed. A comma must be used as the separator. 0 is not allowed.",
    commaSeparatorThreeDecimals: "Only 3 decimals are allowed. A comma must be used as the separator.",
    commaSeparatorFiveDecimalsNoZero:
        "Only 5 decimals are allowed. A comma must be used as the separator. 0 is not allowed.",
    commaSeparatorFiveDecimals: "Only 5 decimals are allowed. A comma must be used as the separator.",
    commaSeparatorTwoDecimalsNoZero:
        "Only 2 decimals are allowed. A comma must be used as the separator. 0 is not allowed.",
    commaSeparatorTwoDecimals: "Only 2 decimals are allowed. A comma must be used as the separator.",
    commaSeparatorGenericDecimalsNoZero:
        "Only {number} decimals are allowed. A comma must be used as the separator. 0 is not allowed.",
    commaSeparatorGenericDecimals: "Only {number} decimals are allowed. A comma must be used as the separator.",
    invalidPeriodMessage: "Enter a valid period (YYYY/MM)",
    extraHoursTableInvalidCodeMessage: "The code must start with a letter. Only uppercase letters are allowed.",
    invalidYearSelected: "The entered year is not valid",
    startDateMustBeGreaterThanEndDate: '"Start date" must be less than or equal to "End date"',
    endDateErrorFestiviesTable: '"End date" must be greater than or equal to "Start date"',
    checkYearFestivitiesDate: "Check the year of the entered dates",
    duplicatedDataEntryPerSociety: "A record with the selected Concept Type and Concept already exists",
    duplicatedDataExtraHoursAuthorization: "A record with the selected Employee Code and Date already exists",
    distributionCostInsertValue: "Cost center, Project, or Dimension must contain a value",
    performanceEvaluation: "Performance evaluation",
    fromDateAlt: "From",
    toDateAlt: "to",
    pendingEvaluations: "Performance evaluations you need to complete",
    indicator: "Indicator",
    scaleForPotentialQuestions: "Scale for rating potential questions",
    groupsToEvaluate: "Group of positions to evaluate",
    createPerformanceForm: "Create performance form",
    editPerformanceForm: "Edit performance form",
    duplicatePerformanceForm: "Duplicate performance form",
    createQuestion: "Create question",
    scaleWarningDialogLine1:
        "For the same form code {code}, all scales used for Competencies and Objectives and for any type of evaluation (Form Design) must have the same numerical rating for maximum and minimum values",
    scaleWarningDialogLine2:
        '"The objectives scale" and "The competencies scale" must have the same numerical rating values for the minimum and maximum',
    forExample: "For example",
    lowerThanExpected: "Below expectations",
    asExpected: "As expected",
    aboveExpected: "Above expectations",
    poor: "Poor",
    fair: "Fair",
    good: "Good",
    veryGood: "Very good",
    calibrated: "Calibrated",
    maximumCalification: "Maximum score",
    minimumCalification: "Minimum score",
    questionsForPerformanceEvaluation: "Questions to evaluate potential",
    yearEvaluations: "Evaluation year",
    onlyEvaluationsWithFinalScore: "Only downward evaluations with final score",
    calibrationMessage:
        "Your performance evaluation has been calibrated. Please review it again in Performance Management/Summary and Results to approve it ({selectedProcess})",
    approvePerformanceSummary: "Do you approve the performance evaluation?",
    graphicsPerformanceSummaryLine1:
        "The grades and scores shown are not final and only consider the evaluations completed so far.",
    graphicsPerformanceSummaryLine2: "They also do not consider possible actions by the calibration committee.",
    graphicsPerformanceSummaryLine3:
        "The grades and scores shown are final because all evaluations have been completed.",
    initialScreenPerformanceSummaryResults:
        "There are currently no performance evaluations available to view the summary and results. (If there is an active process, you must wait for the evaluations to be published.)",
    interviewsAndFeedbackNoData:
        "There are currently no performance evaluations available to view the interview and feedback. (If there is an active process, you must wait for the evaluations to go to the Feedback status.)",
    potentialQuestions: "Potential questions",
    finalScorePotential: "FINAL POTENTIAL SCORE",
    partialScorePerformance: "PARTIAL PERFORMANCE SCORE",
    finalScorePerformance: "FINAL PERFORMANCE SCORE",
    asOf: "as of",
    interviewDate: "Interview date",
    deliveredBy: "Delivered by",
    feedbackPublicationMessage:
        "To modify this feedback or make comments, go to the My Feedback feature in My Dashboard",
    specialtyCode: "Specialty Code",
    specialtyName: "Specialty Name",
    specialtySettingsDefinition: "Specialty Settings Definition",
    noSpecialtySettingsDefinition: "No specialties found",
    newSpecialty: "New Specialty",
    examCode: "Exam code",
    diseaseCode: "Disease code",
    allergyCode: "Allergy code",
    categoryCode: "Category Code",
    categoryName: "Category Name",
    newCategory: "New Category",
    noCategorySettingsDefinition: "No categories found",
    categorySettingsDefinition: "Category Settings Definition",
    categoryDuplicated: "The category has been successfully duplicated",
    categoryCreated: "The category has been successfully created",
    categoryModified: "The category has been successfully updated",
    categoryDeleted: "The category has been successfully deleted",
    categoryInUse: "The category cannot be deleted because it is in use",
    categoryInUseModify: "The category cannot be modified because it is in use",
    duplicatedDataCategory: "There cannot be more than one category with the same code or name",
    specialtyDuplicated: "The specialty has been successfully duplicated",
    specialtyCreated: "The specialty has been successfully created",
    specialtyModified: "The specialty has been successfully updated",
    specialtyDeleted: "The specialty has been successfully deleted",
    specialtyInUse: "The specialty cannot be deleted because it is in use",
    specialtyInUseModify: "The specialty cannot be modified because it is in use",
    duplicatedDataSpecialty: "There cannot be more than one specialty with the same code or name",
    systemTableDuplicated: "The system table has been successfully duplicated",
    systemTableCreated: "The system table has been successfully created",
    systemTableModified: "The system table has been successfully updated",
    systemTableDeleted: "The system table has been successfully deleted",
    userTableDuplicated: "The user table has been successfully duplicated",
    userTableCreated: "The user table has been successfully created",
    userTableModified: "The user table has been successfully updated",
    userTableDeleted: "The user table has been successfully deleted",
    evaluationProcessDefnitionAssignmentLine2:
        "If you replace the evaluator, please note that the ratings already made by the current evaluator will be retained. Do you want to continue?",
    evaluationProcessDefnitionAssignmentLine3:
        "If you assign a new evaluator, the evaluation already performed will be completely deleted. Do you want to continue?",
    evaluationProcessDefnitionAssignmentLine1:
        "The evaluated person {evaluated} has already been rated by evaluator {evaluator} in the evaluation type {formType}.",
    percentageMyRequests: "Percentage of the requested value over the salary: {percentage}",
    percentageExceedsMyRequests:
        "The value you are requesting exceeds the maximum allowed percentage over your salary ({percentage}%)",
    onboardingMaterialCreated: "The material or resource has been successfully created",
    onboardingMaterialModified: "The material or resource has been successfully updated",
    onboardingMaterialDeleted: "The material or resource has been successfully deleted",
    positionEditorError: "The number of positions cannot be less than the number of occupied positions.",
    stepFourMessagePerformanceForm:
        "If you disable potential evaluation, all existing questions related to that type of evaluation will be deleted.",
    stepOneMessagePerformanceForm:
        "If you change the form type, all existing questions related to that type of evaluation will be deleted.",
    stepTwoMessagePerformanceForm:
        "If you disable the evaluation of transversal competencies, all selected competencies related to that type of evaluation will be deleted.",
    evaluationProcessDefinitionMessage1:
        "All data related to the process will be deleted: evaluator network, competency ratings, goal and objective ratings, final results of already evaluated assessments, and potential classification with 9-boxes.",
    evaluationProcessDefinitionMessage2: "Are you sure you want to continue?",
    replacedEvaluators: "{number} evaluator(s) have been replaced",
    assignedEvaluators: "{number} evaluator(s) have been assigned",
    recognitionPlanDialogLine1: "The plan includes employees with already assigned points.",
    recognitionPlanDialogLine2:
        "Before deleting it, we recommend transferring them to another plan; otherwise, they will lose all earned points and recognitions.",
    recognitionPlanDialogLine3: "Do you still confirm the deletion?",
    deleteSpecialty: "Delete specialty",
    deleteCategory: "Delete category",
    deleteSpecialtyContent: "Do you want to delete the specialty?",
    deleteCategoryContent: "Do you want to delete the category?",
    createCategory: "Category creation",
    createSpecialty: "Specialty creation",
    performanceSummaryResultAcceptRejectAccepted: "Evaluation successfully accepted",
    performanceSummaryResultAcceptRejectRefused: "Evaluation successfully refused",
    mailDialogEvaluationProcessDefinition: 'The selected record must be in the "In feedback" status',
    mailDialogEvaluationProcessDefinition2: 'The selected record must be in the "In progress" status',
    conceptFormulaFunction:
        'The concept you want to update does not have formulas, neither the standard nor the custom one. Therefore, to be considered in a calculation process, this concept must always be entered with a "Reported value". To do this, select the "Mandatory value" option in the "Entry structure" field.',
    recognitionsPlanAssigmentLine1:
        "The employee already has earned points. If you remove them, all their points and recognitions will be lost.",
    recognitionsPlanAssigmentLine2: "Before removing them, you may transfer them to another plan if desired.",
    recognitionsPlanAssigmentLine3: "Do you still confirm the deletion?",
    doYouWantToDeleteAttachment: "Do you want to delete the attachment?",
    assistanceAnalysisLine1: "Please note that the changes applied here, such as:",
    assistanceAnalysisLine3: "- Schedule changes",
    assistanceAnalysisLine4: "- Overtime authorization",
    assistanceAnalysisLine5: "- Justification of absences",
    assistanceAnalysisLine6:
        'Will not be reflected in the attendance analysis results until the "Attendance analysis calculation" process is run again',
    valueCannotBeGreaterThanAbscenseHours: "The entered value cannot be greater than the absence hours ({hours})",
    performanceFormInUse:
        'For this form, there are data that can no longer be modified (they will be shown for viewing only) because the form is linked to one or more performance evaluation processes that are not yet "closed"',
    evaluationAccepted: "Your evaluation was accepted on {acceptanceDate}",
    onBoardingProcessAssignmentMessage3Line1: "The assignment has not been completed.",
    onBoardingProcessAssignmentMessage3Line2:
        "You have selected employees who are already in an ongoing onboarding process.",
    onBoardingProcessAssignmentMessage3Line3: "You must omit them from the selected list:",
    onBoardingProcessAssignmentMessage4Line1:
        'If you change the process status to "Closed", keep in mind that there are still employees for whom the process has not been fully completed.',
    onBoardingProcessAssignmentMessage4Line2: 'Do you want to change the status to "Closed" anyway?',
    onBoardingProcessAssignmentMessage5Line1:
        "If you delete the onboarding process, the following will also be deleted:",
    onBoardingProcessAssignmentMessage5Line2: "All traceability and details of the employees who have participated.",
    onBoardingProcessAssignmentMessage5Line3: "Their comments, attachments, and feedback received during the process.",
    onBoardingProcessAssignmentMessage5Line4: "The actions performed and the stages they have gone through.",
    onBoardingProcessAssignmentMessage5Line5: "Are you sure you want to continue?",
    pollNotFound: "Poll not found",
    insertDecimalsNoZeroAllowed: "Only {decimals} decimals are allowed. 0 cannot be entered.",
    onBoardingProcessAssignmentMessage1Linea1:
        "If you remove the employee from the onboarding process, the following will also be deleted:",
    onBoardingProcessAssignmentMessage1Linea2: "All traceability and details of their participation in the process.",
    onBoardingProcessAssignmentMessage1Linea3: "Their comments, attachments, and feedback received during the process.",
    onBoardingProcessAssignmentMessage1Linea4: "The actions performed and the stages they have gone through.",
    onBoardingProcessAssignmentMessage1Linea5: "Are you sure you want to continue?",
    onBoardingProcessAssignmentMessage2Linea1:
        "It is not possible to add new employees to this process because one or more employees already have advanced activities.",
    onBoardingProcessAssignmentMessage2Linea2: "Create a new process to onboard new employees.",
    deleteRowsConfirmation: "Do you want to delete the selected records?",
    performanceEvaluationErrorMessage:
        'The weights of the employee’s objectives for the period "{periodName}" do not total 100%, evaluation is not possible',
    selectNextStage: "Select the next stage",
    attentionForStage: "Attention: for status {statusName}",
    collaboratorAssistanceAnalysis: "Employee attendance analysis",
    assetsDiscountsRequiresBank: 'Bank is required for the payment method "Deposit"',
    evalProcessWarningMessage:
        "All selected employees will have their direct manager assigned as evaluator. Do you want to continue?",
    extraHoursAuthorizationConfirmMessage1:
        "To save information, the applied filters will be deactivated. You will be able to activate them again afterward.",
    extraHoursAuthorizationConfirmMessage2:
        "To add employees, the applied filters will be deactivated. You will be able to activate them again afterward.",
    extraHoursAuthorizationMessage:
        'You can only delete the record when there are "No" hours in "Unauthorized Overtime". If you do not want to authorize any, enter 00:00 in "Authorized Overtime"',
    assetsDiscountsRequiresBankAccount: 'Bank Account is required for the payment method "Deposit"',
    assetsDiscountsDateEndGreaterThan: '"End Period" must be greater than or equal to "Start Period"',
    assetsDiscountsDateStartLessThan: '"Start Period" must be less than or equal to "End Period"',
    assetsDiscountsDecimalQuantity: "Only {decimals} decimals are allowed.",
    areYouSureYouWantToExecuteProcess: `Are you sure you want to execute the process: {process}?`,
    assetsDiscountsEntryPerConceptSetDuplicated: `Check that there is no more than one entry with the same date for an employee ({duplicated})`,
    codeMustNotExceed3Chars: "The code must not exceed 3 characters!",
    nameMustNotExceed60Chars: "The name must not exceed 60 characters!",
    checkIfDatesAreCompletes: "Verify that the date cells are complete",
    timePerDayCantExceedHours: "Time per day cannot exceed {maxHours} hours",
    typesOfSkills: "Competencies",
    competencyType: "Competency type",
    viewPositionData: "View {name}'s position",
    quadrantSuccesfullyUpdated: "The quadrant has been successfully updated",
    notesMessageLine1:
        "If you delete the task, all associated feedback will also be deleted, including text, references, evidence, and comments",
    vacationsYearRequired: "You must enter a valid annual period, e.g., 2022/2023",
    sumMustEqual100: "The weighted sum is correct and totals 100% for the specific competency groups",
    sumErrorTypesOfSkills:
        "The weighted sum totals {number}% for {verificationFailures}. It is necessary to complement with another competency or reassign the weights",
    systemTableCheckChange:
        "To indicate that the table is validated, the field “U_vis = Validation status” must exist within the table structure",
    deleteTableSystemUser: "Do you want to delete the {isSystemTables} table?",
    invalidConceptCode:
        'The concept code is not valid. It may only contain letters, numbers, and the characters "-", "_"',
    structureType: "Structure type or set type",
    notPossibleToDeleteAssetAndDiscount:
        "It is not possible to delete an asset or discount whose entry method is by company",
    prepaid: "Prepaid",
    entryByImportAlt: "Entry via import",
    installments: " installments",
    installmentAlt: "1 installment",
    installmentsToPrepay: "Installments to prepay",
    prepayLoan: "Prepay loan",
    pendingInstallments: "Pending installments",
    invalidInstallmentQuantity: "The number of installments is not valid",
    invalidInstallmentQuotaNumber: "The reference installment number is not valid",
    emptyTableEntryByInstallments:
        'The table is empty. If the header data has been filled in, press "Generate installments"',
    installmentSumErrorPendingInstallments: "The sum of pending installments does not match the outstanding balance",
    checkCellForValidValues: "Verify that the cells have valid values",
    newResponsibleCommunication: "New person responsible for the communication",
    newCommunicationStatus: "New communication status",
    actualStatus: "Current status",
    responsibleAssignedAlt: "Assigned responsible",
    changeStatusCommunicationChannel:
        'When the communication is changed to the statuses "Voided" or "Resolved", no further actions or new responses will be allowed',
    requiresReceiverSelection: "Requires recipient selection",
    anotherConcept: "Another concept",
    extraVariableFieldAlt: "Descriptive complement",
    divisionSettingsModifiedSuccesfully: "The business unit has been successfully updated",
    divisionSettingsCreatedSuccesfully: "The business unit has been successfully created",
    divisionSettingsDeletedSuccesfully: "The business unit has been successfully deleted",
    delegatesAttentionsTo: " delegates attentions to ",
    loadedTemplate: "Currently loaded template",
    digitalFolderFileType: "File type in folder",
    digitalFolderInstance: "Work instance in folder",
    enableAlertMessage: "Enable alert sending",
    consentInUse: "It is not possible to delete the consent for the employee because it has already been received",
    noAccessToDigitalFolder: "You do not have access to {name}'s digital folder",
    communicationSuccesfullyDeleted: "Communication successfully deleted",
    actionSuccesfullyCreated: "Action successfully created",
    responsibleAssignedSucessfully:
        "Responsible person successfully assigned. The communication will now be visible only to the new responsible party.",
    communicationClassifiedSuccesfully: "Communication successfully classified",
    messageCommunicationChannelLine1:
        'You can change the status of the communication to: "Resolved" or "Void", and a historical record will be kept.',
    messageCommunicationChannelLine2: "If you delete it, all information and communication traceability will be lost.",
    messageCommunicationChannelLine3: "Do you still want to delete it?",
    attentionResponsibleAlt: "Person responsible for attention",
    createdByAlt: "Created by",
    complaints: "Complaints",
    suggestions: "Suggestions",
    reports: "Reports",
    complaintsLine1Part1: "Keep in mind that when you file a ",
    complaintsLine1Part2: '"Report"',
    complaintsLine1Part3:
        ", we will assign someone to address it immediately and take any necessary corrective actions as soon as possible.",
    complaintsLine2:
        "When making a report, include as many details as possible such as: dates, times, description of events, locations, or names of people if necessary, as this will help us thoroughly analyze the report.",
    complaintsLine3: "Remember that in the case of reports, we need as much information as possible to help you.",
    complaintsLine4: "Listening to you is part of our commitment.",
    commentRelatedWith: "Comment related to your",
    your: "Your",
    thanksForSharingYour: "Thank you for sharing your",
    communicationChannelMessageCreated: "with us. We will assign someone to handle it shortly.",
    communicationChannelMessageModified: "was successfully modified",
    suggestionLowercase: "suggestion",
    complaintLoweracase: "complaint",
    reportLowercase: "report",
    thirdPartyReportLowercaseShort: "third party report",
    commentRelatedWithThirdPartyReport: "Comment related to the third party report",
    thirdPartyReportNameSurname: "Last name and first name of the reporter",
    queryLowerCase: "query",
    representationColor: "Representation color",
    calcReferenceModifiedCorrectly: "Calculation reference successfully updated",
    calcReferenceAddedCorrectly: "Calculation reference successfully created",
    calcReferenceRemovedCorrectly: "Calculation reference successfully deleted",
    cannotDeleteCalendarAssociatedCalcProcessSingular:
        "The time calendar cannot be modified because it is already associated with the calculation process",
    cannotDeleteCalendarAssociatedCalcProcessPlural:
        "The time calendar cannot be modified because it is already associated with calculation processes",
    notPossibleToChangeCalendarType: "It is not possible to manually change a calendar to 'Historical' status",
    fromDateCantBeLessThanEndDate: "'End date' cannot be earlier than 'Start date'",
    fieldStructureTable: "Field structure of the table",
    sql: "SQL",
    fieldNamesForQueries: "Field names for queries",
    allowEditorForSystemTables: "Enable editors for the system table",
    publicationCenterCreate: "Publication center creation",
    exportErrorHistoricAccumulators:
        "To export the template with data, the number of records in each export must not exceed 50,000",
    selectQueryPeriod: "Select query period",
    accumulator: "Accumulator",
    performanceInterviewAndFeedback: "Poll and Feedback",
    spanish: "Español",
    english: "English",
    Personal: "Personal",
    create: "Create",
    chat: "Chat",
    charts: "Charts",
    assignPIN: "Assign PIN",
    roleAccess: "Role Access",
    icariusTech: "ICARIUS Technology",
    createdBy: "Uploaded by",
    contractEndDate: "Contract End Date",
    maxCharPossible: "Max allowed:",
    cellphoneVisible: "Your cellphone will be visible",
    cellphoneVisibleShort: "Cellphone",
    civilStateVisible: "Your marital status will be visible",
    civilStateVisibleShort: "Marital Status",
    bornDateVisible: "Your birth date will be visible",
    bornDateVisibleShort: "Birth Date",
    personalAddressVisible: "Your personal address will be visible",
    personalAddressVisibleShort: "Personal Address",
    showUnreadAlerts: "Unread",
    nineBoxSettings: "9-Box Definitions",
    talentClassification: "Talent Classification",
    performanceEvaluations: "Performance Evaluations",
    performanceEvaluationsCalibration: "Performance Calibration",
    performanceSummaryAndResults: "Summary and Results",
    forms: "Forms",
    performanceManagement: "Performance Management",
    talentAcquisition: "Talent Acquisition",
    showAllAlerts: "All",
    alertsFilterBy: "Filter by",
    references: "References",
    comingSoon: "Coming Soon",
    completeFields: "There are incomplete values in the form",
    offsetY: "Y Offset",
    offsetX: "X Offset",
    alertChangeProfilePhoto:
        "Dear collaborator: If you want to upload or change your photo, we request it to be a personal photo for corporate use. Thank you for your cooperation.",
    zoom: "Zoom",
    rotation: "Rotation",
    news: "News",
    uploadNewPhoto: "Upload new photo",
    modifyMyPhoto: "Modify profile picture",
    correctlyModifiedPhoto: "Your photo has been updated successfully",
    dataUpdate: "Data Update",
    correctlyModifiedPersonalData: "Your personal information was successfully updated",
    myPersonalData: "Personal Data",
    rightPannelSwitchIndication: "Indicate if the following personal data will be visible in the Directory",
    help: "Help",
    personales: "Personal",
    contrato: "Contract",
    remuneracion: "Remuneration",
    ubicacion: "Location",
    tiempos: "Times",
    timeZones: "Time Zones",
    selectContactToStartConversation: "Select a contact",
    startConversation: "Start a conversation",
    messagePlaceholder: "Write a message...",
    sombrear: "Highlight",
    selectColorTitle: "Select a color",
    theme: "Themes and Colors",
    color: "Color",
    green: "Green",
    red: "Red",
    lightBlue: "Light Blue",
    blue: "Blue",
    gold: "Gold",
    orange: "Orange",
    silver: "Silver",
    teal: "Teal",
    purple: "Purple",
    pink: "Pink",
    brown: "Brown",
    of: "of",
    pinWillChange: "PIN Change or Assignment",
    recoverPinDialogText: "The PIN for user {user} and client {client} will be changed or assigned",
    recoverPinDialogTextFull:
        "The PIN for user {user}, client {client}, and society {society} will be changed or assigned",
    albanyTechnologies: "Albany Technologies",
    contact: "Contact",
    undefinedContact: "No contact data defined",
    aboutUsTitle: "ICARIUS (ODESA)",
    internalCode: "Internal code",
    thisPage: "Export Page",
    allPages: "Export All",
    myPeopleTableTitle: "My Personnel",
    everyone: "Everyone",
    activeAndPlantPersonnel: "Active and Plant Personnel",
    id: "Identifier",
    code: "Employee Code",
    name: "Name",
    nameAndSurname: "Last Name and First Names",
    liquidoNeto: "Net Liquid",
    income: "Hire Date",
    coin: "Currency",
    salary: "Salary",
    filter: "Filter",
    close: "Close",
    contactQr: "Contact QR",
    export: "Export",
    searchLabel: "Search",
    filterBy: "Filter by",
    noEmployeesToShow: "No employees to show",
    newAnnotation: "Enter New Annotation",
    noAnnotationsOfThisType: "No annotations of the selected type",
    noAnnexesForThisFilter: "No files for the selected filters",
    selectType: "Select Type / Reset",
    selectInstance: "Select Instance / Reset",
    iconNewAnnotation: "New Annotation",
    iconEditAnnotation: "Edit Annotation",
    merit: "Merit",
    demerit: "Demerit",
    noType: "Unclassified Annotation",
    noSubtype: "No Subtype",
    subtypeTitle: "By Annotation Subtype",
    categoryTitle: "By Annotation Category",
    meritsTitle: "By Merits and Demerits",
    noAnnotations: "No annotations",
    annotationsConfirm: "Do you want to delete the annotation?",
    visibleColaborador: "Visible to the Collaborator",
    invisibleColaborador: "Not visible to the Collaborator",
    availableColaborador: "Available to the Collaborator",
    notAvailableColaborador: "Not available to the Collaborator",
    maxChar: "Max allowed: 512",
    currentChar: "Character Count:",
    enterText: "Enter text",
    fieldRequeriment: "All fields are mandatory.",
    type: "Type",
    instance: "Instance",
    subtype: "Subtype",
    lastStatus: "Last Status",
    status: "Status",
    viewAnnotationTitle: "Annotation Number, Category, and Subtype",
    viewAnnotationTime: "Creation Date and Time",
    viewAnnotationNewTime: "Modification Date and Time",
    viewAnnotationVisibility: "Visibility",
    viewAnnotationContent: "Annotation Content",
    viewAnnexVisibility: "Available",
    iconNewAnnex: "New File",
    viewAnnexTitle: "File Number, Instance, and Type",
    viewAnnexContent: "File Text",
    selectAnnex: "Select File",
    viewAnnexFile: "File Document",
    annexConfirm: "Do you want to delete the file?",
    iconEditAnnex: "Edit File",
    annexNoType: "No Type",
    maxCharAnnex: "Max allowed: 250",
    documentsListTitle: "File List",
    noAnnexYet: "No file selected yet",
    clicIndication: "Click on charts to display list",
    downloadAnnexFolder: "Download Folder",
    downloadAnnexFolderConfirm: "Do you want to download the folder?",
    noAnnexes: "No files",
    annexFechaVencimiento: "Expiration Date",
    annexDateHelper: "If you enter an Expiration Date, it must be later than the current date",
    annexRequired: "Mandatory",
    annexNotRequired: "Not Mandatory",
    expires: "Expires on:",
    by: ", by ",
    notAvailable: "Not available",
    newEmployee: "New Employee",
    scheduleProgrammed: "Scheduled time for today",
    assistanceStatus: "Assistance Status",
    documents: "Documents",
    contracts: "Contracts",
    payroll: "Payroll",
    absences: "Absences",
    times: "Times",
    familiarGroup: "Family Group",
    fatherLastName: "Father's Last Name",
    firstName: "First Name",
    employeeNumber: "Employee Number",
    officePhone: "Office Phone",
    particularPhone: "Personal Phone",
    bloodType: "Blood Type",
    age: "Age",
    passportNumber: "Passport Number",
    expirationPassport: "Passport Expiration",
    motherLastName: "Mother's Last Name",
    secondName: "Second Name",
    extension: "Extension",
    donante: "Donor",
    contractCode: "Contract Code",
    contractAmount: "Number of Contracts",
    antiquityDate: "Seniority Date",
    contractMotive: "Contract Motive",
    legalMotive: "Legal Termination Motive",
    calculationMotive: "Calculation Termination Motive",
    familyAllowanceSection: "Family Allowance Section",
    additionalMonthVacation: "Additional Vacation Months",
    additionalVacationDate: "Additional Vacation Date",
    additionalDaysVacation: "Additional Vacation Days",
    previsionInstitution: "Pension Institution",
    vacationsUpdateDate: "Vacation Account Update Date",
    affiliationDate: "Pension Affiliation Date",
    healthInstitution: "Health Institution",
    heavyWork: "Heavy Work",
    extremeZoneReduction: "Extreme Zone Reduction",
    extremeZonePercentage: "Extreme Zone Percentage",
    taxOtherCountry: "Tax in Another Country",
    valueOtherCountry: "Quoted Value in Another Country",
    ineClassif: "INE Classification",
    specialCapabilities: "Special Capabilities",
    businessSalary: "Business Salary",
    icariusMenuProfile: "ICARIUS Menu Profile",
    calendarType: "Calendar Type",
    scheduleControlType: "Schedule Control Type",
    cardCode: "Card/Credential Code",
    freedExtraHours: "Freed Extra Hours",
    canMarkMobile: "Can Mark from Mobiles",
    canMarkICARIUS: "Can Mark from ICARIUS",
    canCapturePosition: "Can Capture Geolocation",
    updateOK: "Data successfully updated",
    createdOK: "Employee successfully created",
    namesAndLastnames: "Last Names and Names",
    employeeMasterSidebarTitle: "Complementary Data",
    accessPerm: "Access Permissions",
    otherData: "Other Data",
    contratacionType: "Hiring Type",
    creationUserPhotoInfo: "Changes will be reflected when creating the user",
    icariusProfile: "ICARIUS Profile",
    groups: "Groups",
    personalesTitle: "Personal",
    ubicacionTitle: "Location",
    tiemposTitle: "Times",
    contratoTitle: "Contract",
    remuneracionTitle: "Remuneration",
    receiptsTableTitle: "Payslips",
    myreceiptsMessage:
        "Your payslip has been downloaded, and your acceptance has been registered on {accepted_date} at {accepted_time} hrs",
    receipts: "Payslips",
    certificates: "Certificates",
    receiptsViewAll: "All",
    receiptsViewSignPending: "Pending Signature",
    receiptSignNotFound: "Requested documents not found",
    receiptSignFiltered: "Data successfully filtered for digital signing",
    receiptUnauth: "You are not authorized to sign documents",
    receiptWrongPing: "Incorrect PIN entered",
    receiptWrongDocument: "There was a problem with one of the selected documents; please try again",
    receiptSuccess: "Payslips successfully signed",
    certificatesViewAll: "All",
    certificatesViewSignPending: "Documents to Sign",
    certificateSignNotFound: "Requested documents not found",
    certificateSignFiltered: "Data successfully filtered for digital signing",
    certificateUnauth: "You are not authorized to sign documents",
    certificateWrongPing: "Incorrect PIN entered",
    certificateWrongDocument: "There was a problem with one of the selected documents; please try again",
    certificateSuccess: "Certificates successfully signed",
    scheduleDate: "Schedule date",
    scheduleCode: "Schedule code",
    hrefState: "",
    employeeCode: "Employee Code",
    names: "Names",
    internalNumber: "Internal Number",
    state: "Status",
    email: "Email",
    fType: "Functionary Type",
    position: "Position",
    positionDate: "Position Assignment Date",
    function: "Function",
    functionDate: "Function Assignment Date",
    civilState: "Marital Status",
    sex: "Gender",
    nationality: "Nationality",
    category: "Category",
    costCenter: "Management cost center",
    managementCenter: "Publication Center",
    specialty: "Specialty",
    bornDate: "Birth Date",
    linkedin: "LinkedIn",
    photo: "Photo",
    direcMaps: "",
    address: "Address",
    comuna: "Commune",
    provicia: "Province",
    region: "Region",
    country: "Country",
    postalCode: "Postal Code",
    cellphone: "Cellphone",
    phoneExtension: "Phone Extension",
    contractType: "Contract Type",
    incomeDate: "Hire Date",
    outcomeDate: "Exit Date",
    noOutcomeDate: "(No exit date)",
    paymentLocation: "Payment Location",
    jobLocation: "Job Location",
    management: "Management",
    department: "Department",
    section: "Section",
    paymentMethod: "Payment Method",
    paymentType: "Payment Type",
    bank: "Bank",
    bankAccount: "Bank Account",
    bankAccountType: "Account Type",
    salaryUnit: "Salary Unit",
    jornadaType: "Workday Type",
    hoursPerDay: "Daily Contract Hours",
    hoursPerMonth: "Monthly Contract Hours",
    laborUnion: "Labor Union",
    retired: "Retired",
    scheduleName: "Schedule name",
    shift: "Shift",
    shiftName: "Shift name",
    shiftDate: "Shift Assignment Date",
    comments: "Comments",
    comment: "Comment",
    opinion: "Opinion",
    workPhone: "Work Phone",
    phone: "Phone",
    responsibleEmail: "Response Responsible Email",
    responsiblePhone: "Response Responsible Phone",
    responsibleName: "Response Responsible Name",
    requester: "Requester",
    toExcel: "to Excel",
    toJson: "to JSON",
    toXml: "to XML",
    toTxt: "to TXT",
    toPdf: "to PDF",
    toIcarius: "to ICARIUS AI",
    plantPersonnel: "Plant Personnel",
    contratista: "Contractor",
    centroDeGestion: "Publication Center",
    noFaceFound: "The image does not seem to contain a human face",
    fileSameName: "A file with the same name already exists",
    fileTypeNotValid: "The file type is not supported",
    vigente: "Valid",
    noVigente: "Not Valid",
    allAnnotations: "All Annotations",
    annotationsByDate: "Since Last Hiring",
    allAnnexes: "All Files",
    annexesByDate: "Since Last Hiring",
    attachment: "Attachment",
    approvationType: "Approval type",
    publishedProcess: "Published process",
    periodicity: "Periodicity",
    changingPin: "Change My PIN",
    currentPin: "Current PIN",
    newPin: "New PIN",
    newPinConfirmation: "Repeat Your New PIN",
    pinCorrectlyChanged:
        "PIN successfully changed. Use your new PIN for your next access, whether on the WEB Platform or the APP",
    pinRegenerationConfirmed: "Check your email inbox again because a temporary access PIN has been sent to you.",
    mailSent: "Instructions for restoring your access PIN have been sent to your email.",
    portal: "{role} Portal",
    toolbarTitle: "Albany Technologies",
    disagree: "Cancel",
    agree: "Accept",
    atention: "Attention",
    explainFormulaWithAI: "Understand the formula with ICARIUS AI",
    yes: "Yes",
    no: "No",
    sentTo: "Sent to",
    managerPhone: "Recipient's Phone",
    managerEmail: "Recipient's Email",
    lastActionTime: "Last Action Time",
    lastActionDate: "Last Action Date",
    loginSubtitle: "Collaborative self-consultation of personnel",
    version: "Version",
    loginAs: "Log in as",
    collaborator: "Collaborator",
    collaborators: "Collaborators",
    manager: "Manager",
    employer: "Employer",
    recoverPinAccessCode: "Recover Access PIN",
    copyright: "Copyright (C) {year} ICARIUS",
    allRightsReserved: "All Rights Reserved",
    credits: "Credits",
    icariusMail: "support@icariusglobal.com",
    albanyWebsite: "albany.company",
    icariusWebsite: "icariusglobal.com",
    icariusForoWebsite: "soporte.icarius.online",
    client: "Client",
    user: "User",
    pin: "PIN",
    noResultsFoundQuery: 'No results found for "{query}"',
    searchCommandsConfigurationScreens: "Search menus, configurations, screens...",
    key: "Key",
    selectSocietyTitle: "Select a Society",
    society: "Society",
    favouriteSliderTitle: "Useful Links",
    downloadSliderTitle: "Documents of Interest",
    pollSliderTitle: "Polls",
    countersSliderTitle: "Numbers",
    directory: "Directory",
    alerts: "Alerts and Notices",
    notices: "Notices",
    myPin: "My PIN",
    closeSession: "Log Out",
    menuConfigurator: "Menu Configuration",
    onboardingProfiles: "Onboarding Profiles",
    typesOfPublicationFormats: "Types of Publication Formats",
    typesOfOnboardingActions: "Types of Onboarding Actions",
    typesOfPublicationChannels: "Types of Publication Channels",
    classificationApplicantsTypes: "Types of Applicant Classification",
    loginTitle: "Log In",
    mainTitle: "Home",
    myAssistanceTitle: "My Assistance",
    assistanceTitle: "Assistance Records",
    myPeopleTitle: "My Personnel",
    nineBoxClassification: "9-Box Classification",
    chatTitle: "Chat",
    certificateFullTitle: "Payslips and Certificates",
    myCertificateFullTitle: "My Payslips and Certificates",
    myCertificatesConfirmationTitle: "Do you accept the generated certificate?",
    receiptsFullTitle: "Payslips",
    receiptsShortTitle: "Payslips",
    myReceiptsFullTitle: "My payslips",
    myHistoricalReceiptsFullTitle: "My historical payslips",
    myReceiptsConfirmationTitle: "Do you accept the generated receipt?",
    confirmReceipt: "Reason for not being satisfied with the generated receipt",
    deniedDocumentMessage: "Please enter the reason for rejecting the document",
    certificateTitle: "Certificates",
    myCertificateTitle: "My certificates",
    noCertificates: "No certificates available",
    privacyPolicy: "ABOUT DATA PROTECTION AND PRIVACY POLICY",
    selectCertificate: "Receipt or certificate",
    noReceipts: "No payslips with digital signature available for download",
    selectReceipt: "Payslip",
    selectCalcMethod: "Calculation process",
    confirmCertificateReceipt: "Reason for not being satisfied with the generated certificate",
    holidaysTitle: "Vacation current account",
    loansTitle: "Loan current account",
    loansTitleLong: "Loan current account",
    myAnnotationsTitle: "My annotations",
    myAnnexesTitle: "My digital folder",
    myInfoTitle: "My data",
    receiptsTitle: "Payslips",
    myCredential: "My credential",
    myPositionDescription: "My position description",
    positionDescription: "Position description",
    myReceiptsTitle: "My Payslips",
    myHistoricalReceiptsTitle: "My historical payslips",
    onaSurveyTypeError:
        "For an ONA survey type, you can only create multiple-choice questions with a minimum of 3 options and a maximum of 10 options",
    requestsTitle: "Requests",
    onaOption: "Group of people",
    requestsControlTitle: "Request control",
    schedulerTitle: "Timesheet",
    decisionCubes: "Management cubes",
    kpiIndicators: "Indicators (KPI)",
    query: "Queries",
    eventsIncome: "Event import",
    eventsAuth: "Event authorization",
    employeeMaster: "Employee master",
    myKpiIndicators: "My indicators (KPI)",
    myPending: "Requests pending attention",
    myPendingEmployer: "Requests pending attention",
    myQueries: "My queries",
    queries: "Queries",
    myDigitalSign: "My digital signature",
    myDecisionCubes: "My management cubes",
    groupEvents: "Group events",
    individualEvents: "Individual events",
    parametrization: "Parametrization",
    myRequests: "My requests",
    myRequestsManager: "My requests",
    myRequestsSecondGrid: "myRequestsSecondGrid",
    myPendingSecondGrid: "myPendingSecondGrid",
    timeManagement: "Time management",
    engagement: "Engagement",
    managementNav: "Management and analysis",
    calculationManagement: "Calculation management",
    Remunerations: "Remunerations",
    settings: "Settings",
    changeTheme: "Change theme",
    requestedDocuments: "Requested documents",
    signedDocuments: "Signed documents",
    digitalReceipts: "Digital payslips",
    digitalCertificates: "Digital certificates",
    themeAndColors: "Corporate colors",
    generalSettings: "General parameters",
    next: "Next",
    previous: "Previous",
    pollInfo: "Question {actualNumber} of {totalNumber}",
    submit: "Submit",
    gratitudMessage: "Thank you very much for participating in our survey!",
    alreadyAnswered: "You have already participated in this survey",
    aboveMaximumPoll: "Contains answers that exceed the limit",
    required: "Required",
    errorConnection: "An error occurred while communicating. Please try again",
    anonymousPoll: "This survey is anonymous and non-binding",
    gridCopy: "Copy",
    gridCopyWithHeaders: "Copy with headers",
    gridExport: "Export",
    group: "Group",
    directoryTableTitle: "Directory",
    tarjetero: "Card holder",
    directAccess: "Direct access",
    messageFrom: "Message from",
    read: "Read",
    markAsRead: "Mark as read",
    markAsUnread: "Mark as unread",
    selectQuery: "Select query",
    annotations: "Annotations",
    annex: "Digital folder",
    confirmDelete: "Do you want to delete the template?",
    confirmUpdate: "Do you want to update the template?",
    save: "Save",
    statistics: "Statistics",
    template: "Template name",
    templateNotEmptyWarning:
        'You can only set filters on the query in its original state in this grid. Select the "Reset" option to display the query in its original state',
    createTemplate: "Create template",
    deleteTemplate: "Delete template",
    exportTemplate: "Export template",
    updateTemplate: "Update template",
    exportQuery: "Export query",
    importQuery: "Import query",
    importTemplate: "Import template",
    selectTemplate: "Select template / Reset",
    templateExclusiveToMe: "Exclusive to me",
    templateAllCollaborators: "All collaborators",
    templateAllManagers: "All managers",
    templateAllEmployers: "All employers",
    templateOnlyEmployersPlantPersonnel: "Only plant employers",
    templateOnlyProvidersEmployers: "Only provider employers",
    templateCreate: "Template created successfully",
    templateImport: "Template imported successfully",
    templateUpdate: "Template updated successfully",
    templateDelete: "Template deleted successfully",
    pollReview: "Survey analysis",
    question: "Question",
    defaultQuestion: "Default questions",
    editQuestion: "Modify question",
    deleteQuestion: "Delete question",
    addQuestion: "Add question",
    visualizationRol: "Visualization role",
    delete: "Delete",
    confirmDeletAlert: "Do you want to delete the alert or notification?",
    shrink: "Collapse all",
    expand: "Expand all",
    answerPollNotice: "You must answer the question to continue",
    myAssistenceTitle: "My attendance",
    everyPollAnswer: 'All answers of "{answer}"',
    countVoters: "Number of voters",
    cant: "Quantity",
    questions: "Questions",
    noPollReviewData: "No survey data has been recorded yet.",
    hour: "Hour",
    assistancePlace: "Attendance place",
    date: "Date",
    votos: "Votes",
    noAlertsOrNotification: "There are no alerts or notifications.",
    noUnreadAlertsOrNotification: "There are no unread alerts or notifications.",
    info: "Information",
    clickHereForDetailedAnswers: "Click here to read the answers",
    respuestaParentesis: " answer)",
    respuestasParentesis: " answers)",
    answer: "Answer",
    responsible: "Responsible",
    noKPIdata: "No KPIs available at the moment.",
    aboutUs: "About ICARIUS",
    inDate: "Entry date",
    inHour: "Entry hour",
    outOfZoneIN: "Out of zone (ENTRY)",
    outDate: "Exit date",
    outHour: "Exit hour",
    outOfZoneOUT: "Out of zone (EXIT)",
    generate: "Generate",
    total: "Total",
    permissions: "Permissions",
    loansDetailEmployer: "loansDetailEmployer",
    loansDetailCollaborator: "loansDetailCollaborator",
    numberLoansGranted: "Number of loans granted",
    totalValueLoansGranted: "Total value of loans granted",
    totalPaid: "Total paid",
    totalPendingBalance: "Total pending balance",
    totalInstallments: "Total installments",
    totalPaidInstallments: "Total paid installments",
    totalPendingInstallments: "Total pending installments",
    referenceCode: "Reference code",
    referenceInstallment: "Reference installment",
    installmentValue: "Installment value",
    periodDiscount: "Discount period",
    installmentState: "Installment state",
    installmentNumber: "Installment number",
    grantedValueLoan: "Granted loan value",
    noLoansToShow:
        "The current grid format does not allow graphing. To do so, leave the grid in its initial display format.",
    value: "Value",
    vacationRequestTitle: "Vacation",
    permissionRequestTitle: "Permissions",
    loanRequestTitle: "Advances",
    expenseRequestTitle: "Expense reimbursement",
    permissionType: "Permission type",
    vacationsType: "Vacation type",
    holidays: "Holidays",
    expenses: "Expenses",
    advance: "Advance",
    permission: "Permissions",
    raise: "Salary increase",
    firing: "Dismissal",
    requestRequested: "Requested",
    requestCancelled: "Cancelled",
    requestChangedProposed: "Change proposal",
    requestChangeAccepted: "Change accepted",
    requestChangeRejected: "Change rejected",
    requestApproved: "Approved",
    requestRejected: "Rejected",
    loanType: "Advance type",
    loanType2: "Loan type",
    startDate: "Start date",
    newDelegation: "Create delegation",
    startDateValidation: "The date must be after the current day",
    delegationEndDateValidation: "The date must be after the start date",
    editStartDateValidation: "The date must be after the original date",
    addressee: "Recipient",
    endDate: "End date",
    amountOfDays: "Number of days",
    timePerDay: "Time per day",
    detail: "Detail",
    loanDetail: "Loan detail",
    amountLoanRequested: "Requested advance amount",
    amountLoanRequestedValidation: "The value must be greater than 0 and less than",
    expectedDateOfPay: "Expected collection date",
    fieldRequired: "Required field",
    expenseDeleteConfirmation: "Do you want to delete the expense?",
    newExpenseItem: "New expense",
    noExpenses: "You have not created any expenses yet.",
    expenseAmount: "Expense value",
    requestsInHistory: "Historical",
    requestsInProgress: "In progress",
    requestHistory: "Request history",
    cantCreateNewRequest: "You cannot create a new request of this type because there is already one in progress",
    legalVacation: "Legal vacation",
    additionalVacation: "Additional vacation",
    fullDay: "Full day",
    halfDay: "Half day",
    cancelRequest: "Cancel",
    answerPropose: "Respond to proposal",
    approveRequest: "Approve",
    rejectRequest: "Reject",
    editRequest: "Edit",
    optionalField: "Optional",
    maxCharRequests: "Max. allowed: 1024",
    howToSelectMoreDays:
        "If you want to enter more days than requested, reject the request and indicate the number of days you propose in the Details field.",
    requestEditTitle: "Change Proposal for the Request of",
    requestCreateTitle: "Request of",
    requestBy: "Responsible for the last status",
    sendMessage: "Send message",
    youNeedAtLeastOneRow: "You must select at least one record.",
    requestMailConfirm:
        "Do you want to send a warning message to the selected persons for prompt attention to the requests?",
    mailsHaveBeenSent: "The message was successfully sent",
    docsHaveBeenDeleted: "{numberOfDocuments} pending approval documents were successfully deleted",
    delegatorName: "Name of the delegator",
    delegatorCode: "Delegator's code",
    delegatorEmail: "Delegator's email",
    delegatedName: "Recipient's name",
    delegatedCode: "Recipient's code",
    delegatedEmail: "Recipient's email",
    delegationDateFrom: "Start date",
    delegationDateTo: "End date",
    delegationSent: "Delegation sent",
    delegationReceived: "Delegation received",
    delegation: "Delegation",
    delegationsTitle: "Delegate requests",
    noDelegationsRows: "You have no sent or received delegations.",
    confirmDeleteDelegation: "Do you want to delete the delegation?",
    proposeChange: "Propose change",
    answerChangeTitle: "Do you approve the proposed change?",
    acceptRequest: "Do you approve the request?",
    cancelRequestTitle: "Do you want to cancel the request?",
    insertComment: "Enter a comment",
    delegationAlready: "There is already a delegation for that user on that date",
    matches: "Matches",
    datesCollide: "The selected date range overlaps with previous requests",
    days: "days",
    reply: "Reply",
    goBack: "Go back",
    errorExecutingQuery: "Error executing user query",
    noQueryGroups: "No query groups are available at the moment",
    invalidData: "There is invalid or incomplete data",
    validData: "All data is valid",
    moreOrEqualThan: "Greater or equal",
    lessOrEqualThan: "Less or equal",
    notContains: "Does not contain",
    contains: "Contains",
    notEqual: "Not equal",
    equal: "Equal",
    year: "Year",
    month: "Month",
    localidad: "Location",
    gridVideo: "Grids – Part {part}",
    pinChangedLogoutRequest:
        "The PIN has been successfully changed. If you have access to more than one company for the same client, note that the new assigned PIN will be used for all companies from now on. To continue using ICARIUS, please log in again.",
    parameters: "Parameters",
    changeSociety: "Change company",
    orderByUnread: "Sort by unread",
    visualizationGrid: "Visualization grid",
    viewMoreData: "View data protection",
    reverseOrder: "Reverse order",
    viewAll: "View all",
    viewArchived: "View archives",
    tagName: "Tag name",
    tagTitle: "Tags",
    createTag: "New tag",
    editTags: "Edit tags",
    orderByNotes: "Sort by",
    ascOrder: "Ascending",
    desOrder: "Descending",
    archived: "Archived",
    createNote: "New task",
    labelCorrectlyDeleted: "Tag successfully deleted",
    labelCorrectlyModified: "Tag successfully modified",
    labelCorrectlyCreated: "Tag successfully created",
    title: "Title",
    writeHereYourNote: "Write your task here",
    lastEdited: "Last edited",
    archive: "Archive",
    unarchive: "Unarchive",
    changeLabels: "Edit tags",
    addChecklist: "Add task",
    addImage: "Add image",
    addReminder: "Add reminder",
    deleteNote: "Delete task",
    cancel: "Cancel",
    clear: "Clear",
    today: "Today",
    ok: "OK",
    addItem: "Add item",
    addLabel: "Add tag",
    confirmDeleteNote: "Do you want to delete the task?",
    totemManagementTitle: "Totem management",
    noTotems: "No totems available",
    home: "Home",
    myNotes: "My tasks",
    showAllTags: "All",
    noteInUseGoalsAndObjectives:
        "It is not possible to eliminate the task because it is in use in the goals and objectives of the collaborators",
    noteInUseEvaluation: "Cannot be eliminated because the associated feedback is related to performance evaluation",
    taskLinkedToFeedback: "This task is linked to feedback",
    allPendingTasks: "All pending tasks",
    mustSelectItem: "You must select an item",
    myToDoSelectCollaborator: "Select a Collaborator to view their progress",
    noteAlreadyShared: "You are trying to share the note with users to whom the note has already been shared",
    typesOfSkillsIndicatorsDeletePrompt: "Do you want to delete the indicator?",
    notPossibleToVisualizeProgress:
        "It is not possible to visualize your progress, because you do not have any tasks assigned to you at the moment.",
    allTasks: "All tasks",
    orderByTasks: "Order by tasks",
    pendingTasks: "Pending tasks",
    myPendingTasks: "My pending tasks",
    orderByProgress: "Order by progress",
    noteMustSelectToShare: "You must select someone to send the note to",
    taskResponsibleName: "Last name and first name of person in charge",
    assignedTask: "Assigned task",
    notes: "Tasks",
    totemCorrectlyUpdated: "Totem successfully updated",
    totemCorrectlyDeleted: "Totem successfully deleted",
    totemCorrectlyAdded: "Totem successfully added",
    entrada: "Entrance",
    salida: "Exit",
    promptDeleteTotem: "Do you want to delete the totem?",
    totem: "Totem",
    assistanceTotem: "Assistance totem",
    newAssistanceTotem: "New totem",
    totemCode: "Code",
    totemID: "Totem ID",
    workplace: "Workplace",
    editTotem: "Edit totem",
    createTotem: "Create totem",
    newTotem: "New totem",
    totemAsociatedInThisDevice: "This totem is associated with this device",
    noTotemFound: "This attendance registration totem has been disabled.",
    registryOK: "{move} successfully registered.",
    invalidAssistanceCredentials: "You cannot register attendance with the Client, User, and PIN you have entered.",
    assistanceRegistryDisabled: "Attendance registration is disabled. Please contact an administrator.",
    assistanceLicenceExpired: "The ICARIUS license has expired. Please contact an administrator.",
    cantRegisterAssistance: "You are not authorized to register attendance.",
    cantRegisterAssistanceVacation: "You cannot register attendance today because you are on vacation/leave/permit.",
    registerBlocked: "Attendance registration has been blocked. Please contact Human Resources.",
    registerMarkedInasistance: "You cannot register attendance because absences have already been recorded for today.",
    vacationsTitle: "Vacation balance account",
    myVacationsTitle: "Vacation balance account",
    vacationsTitleLong: "Vacation current account balance",
    viewVacationAccountability: "View balances",
    totalAvailableBalance: "Total available balance for request",
    totalPlusUnusedAvailableBalance:
        "Total available balance in case of termination (as of the date of the current account update)",
    additionalBalance: "Additional balance",
    legalOthersBalance: "Legal and other balances",
    totalDebitUsedDays: "Total debits (days used)",
    totalCredit: "Total credits (days earned)",
    totalAdditionalDays: "Total additional days",
    usedAdditionalDays: "Additional days used",
    totalOtherDays: "Total other days",
    usedLegalDays: "Legal and other days used",
    totalOtherLegalDays: "Total legal days",
    usedTotalDays: "Total used or reserved days",
    availableLegalDays: "Available legal and other days",
    availableAdditionalDays: "Available additional days",
    legalDays: "Legal",
    additionalDays: "Additional",
    otherDays: "Other",
    debits: "Debits",
    description: "Description",
    pendingDays: "Pending days",
    movement: "Movement",
    dailyQuantity: "Daily quantity",
    daysQuantity: "Days quantity",
    availableTotalDays: "Total available days",
    debitAvailableTotalIfFired: "Total available balance (if terminated)",
    debitAvailableTotalToRequest: "Total available balance to request",
    debitAvailableAditional: "Balance (additional or progressive)",
    digitalSignature: "Digital signature",
    DigitalSignatureTitle: "Signers",
    newSigner: "New signer",
    promptDeleteSigner: "Do you want to delete the signer?",
    authorizedDocuments: "Authorized documents",
    dateFrom: "Date from",
    hourFrom: "Hour from",
    dateEnd: "Date to",
    hourEnd: "Hour to",
    activeSigner: "Active signer",
    inactiveSigner: "Inactive signer",
    editSigner: "Edit signer",
    noSigners: "No signers registered",
    signer: "Signer",
    active: "Active",
    inactive: "Inactive",
    signerCorrectlyDeleted: "Signer successfully deleted",
    signerCorrectlyAdded: "Signer successfully created",
    signerCorrectlyUpdated: "Signer successfully updated",
    edit: "Edit",
    autoGeneratedBySign: "Auto-generated by Digital Signature - Signer: {signer}",
    autoGeneratedBySystem: "Auto-generated by the system",
    requestsColabInstructivo: "Employee requests",
    ctaCteVacacionesInstructivo: "Instruction for Vacation Account",
    confirmDeleteAllReadAlerts: "Do you confirm you want to delete all read alerts and notices?",
    deleteAllReadAlerts: "Delete all read alerts",
    nameSurnameLegalSigner: "Legal signer",
    captionLegalName: "If the legal signer is different from the selected one, enter their full name",
    expectedDateOfDisengagement: "Expected date of disengagement",
    disengagementOperativeType: "Reason for registering in the employee's notes",
    disengagementLegalType: "Legal disengagement type",
    detailDisengagement: "Detail the reason for the disengagement request",
    mailRequestedDocuments:
        "Do you want to send a message to the appropriate recipients for the prompt attention to the pending approval documents?",
    noDocumentsForMail: "No pending approval documents found",
    requestDocuments: "Request documents",
    requestDocumentsTitle: "Request document with a digital signature",
    request: "Request",
    noDocumentsRequest: "No digitally signed documents are currently available",
    selectDocument: "Select document",
    documentRequestDuplicated: "A request for this type of document is already in progress",
    documentRequestOK: "Request sent",
    requestedDocumentsTitle: "Requested documents",
    requestDate: "Request date",
    requestHour: "Request hour",
    typeRequestedDoc: "Requested document type",
    codeRequestedDoc: "Requested document code",
    sign: "Sign",
    confirmPin: "Confirm PIN",
    download: "Download",
    signDate: "Signature date",
    signTime: "Signature time",
    signDocType: "Document type",
    signDocCod: "Document code",
    signDocName: "Document name",
    signRef: "Reference",
    signerCode: "Signer code",
    signerFullName: "Signer full name",
    signerCodeTo: "Recipient code",
    signerToFullName: "Recipient full name",
    succesfullySignedDocs: "{cant} documents have been digitally signed",
    requestReceptor: "Request receiver",
    disengagementRequestedFor: "Disengagement requested for",
    reasonToRegisterInDigitalFolder: "Reason to register in the employee's notes",
    disengagement: "Disengagement",
    payRise: "Pay rise",
    disengagementTitle: "Disengagement",
    payRiseTitle: "Pay rise",
    payRiseRequestedFor: "Pay rise requested for",
    myReceiptsConfirmDocNotExist:
        "The digitally signed document is not yet available. Would you like to download it without a digital signature anyway?",
    previewDocuments: "Preview",
    previewDocumentsTooltip: "Preview before signing",
    signTooltip: "Sign previewed documents",
    confirmAcceptRequestedDocuments: "Do you confirm the digital signing of the selected documents?",
    confirmDeleteRequestedDocuments: "Do you confirm the deletion of the selected documents?",
    reason: "Reason",
    legalReason: "Legal reason",
    expectedDate: "Expected date",
    newProposedSalary: "Proposed salary value",
    requestedBy: "Requested by",
    derivate: "Derive",
    derivationSuccessfull: "The request has been successfully derived",
    derivateRequestTitle: "Request Derivation",
    firingLegalType: "Legal disengagement type",
    multipleSeverances:
        "The disengagement data has been recorded in the Employee Master. However, multiple FINIQUITO types have been found as NOMINA, and the employee has been ENABLED in all found types. To review this, access the function: Employee Master – Additional Data – Button: Payroll",
    frequency: "Frequency",
    actualSalary: "Current salary",
    salaryCoin: "Salary currency",
    payRiseExpectedDate: "Expected pay rise date",
    newSalaryValue: "The new salary value",
    signedDocumentsMailErrorTitle: "The following emails could not be sent",
    signedDocumentsDeleteErrorTitle: "The following documents could not be deleted",
    signedDocumentsDocumento: "Document",
    signedDocumentsDestinatario: "Recipient",
    signedDocumentsMotivo: "Reason",
    signedDocumentsNotRequired: "Approval not required",
    signedDocumentsInvalidDocument: "Invalid document",
    errorAwaitingColaboratorConfirmationDeleteDocs:
        "This document cannot be deleted because it belongs to a request that has already been approved, and the Collaborator's confirmation is pending.",
    settingDocuments: "Preparing documents",
    labelRowsPerPage: "Alerts per page",
    nextPage: "Next page",
    previousPage: "Previous page",
    moreThan: "More than",
    deletedDocumentsMotivo: "Reason",
    confirmDeleteDocument: "Confirm document deletion",
    invalidDataDeleteDocs: "The sent recipient is not found as an approver for the document code.",
    invalidStatusDeleteDocs: "The document is not pending signature",
    invalidSignerDeleteDocs: "Invalid signer",
    generateAndDownloadNoSign: "Generate and download",
    generateAndDownloadWithSign: "Generate and download with a digital signature",
    youCanOnlyDeleteDocumentsWithPendingApproval: "Only documents pending approval can be deleted.",
    qrExampleDigitalSignCertificatesReceipt:
        "Example of your digital signature that will be inserted into the document - Acceptance or Rejection",
    socketDisconnect: "An unexpected error has occurred. You will now be redirected to the platform login.",
    youNeedAtLeastOneRowAprovalPending: "You must select at least one record. The status can only be PENDING APPROVAL.",
    requestCreatedOK: "Request successfully created",
    requestDeletedOK: "Request successfully canceled",
    requestChangeSentSnack: "Change proposal sent successfully",
    requestChangeAcceptedSnack: "Change proposal acceptance sent successfully",
    requestChangeRejectedSnack: "Change proposal rejection sent successfully",
    requestAccetedSnack: "The request was successfully approved",
    requestRejectedSnack: "The request was rejected successfully",
    newSalaryMustBeGreaterThanPreviousSalary: "The proposed salary must be higher than the employee's current salary.",
    signUnauthDocuments: "You are not authorized to sign the selected documents.",
    idFiscal: "Fiscal ID",
    companyName: "Company name",
    quantityDocsSigned: "Documents signed",
    dateTimeSign: "Signature date and time",
    idFiscalReceptor: "Recipient Fiscal ID",
    receiver: "Receiver",
    viewCompanies: "View companies",
    documentInspection: "Document inspection",
    registerAssistance: "Register assistance",
    yourLastAssistanceEntryIs: "Your last assistance record was on: ",
    lastAssistanceEntryOrigin: "The source of that record was:",
    lastAssistanceEntryOriginTotemICARIUS: "ICARIUS Totem",
    lastAssistanceEntryOriginWebICARIUS: "ICARIUS Web",
    lastAssistanceEntryOriginAppICARIUS: "ICARIUS Assistance App",
    lastAssistanceEntryOriginClock: "Third-party capture clock",
    lastAssistanceEntryOriginManualManager: "Manual entry by Manager",
    lastAssistanceEntryOriginManualEmployer: "Manual entry by Employer",
    exit: "EXIT",
    entrance: "ENTRANCE",
    fiscalizationLoginTitle: "Digital Document Fiscalization Login",
    fiscalizationIngresar: "Enter",
    fiscalizationCambiar: "Change",
    fiscalizationRecuperarPass: "Recover password",
    fiscalizationEnd: "End fiscalization",
    fiscalizationMailMsg: "You can access document fiscalization from the email sent to your mailbox",
    fiscalizationInvalidToken: "Invalid token. The scheduled access time has expired.",
    fiscalizationPassMail: "You can recover your password from the email sent to your mailbox",
    fiscalizationPassUpdated: "Pin updated",
    fiscalizationRecoveryCodeInvalid: "Invalid recovery code",
    fiscalizationPinReq: "Your PIN must be between 6 and 20 characters",
    collabData: "Collaborator data",
    viewButton: "View",
    noNotes: "No tasks found",
    headerSaluteWithName: "Hello {name}!",
    headerSaluteNoName: "Hello!",
    selectTypeOfDocument: "Select type of document",
    noSignable: "You are not enabled for digital signature",
    certificateDigitalFullTitle: "Payslips and Certificates - Digital Signature",
    receiptsDigitalFullTitle: "Payslips - Digital Signature",
    noDocumentsToGenerate: "No documents found to generate",
    sendNote: "Send",
    shareNote: "Share",
    commentAction: "Comment",
    writeHereYourComment: "Add a comment...",
    editCommentAction: "Save",
    attachments: "Attachments",
    attachFileToNote: "Add attachment",
    accept: "Accept",
    refuse: "Reject",
    newSharedNote: "New shared task",
    newSentNote: "New received task",
    numberOfComments: "{number} comments",
    numberOfCommentsSingular: "{number} comment",
    sharedWith: "Shared with",
    myGroupsTitle: "My Groups",
    newGroup: "New group",
    noGroups: "You do not belong to any group yet",
    groupMembers: "Members",
    groupCreateTitle: "Create a new group",
    groupEditTitle: "Edit group",
    groupName: "Group name",
    groupDescription: "Group description / function",
    groupAddMembers: "Add members",
    groupDeleteQuestion: "Are you sure you want to delete the group?",
    groupCheckValues: "Invalid data, please review your entries",
    groupSearchLabel: "Search collaborator",
    groupCurrentMembers: "Current members",
    groupLeave: "Leave group",
    groupValidationError: "Invalid data",
    groupInvalidGroup: "The selected group was not found",
    groupInvalidParticipants: "There was an error with the selected users. Please try again",
    groupUnauth: "You are not the group owner",
    groupAtLeastOneUser: "The group must have at least one member to create or modify",
    groupLeaveQuestion: "Are you sure you want to leave the group?",
    groupLeaveExplanation: "As the creator, leaving the group will delete it for everyone",
    groupMembersTitle: "Group members",
    groupImagesTitle: "Select image from gallery",
    groupSelectedMembers: "Selected members",
    groupsExplanation: "Groups will help you organize better",
    groupsNewGroup: "Create a new group",
    societyPeopleAndGroupsSearchLabel: "Search group or collaborator",
    viewComments: "View comments",
    viewCollaborators: "Shared with",
    unauth: "You are not authorized to perform this action",
    attachmentFailedOperation: "An error occurred while trying to delete the attachment",
    fileLimitExceeded: "The limit of 12 files per task has been exceeded",
    fileSizeExceeded: "The attachment exceeds 5 MB",
    imageSizeExceeded: "The image exceeds 5 MB",
    invalidFile: "Unsupported file",
    noFilesUploaded: "File upload error",
    invalidColaboratorsGroups: "Check the list of collaborators and/or groups",
    invalidColaborators: "Check the list of collaborators",
    invalidGroups: "Check the list of groups",
    validationError: "Invalid data",
    invalidParticipants: "There was an error with the selected users. Please try again",
    commentNotFound: "Comment not found",
    noteNotFound: "Task not found",
    assignResponsible: "Assign responsible",
    cantAssignResponsible: "Cannot assign responsible",
    changeResponsible: "Change responsible",
    cantChangeResponsible: "Cannot change responsible",
    notAssigned: "No responsible assigned",
    exportQueryOnly: "Export only query",
    exportQueryAndTemplates: "Export query and templates",
    queryImport: "Query successfully imported",
    subTasks: "Subtasks",
    noSubtasks: "No subtasks created",
    noSubtasksTooltip: "No subtasks defined",
    openSubtasks: "Open subtasks",
    noPendingTasks: "No pending tasks",
    myProgress: "My progress",
    tasks: "Progress",
    subtask: "Subtask",
    subtaskProgress: "Subtask progress",
    task: "Task",
    taskProgress: "Task progress",
    taskUpdateDate: "Update date",
    note: "Task",
    progressFilter: "Progress filter",
    progressFilterNoFilter: "No filter",
    progressFilterAbove40: "More than 40%",
    progressFilterAbove70: "More than 70%",
    progressFilterLessEqualThan40: "Less than or equal to 40%",
    subitemEndDateWarning:
        "The end date of each subtask cannot be earlier than its progress date or later than the parent task's end date",
    itemEndDateWarning:
        "The end date of each task cannot be earlier than its progress date, or earlier than the progress or end date of its subtasks",
    taskFinished: "Finished",
    taskEndsToday: "Deadline ends today",
    variableDaysRemaining: "{daysDifference} days remaining",
    taskDelayed: "Delayed",
    taskDelay: "Days delayed",
    taskInTime: "On time",
    taskDaysRemaining: "Days remaining",
    taskNoFilter: "No filter",
    noteInvalidDates: "There are tasks/subtasks with invalid dates",
    noteInvalidResponsible: "You are not authorized to modify some tasks/subtasks",
    deleteSubtaskConfirm: "Do you want to delete the subtask?",
    deleteTaskConfirm: "Do you want to delete the task?",
    notaSharedOk: "The task has been successfully shared",
    notaSentOk: "The task has been successfully sent",
    noteSendAction: "Send",
    noteShareAction: "Share",
    colaboratorsCanModify: "Collaborators can modify:",
    theirPic: "Their photo",
    theirSexCivilNationalityCell: "Their sex, marital status, nationality, and cell phone",
    theirBancAndAccount: "Their bank and account",
    theirAddress: "Their personal address",
    appCanMarkOutside: "Assistance app can mark outside the zone",
    webLogo: "Logo for the WEB platform",
    documentsLogo: "Logo for document templates",
    mailsLogo: "Logo for emails",
    useDigitalSign: "Use digital signature",
    acceptFiscalization: "Accept remote fiscalization",
    typeOfSignature: "Type of digital signature for the collaborator",
    accessGroupAdmin: "Group for admin access",
    rrhhEmail: "Generic HR email",
    latLongSociety: "Latitude/longitude of the society's working hours",
    footerRRHHMail: "HR email footer",
    contactoPhone: "Contact phone",
    contactMail: "Contact email",
    contactCell: "Contact cell phone",
    contactAddress: "Contact address",
    twitter: "Twitter",
    instagram: "Instagram",
    facebook: "Facebook",
    digitalSignDisclaimer: "Disclaimer for digital signature",
    latLongCities: "Latitude/longitude of city schedules",
    employerMasterOrderFields: "Order of fields for the Employee Master",
    digitalFolderSettingsTitle: "Digital folder definition",
    digitalFolderSettingsPageTitle:
        "Definition of the digital folder (mandatory documents) and documents that collaborators can upload",
    generics: "Generic mandatory",
    genericsUpdatedOK: "Documents updated successfully",
    byPosition: "Mandatory by position",
    documentsThatCanBeUploadedByCollaboratorsThemselves: "Documents that collaborators can upload",
    documentPosition: "Position",
    documentInstance: "Instance",
    documentMandatory: "Mandatory document",
    selectPosition: "Select position / Reset",
    documentDeletedOK: "Document successfully deleted",
    documentDeleteQuestion: "Are you sure you want to delete the document's mandatory status?",
    noDocumentsForPosition: "No documents found",
    createNewDocument: "Add by position",
    editDocument: "Edit by position",
    documentCreatedOK: "Document successfully created",
    documentUpdatedOK: "Document successfully updated",
    digitalFolderValidation: "All fields are required",
    documentSamePositionInstanceError: "The document type is already assigned for the same position and instance",
    taskControl: "TASK CONTROL",
    uploadImage: "Upload an image",
    externalDocuments: "External documents",
    externalDocumentsLong: "External documents for signing",
    documentRole: "Role",
    uploadExternalDocuments: "Upload documents",
    previewExternalDocuments: "Preview documents",
    signExternalDocuments: "Sign documents",
    deleteExternalDocuments: "Delete documents",
    confirmDeleteExternalDocuments: "Do you want to delete the documents?",
    confirmSignExternalDocumentsTitle: "Document signing confirmation",
    confirmSignExternalDocuments: "Do you confirm the digital signing of the selected documents?",
    selectExternalFiles: "Select files to upload",
    filesMustBePdf: "Files must have a .pdf extension",
    filesMustStartWithCode:
        "Files must start with the employee code or internal number followed by an underscore (e.g., 12345_file_name.pdf)",
    selectDocumentRole: "Select recipient role",
    externalDocumentTitle: "Enter document title",
    uploadButtonText: "Upload",
    documentUploadedOK: "Documents successfully uploaded",
    errorUploadFile: "There are files that do not belong to {role} in your department.",
    managers: "managers",
    employers: "employers",
    myDigitalDocuments: "My Digital Documents",
    digitalDocuments: "Digital Documents",
    noDigitalDocuments:
        "Through the Digital Documents feature, you will be able to sign and eventually download the documents requiring your digital signature. This includes documents you have requested the employer to digitally sign, as well as those the employer has signed and made available for your signature. Currently, there are no documents available in these categories.",
    digitalDocumentConfirmationTitle: "Do you accept the generated document?",
    rejectDocument: "Enter the reason why you disagree with the generated document",
    documentInvalidTemplate: "The template related to the document was not found",
    dateApprobation: "Approval Date",
    timeApprobation: "Approval Time",
    permissionTimeRange: "The valid time range is from {from} minutes to {max}:{maxMin} hours",
    permissionTimeNotGreater: "Daily time cannot exceed the originally requested daily time",
    fileMustBeImage: "The file must be an image (.jpg, .jpeg, .png, .bmp, or .gif)",
    activationDeactivation: "ICARIUS Activation and Deactivation",
    PG: "Enable ICARIUS for this entity",
    CLIENTE: "Client Code",
    STOP: "Service Stopped",
    STOPTIME: "Time to Resume Display",
    STOPMSG: "Message to Display",
    requests: "Requests",
    VACMAXCTACTE: "Request vacations only up to the balance",
    VACPLUSCTACTE: "Maximum additional vacation days to the balance",
    PORMAXANT: "Maximum percentage for advances",
    RECEP: "Recipients by position or groups",
    identificationAndSocietyData: "Identification and Entity Data",
    decimalFieldsDefinition: "DECIMAL DEFINITION FOR NUMERIC FIELDS",
    QTY_DEC_DOC: "Documents (Calculation basis and Value)",
    EMAILRRHH: "Generic HR Email",
    GO_LOCALTIME: "Society timezone latitude/longitude",
    GO_DTO_RRHH: "HR Department Email Footer",
    GO_TELEFONO: "Contact Phone",
    GO_EMAIL: "Contact Email",
    GO_CELULAR: "Contact Mobile",
    GO_ADDRESS: "Contact Address",
    GO_TWITTER: "X (Twitter)",
    GO_FACEBOOK: "Facebook",
    GO_INSTAGRAM: "Instagram",
    GO_LINKEDIN: "LinkedIn",
    JUSTIFY_QUALIFICATIONS: "Should the evaluator justify the minimum and maximum ratings?",
    SHOW_BEHAVIOR_SKILLS: "Display behavior of indicators in competencies",
    WEIGHT_DISTRIBUTION_FOR_NON_EXISTENT: "Weight distribution for non-existent evaluations",
    ALLOW_COMPLAINTS_CHANNEL: "Enable complaints submission",
    SHOW_RECOGNITION_POINTS_IN_ANALYTICS: "Show recognition points in performance analytics",
    SHOW_SALARY_DATA_IN_ANALYITICS: "Show salary data in performance analytics",
    START_HOLIDAYS_ON_NON_WORKING_DAY: "Can holidays start on a non-working day",
    ALLOW_HALF_DAY_HOLIDAYS: "Can request half-day vacations",
    digitalSign: "Digital Signature",
    goalsAndObjectives: "PERFORMANCE GOALS AND OBJECTIVES",
    COLMETASYOBJ: "Can the collaborator define goals and objectives",
    FIRMADIGITAL: "Use digital signature",
    FISCALIZACION: "Allow remote auditing",
    FIRMACOL: "Collaborator's digital signature type",
    DISCLAMER: "Disclaimer for digital signature",
    timezones: "Timezones",
    GO_CITYHOUR: "City timezone latitude/longitude",
    SOCIETYNAME: "Entity Name",
    TAXID: "Tax Identifier",
    QTY_DEC_AMOUNTS: "Amounts",
    QTY_DEC_PRICES: "Prices",
    QTY_DEC_RATES: "Rates",
    QTY_DEC_QUANTITIES: "Quantities",
    QTY_DEC_PERCENTAGES: "Percentages",
    logosAndCustomization: "Logos and Customization",
    lightWebsiteLogo: "Logo for light-themed web platform",
    darkWebsiteLogo: "Logo for dark-themed web platform",
    templateLogo: "Logo for document templates",
    emailLogo: "Logo for emails",
    permissionsGeneralParameters: "Permissions and Data Access",
    colaboratorPermissions: "Data the collaborator can modify",
    geographicStructureSettings: "Geographic Organization",
    GEO_DIVISION1: "Geographic Division 1",
    GEO_DIVISION2: "Geographic Division 2",
    GEO_DIVISION3: "Geographic Division 3",
    hideFieldsPeopleMasterGeneralParameters: "Hide:",
    peopleMasterGeneralParameters: "PEOPLE MASTER",
    SHOW_CONTRACT_DATA: "Show CONTRACT data",
    SHOW_SALARY: "Show REMUNERATION data",
    SHOW_ABSENT_COLABORATORS_GRID_TO_COLABORATORS: "Show absent collaborators grid to collaborators",
    SHOW_TIME_DATA: "Show TIME data",
    SHOW_SPECIAL_CLASSIFICATIONS: "Show SPECIAL CLASSIFICATIONS data",
    ASSUME_DATES: "Assume hiring date for other dates",
    SHOW_OFFICE_PHONE: "Office phone",
    SHOW_PERSONAL_PHONE: "Personal phone",
    SHOW_PASSPORT_DATA: "Passport number and expiration",
    SHOW_DOMICILIARY_DATA: "Residential data (except address)",
    SHOW_CONTRACT_CODE: "Contract code",
    SHOW_CONTRACT_MOTIVE: "Hiring reason",
    SHOW_SECTION: "Section",
    SHOW_PUBLICATION: "Publication center",
    SHOW_IS_RETIRED: "Retired",
    SHOW_WORKER_TYPE: "Worker type",
    SHOW_FAMILY_ALLOWANCE_DATA: "Family allowance bracket",
    SHOW_EXTREME_ZONE: "Extreme zone reduction and percentage",
    SHOW_ADDITIONAL_VACATIONS_DATA: "Additional vacation months, date, and days",
    SHOW_BUSSINESS_SALARY: "Business salary",
    SHOW_HARD_WORK: "Hard work",
    SHOW_IMPOSED_IN_ANOTHER_COUNTRY: "Imposed in another country and quoted value",
    SHOW_SCHEDULED_NOTICE: "Mark with scheduled notice",
    SHOW_DONOR_BLOOD_TYPE: "Blood type and donor",
    SHOW_DIVISION: "Business unit",
    colaboratorsWillBeAbleToModifiy: "Collaborators can modify",
    GO_UPDATEPHOTO: "Their photo",
    EDIT_SEX: "Their sex",
    EDIT_CIVILSTATUS: "Their marital status",
    EDIT_NATIONALITY: "Their nationality",
    EDIT_CELLPHONE: "Their cellphone",
    EDIT_LINKEDIN: "Their LinkedIn",
    EDIT_PERSONAL_EMAIL: "Their personal email",
    GO_UPDATEBANK: "Their bank and bank account",
    GO_UPDATEDIR: "Their personal address",
    ORDFIELDMAFU: "Employee Master field order",
    GRUPOEMP: "Group for administrator access",
    HISTORICAL_DATA_TRACEABILITY: "Historical data traceability",
    SOCIAL_FEED_PUBLICATIONS: "Social wall posts",
    ALERTS_AND_NOTICES: "Alerts and notices",
    PENDING_REMINDERS: "Pending actions",
    mobileApps: "Mobile Apps",
    historicalDataDuration: "Historical data validity",
    MARCAFUERAZONA: "APP Assistance can mark outside the zone",
    tooltipWebLogo: ".png min 200x200px",
    tooltipTemplateLogoLine1: "*.jpg with white background",
    tooltipTemplateLogoLine2: "max 300x200px",
    tooltipTemplateLogoLine3: "min 75x75px",
    tooltipEmailLogoLine1: "*.jpg with white background",
    tooltipEmailLogoLine2: "max 750x750px",
    fillClientGeneralSettings: "Verify the client code",
    fillStopMsgGeneralSettings: "Verify the message to display when the service is stopped",
    fillStopTimeGeneralSettings: "Verify the time to resume display when the service is stopped",
    fillHREmailGeneralSettings: "Verify the HR email for generic messages",
    fillHRDTOGeneralSettings: "Verify the footer for the HR department email",
    fillContactEmailGeneralSettings: "Verify the contact email",
    fillMaxPercentageAdvance: "Verify the maximum advance percentage",
    fillDisclaimerGeneralSettings: "Verify the disclaimer for digital signature",
    fillFirmaColGeneralSettings: "Verify the collaborator's signature type",
    dataSucessfullySaved: "Data has been successfully saved",
    pollSettings: "Survey Settings",
    newPoll: "New Survey",
    pollCreation: "Survey Creation",
    pollFrom: "From",
    pollTo: "To",
    pollType: "Type",
    pollRole: "Role Visibility",
    pollFamily: "Family",
    pollReference: "Reference",
    pollQuestion: "Question",
    pollQuestionType: "Question Type",
    pollQuestionOption: "Option",
    pollAddOption: "+ Add Option",
    pollName: "Survey Name",
    pollDescription: "Description",
    deletePollOption: "Delete Option",
    pollOption: "Option",
    confirmDeletePoll: "Do you want to delete the survey?",
    newPollQuestion: "New Question",
    pollDeletedOK: "Survey successfully deleted",
    pollCreatedOK: "Survey successfully created",
    pollModifiedOK: "Survey successfully edited",
    questionAtLeastTwoOption: "Must have at least 2 options",
    performanceCompetenciesDescription: "SPECIFIC PERFORMANCE COMPETENCIES AND JOB DESCRIPTIONS",
    SHOW_WEIGHT_SPECIFIC_SKILLS: "Show weighted scores for specific competencies",
    questionAtLeastThreeOption: "Must have at least 3 options",
    accordingToOnaPollRespondents: "According to the respondents who were able to participate in this ONA survey",
    pollFieldsRequiredAndOptions: "All fields are required, and questions with options must have more than one",
    pollDuplication: "Duplicate",
    pollDuplicationTitle: "Duplicate Survey",
    pollFieldsRequired: "All fields are required",
    pollDuplicationMessage: "Please enter the survey name and dates.",
    pollDuplicationMessage2: "These details will replace the originals.",
    pollDeleteDialogTitle: "Delete Survey",
    pollDeleteIsInUse: "The survey to be deleted {name} already contains votes. Do you want to delete it anyway?",
    pollDeleteQuestion: "Are you sure you want to delete the survey {name}?",
    typeOfScoreFieldsRequiredAndOptions: "All fields are required, and there must be at least one score",
    confirmDeleteTypeOfScore: "Do you want to delete the score type?",
    newTypeOfScoreQuestion: "New score",
    typeOfScoreDeletedOK: "Score type successfully deleted",
    typeOfScoreCreatedOK: "Score type successfully created",
    typeOfScoreModifiedOK: "Score type successfully edited",
    typeOfScoreFieldsRequired: "All fields are required",
    typeOfScoreDeleteDialogTitle: "Delete score type",
    typeOfScoreDeleteItem: "Are you sure you want to delete the score type {name}?",
    ratingScaleFieldsRequiredAndOptions: "All fields are required, and there must be at least one rating",
    confirmDeleteRatingScale: "Do you want to delete the rating scale?",
    newRatingScaleQuestion: "New rating",
    ratingScaleDeletedOK: "Rating scale successfully deleted",
    ratingScaleCreatedOK: "Rating scale successfully created",
    ratingScaleModifiedOK: "Rating scale successfully edited",
    ratingScaleFieldsRequired: "All fields are required",
    ratingScaleDeleteDialogTitle: "Delete rating scale",
    ratingScaleDeleteItem: "Are you sure you want to delete the rating scale {name}?",
    accessSettingsTitle: "Access and properties",
    manangersAndEmployers: "Managers and employers",
    newManager: "New manager",
    selectManager: "Select manager",
    filterByManager: "Filter by manager",
    managerActive: "Active",
    accessGroups: "Access groups",
    isEmployer: "HR staff (Employer)",
    noManagerFound: "No manager found",
    managersUpdatedOK: "Successfully updated",
    managersCreatedOK: "Successfully created",
    managerDeletedOK: "Successfully deleted",
    errorEmployeeInUseAlready: "There are already rows with the selected employee",
    errorTwoEmployersAlready: "There cannot be more than one Manager or Employer sharing the same email",
    viewAccessGroups: "View groups",
    currentGroups: "Current groups",
    groupsWarning: "If no group is selected, access will be granted to all groups",
    findGroupByName: "Search group by name",
    onlineUsers: "Online users",
    onlineCollab: "Collaborators",
    onlineManagers: "Managers",
    onlineEmployers: "Employers",
    noteGlobalProgress: "Global task progress",
    noteOwner: "Task owner",
    noteMailSent: "Email sent successfully",
    noteMailOwner: "You can only send messages to task owners of notes that you own",
    noteTaskGridData: "Task progress",
    noteOwner2: "Note owner",
    noteGlobalProgress2: "Global note progress",
    noteProgressCollaborator: "{user}'s global progress",
    noteMyGlobalProgress: "My global progress",
    note2: "Note",
    mailMyPeopleWillBeSent: "It will be sent to {amount} collaborator(s)",
    mailTextPlaceholder: "Write your message here",
    mailLinkPlaceholder: "Insert link",
    mailCoordPlaceholder: "Insert coordinates",
    mailUploadFile: "Upload attachment",
    mailLinkText: "Enable link",
    mailUndoLinkText: "Disable link",
    mailCoordText: "Enable coordinates",
    mailUndoCoordText: "Disable coordinates",
    mailSend: "Send",
    mailFieldInvalid: "Field cannot be empty",
    mailCoordInvalid: "Example of valid coordinates: -33.42560642629101, -70.6139463736171",
    mailInvalidFileType: "File cannot be .exe",
    mailInvalidFileSize: "File cannot exceed 5MB",
    mailFileAttached: "1 file attached",
    mailMyPeopleSent: "Emails successfully sent",
    annotationsAnalysisTitle: "Annotations analysis",
    annoText: "Annotation text",
    noDataToChart:
        "The current grid format does not allow charting. To do so, leave the grid in its initial display format.",
    sendingMail: "Sending email...",
    duplicate: "Duplicate",
    selectColabFire: "Select collaborator: Termination request",
    selectColabRise: "Select collaborator: Salary increase request",
    selectedColab: "Selected collaborator",
    historicalProcessesTitle: "Historical processes",
    currentProcessesTitle: "Current processes",
    processCode: "Process code",
    processDescription: "Description",
    processType: "Process type",
    processSubtype: "Subprocess type",
    processDateFrom: "Date from",
    processDateTo: "Date to",
    processPeriod: "Period",
    processPaymentDate: "Payment date",
    processStatus: "Status",
    processDateLast: "Last process date",
    processTimeLast: "Last process time",
    processNew: "Create process",
    processEdit: "Edit process",
    processCodeChar: "Spaces and the following special characters are not allowed: / \\ _ : * ? “ | < > = +",
    tableDeleteConfirm: "Are you sure you want to delete the table {table}?",
    tableDeleteSecondConfirm:
        "If you delete the table {table}, all information contained in it will be lost. Are you sure you want to delete it?",
    fieldDeleteConfirm: "Are you sure you want to delete the field {field}?",
    fieldDeleteSecondConfirm:
        "If you delete the field {field}, all data contained in it will be lost. Are you sure you want to delete it?",
    deleteTable: "Delete table",
    processCodeUse: "Code cannot be in use",
    tableCreatedOK: "Table successfully created",
    tableEditedOK: "Table successfully edited",
    tableDeletedOK: "Table successfully deleted",
    processGridLabel: "Select the collaborators to be processed.",
    processCreatedOK: "Calculation process successfully created",
    processEditedOK: "Calculation process successfully edited",
    processModifyConfirm:
        "If you have modified the process data or changed the selection of collaborators participating in this process, remember that you need to recalculate. Do you wish to continue?",
    processNoExist: "The calculation process to be modified does not exist",
    processDeletedOK: "Calculation processes successfully deleted",
    processDeleteConfirm: "Are you sure you want to delete the calculation processes?",
    processCalculate: "Calculate",
    calcProcessTraceability: "Calculation process traceability",
    processExecutePartialConfirm:
        "Are you sure you want to execute a PARTIAL calculation process for {amount} collaborators?",
    processExecuteTotalConfirm:
        "Are you sure you want to execute a TOTAL calculation process for {amount} collaborators?",
    youNeedOneRow: "You must select a single process",
    digitalFolderAnalysisTitle: "Digital folder analysis",
    digitalFolderNotAvailable: "Missing files",
    digitalFolderAvailable: "Existing files",
    digitalFolderSelectInstance: "Select instance",
    digitalFolderEveryInstance: "All instances",
    digitalFolderInstanceReq: "You must select Entry, Exit, or Life cycle",
    digitalFolderFechadecarga: "Upload date",
    digitalFolderHoradecarga: "Upload time",
    digitalFolderInstancia: "Instance",
    digitalFolderTipodedocumentooarchivo: "Type of document or file",
    digitalFolderTipodedocumentooarchivoFaltante: "Missing type of document or file",
    digitalFolderTextodescriptivo: "Descriptive text",
    digitalFolderNombredelarchivo: "File name",
    digitalFolderFechadevencimiento: "Expiration date",
    digitalFolderResponsabledelacarga: "Upload responsible",
    digitalFolderSituacion: "Situation",
    accessByGroups: "Access by groups",
    tasksAndTelecommuting: "Tasks and teleworking",
    employeesProcessesTitle: "Processed collaborators",
    employeesProcessDeleteConfirm:
        "Are you sure you want to delete the selected collaborators from the calculation process?",
    employeesProcessDeletedOK: "Collaborators successfully removed from the calculation process",
    employeesProcessResult: "Result",
    employeesProcessOthers: "Others",
    employeesProcessDetail: "Detail",
    employeesProcessReferences: "References",
    employeesProcessDialogTitle: "Query",
    employeesProcessName: "Name",
    employeesProcessAmount: "Amount",
    employeesProcessBaseCalculo: "Calculation base",
    employeesProcessHaberesAportes: "Earnings with contributions",
    employeesProcessDescuentosLegales: "Legal discounts",
    employeesProcessHaberesSinAporte: "Earnings without contributions",
    employeesProcessDescuentosVarios: "Various discounts",
    employeesProcessConcepto: "Concept",
    employeesProcessCodigoConcepto: "Concept code",
    employeesProcessNombreConcepto: "Concept name",
    employeesProcessPorcentaje: "Percentage",
    employeesProcessValor: "Value",
    employeesProcessFecha: "Date",
    employeesProcessValueType: "Value type",
    employeesProcessAnnexComment: "Annex comment",
    employeesProcessPeriodoImputacion: "Allocation period",
    employeesProcessCentroBeneficio: "Cost center",
    employeesProcessProyecto: "Project",
    employeesProcessDimension2: "Dimension 2",
    employeesProcessDimension3: "Dimension 3",
    employeesProcessDimension4: "Dimension 4",
    employeesProcessDimension5: "Dimension 5",
    employeesProcessCodigoReferencia: "Reference code",
    employeesProcessReferencia1: "Reference 1",
    employeesProcessReferencia2: "Reference 2",
    employeesProcessCantidadConvertida: "Converted amount",
    employeesProcessPeriodoReliquidacion: "Recalculation period",
    employeesProcessMesesReliquidar: "Months to recalculate",
    employeesProcessEntidad: "Entity",
    employeesProcessTipoComprobante: "Voucher type",
    employeesProcessSerieComprobante: "Voucher series",
    employeesProcessNumeroComprobante: "Voucher number",
    employeesProcessOrigen: "Origin",
    employeesProcessValorNumerico: "Numeric value",
    employeesProcessValorAlfanumerico: "Alphanumeric value",
    employeesProcessValorFecha: "Date value",
    employeesProcessComentarios: "Comments",
    employeesProcessTipoValor: "Value type",
    employeesProcessCodigoAccion: "Action code",
    employeesProcessObjetoAccion: "Action object",
    employeesProcessFechaAccion: "Action date",
    employeesProcessAccionesSQL: "SQL actions",
    employeesProcessTotal: "Net/Liquid",
    geoanalysisTitle: "Geoanalysis",
    noGeoanalysisGroups: "There are currently no geoanalysis query groups available",
    openMap: "Open map",
    closeMap: "Close map",
    exportAsExcel: "Export for My Maps",
    accessosSegmentadoPorGrupos: "Access segmented by groups",
    selectColumn: "Select column",
    deleteManagerQuestion: "Are you sure you want to remove the Manager from the list?",
    deleteEmployerQuestion: "Are you sure you want to remove the Employer from the list?",
    publicationSettings: "Homepage publications",
    newPublication: "New publication",
    publicationName: "Publication name",
    publicationFrom: "From",
    publicationTo: "To",
    publicationRole: "Viewing role",
    publicationText: "Text",
    publicationLink: "Link",
    publicationDownload: "Download",
    publicationType: "Type",
    publicationNumber: "Number",
    publicationImage: "Image",
    confirmDeletePublication: "Do you want to delete the publication?",
    publicationDeleteDialogTitle: "Delete publication",
    publicationCreation: "Publication creation",
    publicationDeletedOK: "Publication successfully deleted",
    publicationCreatedOK: "Publication successfully created",
    publicationModifiedOK: "Publication successfully edited",
    publicationExplanation: "Publications will help keep your organization informed",
    noPublications: "No publications created yet",
    publicationNewsModal: "Featured news",
    validationURLPreview: "The provided URL does not have a preview image. Please upload an image.",
    publicationInvalidFileType: "Invalid file type",
    publicationFileTypeExplanation:
        "It must be one of the following types: jpg, bmp, png, jpeg, rar, zip, gz, tar, xls, xlsx, txt, rtf, doc, docx, pdf, html",
    downloadAttachment: "Download attachment",
    answerPoll: "Answer poll",
    generatePublications: "Generate publications",
    filterbranches: "Branches",
    filtercategory: "Categories",
    filtercontractType: "Contract types",
    filterfunction: "Functions",
    filterfunctionType: "Function types",
    filtergender: "Gender",
    filtermanagement: "Management",
    filtermaritalStatus: "Marital status",
    filterpositions: "Positions",
    filterretiredPersonal: "Retirees",
    filtershifts: "Shifts",
    filterspecialty: "Specialties",
    filterunion: "Unions",
    filterworkplaces: "Workplaces",
    filtermanagementCenters: "Publication centers",
    filtersOK: "Filters successfully updated",
    orgChart: "Organizational chart",
    positionEditor: "Position structure",
    cargosMenu: "Positions",
    centersSettings: "Cost centers and publication centers",
    newCenter: "New cost and publication center",
    centerCode: "Code",
    centerName: "Name",
    cantDeleteCenter: "Cannot delete the publication center because it is in use",
    deleteCenterQuestion: "Are you sure you want to delete the publication center from the list?",
    noCentersFound: "No publication centers found",
    centerCodePlaceholder: "Enter code",
    centerNamePlaceholder: "Enter name",
    centerDuplicatedData: "There cannot be more than one publication center sharing the same code or name",
    centersUpdatedOK: "Update successfully completed",
    centersCreatedOK: "Creation successfully completed",
    centerDeletedOK: "Deletion successfully completed",
    permissionsSettings: "Permissions for requests",
    newPermission: "New permission",
    permissionName: "Permission name",
    permissionCode: "Permission code",
    confirmDeletePermission: "Do you want to delete the permission?",
    permissionDeleteDialogTitle: "Delete permission",
    permissionCreation: "Permission creation",
    permissionDeletedOK: "Permission successfully deleted",
    permissionCreatedOK: "Permission successfully created",
    permissionModifiedOK: "Permission successfully edited",
    noPermissions: "No permissions created yet",
    permissionDuplicatedData: "There cannot be more than one permission sharing the same code or name",
    positionEditorId: "ID",
    positionEditorPositionName: "Position name",
    positionEditorPositionQuantity: "Number of positions",
    positionEditorOccupiedPositions: "Occupied positions",
    positionEditorFreePositions: "Free positions",
    positionEditorResponsabilityDegree: "Degree of responsibility",
    positionEditorSuperior: "Superior position",
    positionEditorAssistant: "Assistant",
    familySettings: "Family definitions",
    newFamily: "New family type",
    familyCode: "Code",
    familyName: "Name",
    cantDeleteFamily: "Cannot delete the family type because it is in use",
    deleteFamilyQuestion: "Are you sure you want to delete the family type from the list?",
    noFamilyFound: "No family definitions found",
    familyCodePlaceholder: "Enter code",
    familyNamePlaceholder: "Enter name",
    familyDuplicatedData: "There cannot be more than one family type sharing the same code or name",
    familyUpdatedOK: "Update successfully completed",
    familyCreatedOK: "Creation successfully completed",
    familyDeletedOK: "Deletion successfully completed",
    functionsSettings: "Function definitions",
    newFunction: "New function",
    deleteFunctionQuestion: "Are you sure you want to delete the function from the list?",
    noFunctionsFound: "No functions found",
    functionCode: "Code",
    functionCodePlaceholder: "Enter code",
    functionName: "Name",
    functionNamePlaceholder: "Enter name",
    functionsUpdatedOK: "Update successfully completed",
    functionsCreatedOK: "Creation successfully completed",
    functionsDeletedOK: "Deletion successfully completed",
    functionsDuplicatedData: "There cannot be more than one function sharing the same code or name",
    cantDeleteFunction: "Cannot delete the function because it is in use",
    advancesSettings: "Advances for requests",
    newAdvance: "New advance",
    noAdvances: "No advances created yet",
    advanceCreation: "Advance creation",
    advanceName: "Advance name",
    advanceType: "Advance type",
    advanceCode: "Advance code",
    advanceDeleteDialogTitle: "Delete advance",
    confirmDeleteAdvance: "Do you want to delete the advance?",
    advanceDeletedOK: "Advance successfully deleted",
    advanceCreatedOK: "Advance successfully created",
    advanceModifiedOK: "Advance successfully edited",
    advanceDuplicatedData: "There cannot be more than one advance sharing the same code or name",
    documentPublication: "Document publication",
    newDocumentPublication: "New document",
    documentReceipts: "Payslips",
    documentCertificates: "Certificates and vouchers",
    documentRequests: "Request documents",
    documentExternal: "External documents",
    documentAssistance: "Attendance reports",
    documentByRequest: "On-demand documents",
    documentsGenerated: "Auto-generated documents during digital folder download",
    documentPublicationName: "Document name",
    documentPublicationRole: "Viewing role",
    documentPublicationType: "Type",
    confirmDeleteDocumentPublication: "Do you want to delete the published document?",
    documentPublicationDeleteDialogTitle: "Delete publication",
    documentPublicationCreation: "Document publication",
    documentPublicationDeletedOK: "Publication successfully deleted",
    documentPublicationCreatedOK: "Publication successfully created",
    documentPublicationModifiedOK: "Publication successfully edited",
    noDocumentPublication: "No documents created yet",
    documentIncludedFolder: "Included in digital folder download",
    documentPublicationWorkflow: "Related to workflow",
    documentPublicationCode: "Related template",
    documentPublicationSign: "With digital signature",
    contractTypesSettings: "Contract Types",
    newContractType: "New Contract Type",
    noContractTypes: "No contract types found",
    contractTypeCode: "Contract Type Code",
    contractTypeName: "Contract Type Name",
    contractTypeCalification: "Qualification",
    contractTypeDeleteDialogTitle: "Delete Contract Type",
    confirmDeleteContractType: "Do you want to delete the contract type?",
    contractTypeCreation: "Contract Type Creation",
    contractTypeDuplicatedData: "There cannot be more than one contract type with the same code or name",
    contractTypeDeletedOK: "Contract type successfully deleted",
    contractTypeCreatedOK: "Contract type successfully created",
    contractTypeModifiedOK: "Contract type successfully modified",
    cantDeleteContractType: "Unable to delete the contract type because it is in use",
    conceptGroups: "Concept Groups",
    newConceptGroup: "New Group",
    conceptGroupNamePlaceholder: "Enter name",
    conceptGroupName: "Name",
    conceptGroupCode: "Number",
    noConceptGroupsFound: "No concept groups found",
    conceptsInUse: "The concept cannot be modified as it is in use",
    contractorCode: "Contractor Code",
    contractorName: "Contractor Name",
    contractorAddress: "Address",
    contractorContactName: "Contact Name",
    contractorContactMail: "Contact Email",
    contractorContactPhone: "Contact Phone",
    contractorType: "Type",
    contractorSettings: "Contractors",
    newContractor: "New Contractor",
    contractorDeleteDialogTitle: "Delete Contractor",
    confirmDeleteContractor: "Do you want to delete the contractor?",
    contractorCreation: "Contractor Creation",
    noContractors: "No contractors found",
    contractorDuplicatedData: "There cannot be more than one contractor with the same code or name",
    contractorDeletedOK: "Contractor successfully deleted",
    contractorCreatedOK: "Contractor successfully created",
    contractorModifiedOK: "Contractor successfully modified",
    cantDeleteContractor: "Unable to delete the contractor because it is in use",
    functionaryTypesSettings: "Functionary Types",
    newFunctionaryType: "New Functionary Type",
    noFunctionaryTypes: "No functionary types found",
    functionaryTypeCode: "Functionary Code",
    functionaryTypeName: "Functionary Name",
    functionaryTypeProcess: "Automatic Processes",
    functionaryTypeRequiresClient: "Requires Client/Supplier",
    functionaryTypePlant: "In-house Personnel",
    functionaryTypeNoPlant: "External or Subcontractors",
    functionaryTypeDeleteDialogTitle: "Delete Functionary Type",
    confirmDeleteFunctionaryType: "Do you want to delete the functionary type?",
    functionaryTypeCreation: "Functionary Type Creation",
    functionaryTypeDuplicatedData: "There cannot be more than one functionary type with the same code or name",
    functionaryTypeDeletedOK: "Functionary type successfully deleted",
    functionaryTypeCreatedOK: "Functionary type successfully created",
    functionaryTypeModifiedOK: "Functionary type successfully modified",
    cantDeleteFunctionaryType: "Unable to delete the functionary type because it is in use",
    locationSettings: "Workplace Definition",
    worksAndTasksSettings: "Works and Tasks Definition",
    divisionsSettings: "Business Units",
    conceptsAndFormulas: "Concepts and Formulas",
    conceptsFormulasFunctions: "Concepts, Formulas, and Functions",
    accumulatorSettings: "Accumulator Definition",
    organizationalDefinitions: "Organization Definition",
    allergiesExamsDiseases: "Medical Profile Definition",
    calculationReferences: "Calculation References",
    entryExitTypes: "Contract Types Definition",
    publications: "Publications",
    requestsSettings: "Requests Definition",
    thirdPartySettings: "Third-Party Definition",
    locationSettingsBox: "Location Definition",
    organizationStructure: "Departmental Structure",
    geographicalStructure: "Geographical Organization",
    issueTypesSettings: "Issue Definition",
    absenceTypes: "Absence Types",
    permissionTypes: "Permission Types",
    licenceTypes: "License Types",
    positionsClassification: "Position Classifications",
    managementDefinition: "Management Definition",
    alertsSettings: "Alerts/Notices Definition",
    conceptsSetSettingsTitle: "Concept Set",
    thirdPartyClassification: "Third-Party Classification",
    thirdParty: "Third Parties",
    thirdPartySingular: "Third party",
    laborUnions: "Unions",
    paymentTypes: "Payment Methods",
    documentTemplates: "Document Templates",
    assetsAndDiscountsScreenSelector: "Income and Deductions",
    assetsAndDiscountsCreation: "Income and Deductions Creation",
    digitalWarehouseFileTypes: "Digital Warehouse File Types",
    trainingData: "Training Definition",
    schooling: "Schooling Levels",
    studies: "Studies",
    specializations: "Specializations",
    languages: "Languages",
    benefitsSettingsBox: "Benefits",
    affiliationInstitutionDefinition: "Affiliation Institutions Definition",
    retirementDefinition: "Retirement",
    healthDefinition: "Health",
    ratingsAndGeneralValues: "Indices and General Values",
    familyAsignations: "Family Allowances",
    ratings: "Indices",
    taxTable: "Tax Table",
    processScheduling: "Current Process Scheduling",
    ICARIUS_NOT_AVAILABLE: "ICARIUS is not available at this time",
    employerAdministrator: "Employer Administrator",
    myDigitalWarehouse: "My digital warehouse",
    utilityDownloads: "Utility downloads",
    darkMode: "Dark mode",
    lightMode: "Light mode",
    shortcut: "Shortcut",
    absentCollaborators: "Absent collaborators",
    generateDocuments: "Generate documents",
    selectProcess: "You must select a process",
    process: "Process",
    noProcessOnline: "There is no default process defined to calculate",
    processSucessfullyInitialized: "Process successfully started",
    noProcessOnlineCalculate: "There is no default process defined to query",
    noProcessFound: "No processes found to execute",
    viewConsent: "View consent",
    viewAcceptConsent: "View and accept consent",
    acceptanceDate: "Acceptance date",
    consentText: "Consent text",
    removeFromFavorites: "Remove from favorites",
    addToFavorites: "Add to favorites",
    succesfullyModified: "Successfully modified",
    wrongFormatFiles: "There are files with invalid format",
    selectFiles: "Select file",
    validFormats: "Valid formats",
    countSelectedFiles: "Number of selected files",
    cantMoveToColumn: "You cannot move it to this column.",
    coordinates: "Coordinates",
    link: "Link",
    invalidURL: "It must be a valid URL.",
    accumulatedPoints: "Accumulated points",
    pointsRemaining: "You need",
    recognitionInProgress: "Recognition in progress",
    viewTimeline: "View timeline",
    medalTableConfirmationMessage: "Are you sure you want to {action} {points} points to {userName}?",
    medalTableConfirmationExceptionMessage: "You can only {action} between 1 and {maxPoints} points",
    deliverPoints: "Deliver points",
    medalTableActionTitle: "{action} of points",
    pointsAwarded: "Points awarded",
    pointsValueMedalTable: "{points} point(s) = Value {value}",
    discount: "Discount",
    assignment: "Assignment",
    discountAction: "deduct",
    assignPointsAction: "deliver",
    keepGettingPoints: "Keep earning points!",
    starCollaborator: "Star collaborator!",
    superstarCollaborator: "Superstar collaborator!",
    recognitionPlan: "Recognition plan",
    historicalLabel: "History",
    pointsAvailableForTrade: "Points available for redemption",
    won: "Earned",
    firstMedal: "Let's go for your first medal!",
    noDataFound: "No data found",
    fullHistory: "Full history",
    points: "{points} points",
    accumulatedPointsUntilToday: "Accumulated points to date",
    deliveryReason: "Reason for delivery",
    inactiveCollaboratorCantDeliverPoints:
        "The collaborator is inactive in the recognition plan and cannot receive points.",
    noPlanMatch: "The collaborator is not associated with the indicated plan",
    pointsDeliveredSuccefully: "Points successfully delivered",
    modificationMadeSuccesfullyMedalTable: "Adjustment successfully made",
    discountDate: "Discount date",
    namesAndLastnamesManagerEmployer: "Last names and first names (Managers/Employers)",
    canReceiveRequests: "Can receive requests?",
    icariusAdministrator: "ICARIUS Administrator",
    groupsWithAccess: "Groups with access",
    initialYear: "Start year",
    initialPeriod: "Start period",
    credit: "Credit",
    debit: "Debit",
    balanceAtTransaction: "Balance at transaction",
    transactionDate: "Transaction date",
    installment: "Installment",
    clasification: "Classification",
    availability: "Availability",
    accountingEntry: "Accounting entry",
    condition: "Condition",
    liquidReportedValue: "Reported net value",
    grossReportedValue: "Reported gross value",
    entryByImport: "Entry via Import",
    filterDepartamento: "Department",
    filterCargo: "Position",
    "filterObra o Faena": "Work or Task",
    filterGerencia: "Management",
    "filterLugar de trabajo": "Workplace",
    filterTurno: "Shift",
    filterHorario: "Schedule",
    filterColaborador: "Employee",
    filterAcumuladores: "Accumulators",
    "filterGrupos para conceptos": "Concept Groups",
    "filterConjunto de conceptos": "Concept Set",
    "filterEstructura de ingreso": "Entry Structure",
    digitalWarehouse: "Digital Warehouse",
    kpiDefinition: "KPI Definition",
    geoQuery: "Geoanalysis Queries",
    queryDefinition: "Query Definition",
    generalValues: "General Values",
    conceptStructure: "Concept Entry Structure",
    conceptsSet: "Concept Set",
    extraHoursAuthorization: "Extra Hours Authorization",
    holidayTable: "Vacation Table",
    extraHoursTable: "Extra Hours Types",
    festivitiesTable: "Holidays and Festive Days",
    groupClassification: "Group Classification",
    payrollTypesSettings: "Payroll Types",
    entryPerConcept: "Entry by Concept",
    entryPerSociety: "Entry by Society",
    assetsDiscountsSummary: "Income and Deductions Summary",
    attendanceReport: "Attendance Report",
    entryPerConceptSet: "Entry by Concept Set",
    entryTypes: "Entry Reasons",
    exitTypes: "Exit Reasons",
    allergiesSettings: "Allergies",
    examsSettings: "Exams",
    diseasesSettings: "Diseases",
    categoriesSettings: "Categories",
    specialtiesSettings: "Specialties",
    userAlertsSettings: "User Alerts and Notices",
    systemAlertsSettings: "System Alerts and Notices",
    massEntry: "Mass Entry",
    conceptsAndFormulasScreenSelector: "Concepts, Formulas, and Functions",
    calculationsFunctions: "Calculation Functions",
    CALC_ONLINE: "Enable Online Processes",
    SHOW_9BOXES_C: "Displays 9-Boxes classification to the employee",
    MANAGER_GESPER: "Enable managers direct management of permissions",
    ORGCHART: "Publish organizational chart",
    MANAGER_SEE_UNPUBLISHED_PROCESSES: "Managers can view unpublished calculation processes",
    SHOW_POINTS_TO_REDEEM: "Displays points for redemption in the medal table",
    MANAGER_GESVAC: "Enable managers direct management of vacations",
    specialProcessDefinition: "Definition of special processes",
    accountingImputations: "Accounting imputations",
    typesOfBenefits: "Types of benefits",
    typesOfScore: "Evaluation grades",
    ratingScales: "Rating scales",
    benefitsForPlans: "Benefits for plans",
    recognitionPlansAssignment: "Recognition assignment",
    organizationalBenefits: "Organizational benefits",
    dataCapture: "Data input via API",
    myDesktop: "My desktop",
    specialProcessExecution: "Execution of special processes",
    myPeopleSchedule: "Schedule management",
    mySchedule: "My scheduled hours",
    rebuildAccumulators: "Rebuild accumulators",
    turnDefinition: "Shift definitions",
    schedulesDefinition: "Schedule definitions",
    schedulesProgramming: "Schedule programming",
    historicAccumulators: "Historical accumulators",
    assetsDiscountsEntryByInstallments: "Installment entry",
    alertsTemplates: "WhatsApp templates",
    calendarDefinition: "Calendar definition",
    issueManagementScreenSelector: "Issue management",
    issueSummary: "Incidents summary",
    issueLicences: "Medical leave management",
    issuePermissions: "Permissions management",
    issueAbsences: "Absence management",
    issueVacations: "Vacation management",
    consentTypes: "Consent types",
    benefitsCenter: "Cost centers",
    projects: "Projects",
    consentPublication: "Consent publication",
    VACATIONS_ENABLED: "Enable vacation requests",
    PERMISSIONS_ENABLED: "Enable permission requests",
    LOANS_ENABLED: "Enable advance requests",
    historicalProcesses: "Historical processes",
    myApprovedConsents: "My approved consents",
    consentsScreenSelector: "Consents",
    documentsScreenSelector: "Documents",
    pollScreenSelector: "Surveys",
    PROCESS_USER: "User code for alert calculations",
    userTablesDefinition: "User table editors",
    extensibility: "Extensibility",
    catalogs: "Database catalog",
    ESQVAC: "Vacation calculation scheme",
    userTables: "User table editor",
    relatedTablesDefinition: "Related table definitions",
    extensibilityScreenSelector: "Modeling",
    systemTablesDefinition: "System table editors",
    systemTables: "System table editor",
    GT_ALERT2: "Working on an unscheduled day",
    GT_ALERT3: "Inconsistent time marks",
    GT_ALERT4: "Unauthorized overtime",
    GT_ALERT5: "Late entry",
    GT_ALERT6: "Absences",
    GT_ALERT7: "Early departure",
    GT_ALERT8: "Delay in break",
    GT_ALERT9: "Change in planned schedule",
    TRACE_DATA: "Enable data traceability",
    CONNECTED_USERS_ENABLED: "View online users",
    transactionLog: "Transaction log",
    assistanceAnalysis: "Attendance analysis",
    GT_PROC: "Special process to execute for attendance analysis",
    GT_HIGHLIGHT_YELLOW: "Minimum number of hours and minutes of additional attendance required to highlight in yellow",
    GT_HIGHLIGHT_RED: "Minimum number of hours and minutes of additional attendance required to highlight in red",
    GT_SELECT_WORKPLACE: "Allow workplace selection when marking from the web",
    CON_BENEF: "Consent for the use of benefits",
    PERM_BENEF: "Permission for earned days",
    CTO_BENEF: "Concept for direct benefit payments in cash",
    recognitionPlans: "Recognition plans",
    feedbackPurpose: "Feedback purposes",
    reasonForPointAwarding: "Reasons for awarding points",
    myBenefits: "My benefits",
    actions: "My actions and reminders",
    recognitionScreenSelector: "Recognitions",
    recognitionAnalysis: "Recognition analysis",
    actionTypes: "Action types",
    pollComparison: "Survey comparison",
    feed: "Social",
    HABPUBMURO: "Enable social wall",
    DURPUBMURO: "Duration of social wall posts",
    feedback: "Feedback",
    communicationChannel: "Communication channel",
    communicationClassification: "Communication classifications",
    userMenus: "User menu definitions",
    socialBlacklist: "Blocked users in Social",
    performanceDefinition: "Performance definitions",
    periodsForObjectives: "Periods for objectives",
    typesOfObjectives: "Types of objectives",
    positionGroupsForEvaluations: "Position groups for evaluations",
    typesOfSkillsSpecific: "Specific skills",
    skillsCode: "Skills code",
    indicatorNumber: "Indicator number",
    indicatorName: "Indicator name",
    behaviorDescription: "Behavior description",
    typesOfSkillsTransversal: "Transversal skills",
    goalsAndObjectivesTitle: "Goals and objectives",
    skillType: "Skill type",
    myGoalsAndObjectivesTitle: "My goals and objectives",
    talentAcquisitionSettings: "Talent acquisition settings",
    performanceForms: "Performance forms",
    evaluationProcessDefinition: "Evaluation processes",
    USER_TO_PUBLISH_RECOGNITION: "User to publish recognitions on the wall",
    performanceAnalytics: "Performance and talent analytics",
    performanceAnalyticsEvaluations: "Performance evaluation analytics",
    performanceAnalyticsHistoric: "Historical performance analysis",
    performanceAnalyticsTalent: "Talent analytics",
    ALLOW_CALIBRATION_IN_TALENT_CLASSIFICATION: "Allow calibration in talent classification",
    ALLOW_ACCEPT_REJECT: "Allow evaluated individuals to accept or reject their evaluation",
    onboardingMaterials: "Onboarding materials and resources",
    onboardingScreenSelector: "Onboarding",
    onboardingProcesses: "Onboarding processes",
    onboardingProcessesAssignment: "Assignment to onboarding processes",
    onboardingTracking: "Onboarding tracking",
    myOnboardingTracking: "My onboarding processes",
    DELETE_PROCESS_SQL: "SQL to execute when deleting a calculation process",
    changeLanguage: "Change language",
    youHaveUnreadAlerts: "You have {unread_alert_quantity} unread alert(s)",
    generatedDocument: "Generated document",
    settingDownload: "Preparing download...",
    creatingSignedDocuments: "Generating signed documents",
    creatingDocuments: "Generating documents",
    processing: "Processing",
    processInformationNotFound: "Process information not found",
    disableComment: "Disable comment",
    emptyCommentWarning: "The comment cannot be empty",
    createComment: "Create comment",
    editComment: "Edit comment",
    commentHowToTagForEmail: "To send your comment by email, mention the recipients with @",
    commentsNotFound: "No comments found",
    seeAll: "See all",
    revisionDate: "Revision date",
    eventDate: "Event date",
    event: "Event",
    purpose: "Purpose",
    reference: "Reference",
    feedbackHowSent: "How did you give the feedback?",
    feedbackHowReceived: "How do you want to receive the feedback?",
    uploadEvidence: "Upload evidence",
    uploadFile: "Upload file",
    progressPercentage: "Progress %",
    chooseGoalsAndObjectives: "Choose goals and objectives",
    none: "None",
    noneFemale: "None",
    selectedUserHasNoGoalsAndObjectives: "The selected user has no active goals and objectives",
    invalidLinkWarning: "Enter a valid link",
    enterLink: "Enter link",
    previewOnlyForPDF: "Only .pdf files can be previewed",
    linkToPoll: "Link to poll",
    poll: "Poll",
    onlySeenByCollaborators: "It will be visible to all collaborators.",
    onlySeenBySelectedPerson: "Only the selected person.",
    onlySeenBySelectedPeopleList: "Only the selected list of people.",
    onlySeenBySelectedGroup: "Only people within the selected group.",
    onlySeenBySelectedTask: "Only people sharing the selected task.",
    mustSelectOption: "You must select an option",
    whoCanSeePublication: "Who can see the publication",
    whoReceivesFeedback: "Who receives the feedback",
    whoGivesFeedback: "Who should give you feedback",
    feedbackWillBeViewedBy: "Your feedback will be visible to those you indicate",
    publicationWillBeViewedBy: "Your publication will appear in Social and will be visible to those you indicate.",
    feedbackAndTaskWillBeLinked: "With this option, the feedback and task will be linked",
    selected: "Selected",
    selectTaskThatCanView: "Select the task that can view",
    selectGroupThatCanView: "Select the group that can view",
    createFeedback: "Create feedback",
    editFeedback: "Edit feedback",
    createPublication: "Create publication",
    editPublication: "Edit publication",
    allFieldsRequiredAndSelectReceiver: "You must fill in the required fields and select the recipients",
    mustEnterPublicationText: "You must enter the publication text",
    giveFeedback: "Give feedback",
    requestFeedback: "Request feedback",
    allowComments: "Allow comments",
    seeLikes: "See likes",
    like: "Like",
    mustEnterReason: "You must enter the reason",
    enterReason: "Enter reason",
    commentHasBeenDisabled: "Only you can see this comment because it has been disabled by {responsibleName}.",
    publicationHasBeenDisabled: "Only you can see this publication because it has been disabled by {responsibleName}.",
    edited: "Edited",
    whoCanSee: "Who can see",
    eventAssistanceConfirmation: "I will attend the event",
    eventAssistance: "Event assistance",
    searchByName: "Search by name",
    noResultsFound: "No results found",
    feedbackDeleteConfirmation: "Do you want to delete the feedback?",
    publicationDeleteConfirmation: "Do you want to delete the publication?",
    feedbackIsLinkedToTask: "This feedback is linked to the task",
    feedbackDeleteWarning:
        "If you delete the feedback, the entire task and everything it contains (activities, progress, attachments, and comments) will also be deleted",
    revision: "Revision",
    disablePublication: "Disable publication",
    disable: "Disable",
    reactivate: "Reactivate",
    loadMore: "Load more",
    youHaveBeenBlocked:
        "User blocked: you cannot create or interact with other publications because you have been blocked.",
    publicationsNotFound: "No publications found",
    private: "Private",
    public: "Public",
    custom: "Custom",
    taskTeam: "Task team",
    delivered: "Delivered",
    received: "Received",
    commentRequiredForFeedback: "To receive feedback, you must add a comment",
    requested: "Requested",
    topTenFeedbackGivers: "Top 10 people who have given the most feedback",
    topTenFeedbackGiversToMe: "Top 10 people who have given me the most feedback",
    timeline: "Timeline",
    graphStatistics: "Graph statistics",
    selectedFeedback: "Selected feedbacks",
    myFeedback: "My feedback",
    onlyDelivered: "Only delivered",
    deliveredAndReceived: "Delivered and received",
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December",
    multipleCollaboratorsSelected: "Multiple collaborators selected",
    from: "From",
    to: "To",
    mustSelectOneRow: "You must select a record",
    cantDeleteOtherPeopleFeedback: "You cannot delete the selected feedback because you did not send it",
    cantDeleteLinkedToEvaluation: "It cannot be deleted because it is linked to the performance evaluation",
    taskAlreadyLinkedToFeedback: "The selected task is already associated with another feedback",
    feedbackCode: "Feedback code",
    whoSends: "Who sends",
    whoReceives: "Who receives",
    text: "Text",
    modality: "Modality",
    period: "Period",
    image: "Image",
    evidence: "Evidence",
    scope: "Scope",
    commentsAreAllowed: "Comments are allowed",
    likes: "Likes",
    role: "Role",
    whoSendsCode: "Sender's code",
    whoReceivesCode: "Receiver's code",
    publish: "Publish",
    myPendingConsents: "My pending consents",
    myVacations: "My vacations",
    myLoans: "My loans",
    myFeedbacks: "My feedback",
    myCommunicationChannel: "My communication channel",
    myPeopleVacations: "My team's vacations",
    myPeopleAnnotations: "My team's annotations",
    myPeopleTime: "My team's schedules",
    timeChangeRequests: "Schedule change requests",
    myCreatedCommunications: "My communications",
    communicationsToAttend: "Communications I need to attend",
    myOnboardingTasks: "My onboarding tasks",
    openMyPersonalData: "Open Personal Data",
    sendMessageToManager: "Send message to manager",
    myMedalTable: "My medal table",
    noRegisteredAssistanceData: "No registered assistance data",
    lastAssistanceRegistry: "Last assistance registry",
    totalProgressLowercase: "total progress",
    collaboratorsProgress: "Collaborators' progress",
    oneDayRemaning: "1 day remaining",
    daysRemaning: "{remainingDays} days remaining",
    viewProgressOf: "View progress of",
    noQueriesFound: "No queries found",
    daysDelay: "{remainingDays} days delayed",
    oneDayDelay: "1 day delayed",
    taskFinishedMale: "Finished",
    taskShortageProgress: "Shortage",
    lastAlerts: "Latest notifications",
    lastCreatedAnnotations: "Last annotations you created",
    lastReceivedAnnotations: "Last annotations received",
    myFavouriteGeolocationQueries: "My favorite geoanalysis queries",
    myFavouriteKPI: "My favorite KPIs",
    pendingPolls: "Pending surveys",
    myFavouriteQueries: "My favorite queries",
    willBeSentToMyManager: "Will be sent to my manager",
    consentAlreadyAccepted: "Consent already accepted",
    thanksForAcceptingConsent: "Thank you very much for accepting the consent",
    deleteSelectedAlerts: "Delete selected alerts",
    deleteReadAlerts: "Delete read alerts",
    selectFilter: "Select filter",
    noFilter: "No filter",
    downloadHasBegun: "Download has begun...",
    inePoll: "INE Poll (Excel template)",
    encryptor: "Encryptor",
    fingerprintRegistration: "Fingerprint registration",
    assistanceRegistrationApp: "Assistance registration App",
    legalFilesAndDocuments: "Legal files and documents",
    assistanceRegistration: "Assistance registration",
    utils: "Utils",
    yourProgrammedScheduledForToday: "Your programmed schedule for today is",
    myAssistanceRegistration: "My assistance registration",
    mustSelectJobLocation: "You must select a job location",
    pollAnswered: "Poll answered",
    giveOpinion: "Give us your opinion",
    pollMedalTablePoints: "Answering this poll will give you {points} points in your medal table",
    openDigitalWarehouse: "Open digital warehouse",
    noDigitalWarehouse: "No digital warehouse",
    hasDigitalWarehouse: "Has digital warehouse",
    tag: "Tag",
    addMembers: "Add members",
    membersSelected: "Selected members",
    viewCollaboratorsList: "View collaborators from list",
    viewAsList: "View as list",
    viewAsTree: "View as tree",
    preview: "Preview",
    groupDigitalWarehouse: "Digital warehouse from group",
    enterRequiredFields: "Enter required fields",
    editFile: "Edit file",
    createFile: "Create file",
    folder: "Folder",
    subfolder: "Subfolder",
    fileType: "File type",
    quickSearch: "Quick search...",
    fileOnFolderAlreadyExists: "File on that date and folder/subfolder already exists",
    cantDeleteFileInUse: "Can't delete file because it's in use",
    fileDeletedSuccessfully: "File deleted successfully",
    fileCreatedSuccessfully: "File created successfully",
    filesCreatedSuccessfully: "files created successfully",
    fileEditedSuccessfully: "File updated successfully",
    personalEmail: "Personal email",
    weeklyHoursContract: "Weekly hours by contract",
    helpAssistant: "Help assistant",
    dataProtection: "Data protection",
    correctlyRequestedCorrection: "Correction requested successfully",
    correctionRequest: "Correction request",
    requestCorrection: "Request a correction",
    detailCorrectionRequest: "Please provide details about the correction you wish to request:",
    changeProfileImageWarning:
        "Dear collaborator: if you want to upload a picture, we request it to be a personal picture for corporate use.",
    changeProfileImageThanks: "Thanks for your collaboration.",
    mustSelectImage: "Must select an image",
    historicCertificatesReceiptsWarning1:
        "The processes that are displayed correspond only to those in which you have already accepted the payslip.",
    historicCertificatesReceiptsWarning2:
        "If you do not see a specific process, it is because it is not yet available, or because you have not yet accepted the payslip for that process. If this is the case, go to My Payslips to accept the pending documents.",
    mustSelectQuery: "Must select query",
    file: "File",
    uploader: "Uploader",
    groupMemberPermissions: "Group members permissions",
    noOnboardingTask: "You have no onboarding tasks where you are defined as responsible",
    profile: "Profile",
    onboardingTrackingFromTo: "From {startDate} to {endDate}",
    onboardingTrackingProgress: "Process total progress: {processProgressValue}% ({amountInProgress} of {amountTotal})",
    activeProcesses: "Active processes",
    everyProcess: "Every process",
    lookAtProcessTree: "Look at process tree",
    moment: "Moment",
    actionType: "Action type",
    onboardingTrackingMomentProgress: "Moment progress: {processProgressValue}% ({amountInProgress} of {amountTotal})",
    seeEmployeeData: "See employee data",
    assignToProcessControl: "Assign to process control",
    removeFromProcessControl: "Remove from process control",
    stopProcessControl: "Stop process control",
    reassignProcessControl: "Reassign to process control",
    moveToDone: "Move to “Done”",
    removeProcessCompletely: "Remove process completely",
    reminderDate: "Reminder date",
    onboardingTrackingDescriptionHelperText:
        "When you enter or modify the description, remember that in order for a notification to be sent to the assigned person, you need to access this action again, click on it, and create a comment.",
    commentCantBeEmpty: "Comment can't be empty",
    howToTagInComment: "To have your comment sent by email as well, mention destinataries with @",
    processTree: "Visualization tree of process",
    excludeStoppedCollaborators: "Exclude stopped collaborators",
    excludeUnnecessaryActions: "Exclude unnecessary actions",
    onlyIncludePlannificatedActions: "Only include planned actions",
    includePlannificatedAndInProgressActions: "Include planned and in progress actions",
    collaboratorsInProcess: "collaborators in process",
    howToEditFeedback: "To edit this feedback or make comments, go to My Feedback from My Desktop",
    collaboratorAssignedToControlProcess: "Collaborator assigned to process control successfully",
    collaboratorRemovedFromControlProcess: "Collaborator removed from process control successfully",
    collaboratorUpdated: "Collaborator updated successfully",
    responsibleAssigned: "Responsible assigned successfully",
    actionDeleted: "Action removed successfully",
    actionUpdated: "Action updated successfully",
    actionReplicated: "Action replicated successfully",
    collaboratorsNotFound: "Collaborators not found",
    replicateWarning:
        "The assigned person, the action description, and the dates will be assigned to the rest of the actions of the same type that are in a planned state.",
    doYouWishToContinue: "Do you wish to continue?",
    cantAssignCollaboratorToProcessControl1:
        "It is not possible to assign the collaborator to the process control because the process has already advanced to the second stage for other collaborators.",
    cantAssignCollaboratorToProcessControl2: "Assignments can only be made when the process is in the first stage.",
    cantAssignCollaboratorToProcessControl3:
        "Remove the collaborator from this process and assign them to another onboarding process.",
    deleteActionQuestion: "Do you wish to delete the action?",
    deleteCollaboratorProcessOnboardingWarning1:
        "If you remove the collaborator from the onboarding process, the following will also be deleted:",
    deleteCollaboratorProcessOnboardingWarning2: "All traceability and details of their participation in the process.",
    deleteCollaboratorProcessOnboardingWarning3:
        "Their comments, attachments, and feedback received during the process.",
    deleteCollaboratorProcessOnboardingWarning4: "The actions carried out and the stages they have gone through.",
    removeCollaboratorProcessOnboardingWarning1:
        "If you remove the collaborator from the onboarding process control (Kanban), the following will also be deleted:",
    removeCollaboratorProcessOnboardingWarning2: "All traceability and details of their participation in the process.",
    removeCollaboratorProcessOnboardingWarning3:
        "Their comments, attachments, and feedback received during the process.",
    removeCollaboratorProcessOnboardingWarning4: "The actions carried out and the stages they have gone through.",
    removeCollaboratorProcessOnboardingWarning5:
        "Although they will remain within the process, the details of the actions performed will not be retained.",
    removeCollaboratorProcessOnboardingWarning6:
        "However, it will be possible to reassign them to the process control at a later time.",
    moveCollaboratorToDoneWarning1:
        "If you move the collaborator to the 'Done' stage, it means that the onboarding process for the collaborator has been completed.",
    moveCollaboratorToDoneWarning2:
        "From that point on, you will only be able to view it, but you will no longer be able to modify it or perform new actions within the onboarding process control for that collaborator.",
    hasBeenAnswered: "Has been answered.",
    hasNotbeenAnswered: "Has not been answered yet.",
    accessMaterial: "Access material",
    acceptTermsAndConditions: "Accept terms and conditions",
    observations: "Observations",
    observationsRequired: "Observations are required if you reject the document",
    mustSelectDocument: "Must select document",
    previewDocumentBeforeSigning: "Preview document before signing it",
    acceptAndSign: "Accept and sign",
    previewDocument: "Preview document",
    viewAttachment: "View attachment",
    wrongPIN: "Password entered is incorrect",
    approvalAndSignSuccessfull: "Document approved and signed successfully",
    documentRejectionSuccessfull: "Document rejected successfully",
    openEmojiSelector: "Open emoji selector",
    collaboratorAnnotations: "Collaborator annotations",
    checkWeight: "Check weightings",
    goalsAndObjectivesCharts: "Goals and objectives charts",
    amountByProgress: "Amount by progress",
    amountByStatus: "Amount by status",
    mustSelectCollaborator: "You must select a collaborator",
    createObjective: "Create objective",
    editObjective: "Edit objective",
    selectCollaborator: "Select collaborator",
    selectCollaborators: "Select collaborators",
    objectiveType: "Objective type",
    objective: "Objective",
    objectiveName: "Objective name",
    objectiveWeight: "Objective weighting",
    assignationDate: "Assignment date",
    relatedTask: "Related task",
    progressDate: "Progress date",
    progressPercentageObjective: "Progress percentage",
    mustBeApprovedByCollaborator: "Must be approved by the collaborator?",
    mustByApprovedByManager: "Must be approved by the manager?",
    doYouApproveObjective: "Do you approve the objective?",
    doesCollaboratorApproveObjective: "Approved by the collaborator?",
    doesManagerApproveObjective: "Approved by the manager?",
    viewGrid: "View grid",
    myManager: "My manager",
    allObjectives: "All objectives",
    objectivesAssignedByMe: "Objectives I have assigned",
    noObjectivesForYouInPeriod: "You have no goals or objectives for the selected period",
    noCollaboratorWithObjectivesInPeriod: "No collaborator has goals or objectives for the selected period",
    noCollaboratorSelectedWithObjetivesInPeriod:
        "The selected collaborator has no goals or objectives for the selected period",
    personalObjectives: "Personal objectives",
    organizationObjectives: "Organization objectives",
    selectedCollaboratorNoObjectivesOfType: "The selected collaborator has no goals or objectives of this type",
    assignedBy: "Assigned by",
    progressStatus: "Progress status",
    youMustApproveObjective: "You must approve the objective",
    objectiveDescription: "Objective description",
    objectiveWeightWarning:
        "The total of the weightings is {number}% for {verificationFailuresValue}. You must add another objective or reassign the weightings",
    objectiveWeightCollaboratorOk:
        "The total of the weightings is correct and adds up to 100% for the assigned objectives",
    objectiveWeightSelectedCollaboratorsOk:
        "The total of the weightings is correct and adds up to 100% for the selected collaborators",
    objectiveCantBeDeletedCreatedBy: "The objective cannot be deleted, it was created by their {selectedRowRole}",
    deleteObjectiveQuestion: "Do you want to delete the objective?",
    mustSelectOneRowAndPeriod: "You must select at least one record and a period",
    objectiveFeedbackWarning:
        "You have modified data included in the feedback (end date or progress %), please update before submitting the feedback.",
    mustIApproveObjective: "Do I have to approve the objective?",
    assignerRole: "Assigner role",
    datesInvalid: "The entered dates are invalid",
    objectiveAlreadyExistsNameOrCode: "An objective with the same name or code already exists",
    objectiveInUse: "The objective cannot be deleted because it is in use",
    objectiveWeightWarning2:
        "The total weightings for the collaborator in the selected period cannot exceed the maximum value of 100",
    objectiveAlreadyEvaluated:
        "The objective cannot be deleted because it has already been rated in the evaluation: {evaluationName}",
    objectiveDeletedOk: "Objective successfully deleted",
    objectiveCreatedOk: "Objective successfully created",
    objectiveModifiedOk: "Objective successfully updated",
    expiresToday: "Expires today",
    atTime: "at",
    objectiveStatus: "Objective status",
    objectiveAssigner: "Objective assigner",
    postpone: "Postpone",
    forFinalResultOfPotentialEvaluation: "For the final result of the potential evaluation",
    onboardingStageProfiles: "Onboarding stage profiles",
    cannotDeleteRatingScaleBecauseItIsUsedInPerformanceForms:
        "Cannot delete rating scale because it is used in performance forms",
    noFormatTypesFoundForPublications: "No format types found for publications",
    attendanceMarks: "Attendance marks",
    timeStartDate: "Time start date",
    newProject: "New project",
    onlyOnePurposeCanShareSameCodeOrName: "Only one purpose can share the same code or name",
    alphanumericEdit: "Alphanumeric edit",
    quota: "Quota",
    numericWithDecimalsAndNotEligibleAsMarker: "Numeric with decimals and not eligible as marker",
    earningsAndDeductionsByConceptGroup: "Income and Deductions - By concept group",
    onlyActiveEmployeesAllowedForMassProjectChange: "Only active employees allowed for mass project change",
    withVisa: "With visa",
    publicationCenters: "Publication centers",
    day: "Day",
    someDataLockedForThisFormDueToLinkedEvaluationProcesses:
        "Some data is locked for this form due to linked evaluation processes (View only)",
    scaleTypeName: "Scale type name",
    analytical: "Analytical",
    amountToReceive: "Amount to receive",
    npsExcellent: "NPS excellent",
    onlyOneDefaultProcessAllowedAtATime: "Only one default process allowed at a time",
    bulkFileUpload: "Bulk file upload",
    newConceptCode: "New concept code",
    advanceCurrency: "Advance currency",
    descriptiveTextForContractsAndOthers: "Descriptive text for contracts and others",
    confirmDeleteEvaluatedAndEvaluatorsRecords:
        "Are you sure you want to delete selected evaluated and evaluators records?",
    preloadedVariables: "Preloaded variables",
    allPlans: "All plans",
    currentCalculationProcessSchedule: "Current calculation process schedule",
    quotaStatus: "Quota status",
    processCodeAlreadyExistsForAnotherCalculation: "Process code already exists for another calculation process",
    withMultipleSignatures: "With multiple signatures",
    thirdPartyName: "Third party name",
    outstandingPerformance3: "3 Outstanding performance",
    scheduledShiftAlreadyExistsForThatDate: "A scheduled shift already exists for that date",
    cannotDeletePaymentMethodBecauseItIsInUse: "Cannot delete payment method because it is in use",
    createFamilyMemberRecord: "Create family member record",
    exportTemplateWithData: "Export template with data",
    mustSelectAtLeastOneFilter: "Must select at least one filter",
    createHealthInstitution: "Create health institution",
    dateWithPicker: "Date with picker",
    paymentMethodDeletedSuccessfully: "Payment method deleted successfully",
    confirmDeleteEmployeeFromPlan: "Are you sure you want to delete the employee from the plan?",
    editPeriodForObjectives: "Edit period for objectives",
    alertAndNotificationDefinition: "Alert and notification definition",
    editRecord: "Edit record",
    whatTypeOfDocumentDoYouWantToCreate: "What type of document do you want to create?",
    studyTypeDeletedSuccessfully: "Study type deleted successfully",
    absenceUpdatedSuccessfully: "Absence updated successfully",
    deleteMaterialOrResource: "Delete material or resource",
    exitReasons: "Exit reasons",
    costCenterUpdatedSuccessfully: "Cost center updated successfully",
    extraVariableField: "Extra variable field",
    inputSource: "Input source",
    positionAssignmentDate: "Position assignment date",
    specificCompetencyGroupForPosition: "Specific competency group for position",
    fromPerformanceRatings: "From performance ratings",
    indexDeletedSuccessfully: "Index deleted successfully",
    capturedViaOtherSystemApi: "Captured via other system (API)",
    noReasonsFoundForPointDelivery: "No reasons found for point delivery",
    confirmDeleteBenefitType: "Are you sure you want to delete the benefit type?",
    imputationAlreadyExistsForSameConceptEntryTypeAndCondition:
        "Imputation already exists for the same concept, entry type, and condition",
    publicationReference: "Publication reference",
    unscheduledWorkday: "Unscheduled workday",
    sqlToGetRecipients: "SQL to get recipients",
    secondLevelGeographicOrganizationIsMandatory: "Second level of geographic organization is mandatory",
    reasonsForPointDelivery: "Reasons for point delivery",
    historical: "Historical",
    entered: "Entered",
    peopleMaster: "PeopleMaster",
    ragBlueWhiteText: "rag-blue-whiteText",
    mandatoryAttachment: "Mandatory attachment",
    labelAbbreviation: "Label abbreviation",
    absencesAlternative: "Absences",
    final: "Final",
    changeSchedules: "Change schedules",
    descriptionCannotBeEmpty: "Description cannot be empty",
    mustSelectAtLeastOneItem: "Must select at least one item",
    positionIdMustBeNumber: "Position ID must be a number",
    deletePensionInstitution: "Delete pension institution",
    crossCompetencies: "Cross competencies",
    deleteThirdParty: "Delete third party",
    formula: "Formula",
    previewPdf: "Preview PDF",
    newRating: "New rating",
    returnFromBreak: "Return from break",
    averageFromMyEvaluators: "Average from my evaluators",
    conceptFamily: "Concept family",
    workLocationAssignmentDate: "Work location assignment date",
    creditAndDebitMustBeGreaterThanZeroIfPresent: "Credit and debit must be greater than 0 if present",
    benefitTypeUpdatedSuccessfully: "Benefit type updated successfully",
    newEvaluatorSelection: "New evaluator selection",
    icon1MinimumValue: "icon1MinimumValue",
    commentsAndObservations: "Comments and observations",
    organizationObjective2: "Organization objective 2",
    newNoteType: "New note type",
    finalGrade: "Final grade",
    collaboratorsPercentage: "Collaborators percentage",
    mustEnterMandatoryParameters: "You must enter the values for the mandatory parameters",
    paymentMethods: "Payment methods",
    yellow: "Yellow",
    peerWeightedScore: "Peer weighted score",
    associatedWithThisTeam: "Associated with this team",
    conceptCode: "Concept code",
    lowerPrice: "Discount",
    actionUpdatedSuccessfully: "Action updated successfully",
    cannotDeleteProjectBecauseItIsInUse: "Cannot delete the project because it is in use",
    alphaComma: "Alfa,",
    cannotDeleteConceptBecauseItIsInUse: "Cannot delete the concept because it is in use",
    referenceEmployee: "Reference employee",
    viewOnlyObjectives: "View-only objectives",
    noQuotaEntriesFound: "No quota entries found",
    signers: "Signers",
    specialProcessExecutionInProgress: "Execution in progress for the selected special process",
    exportData: "Export data",
    updatedQuadrantOrderSuccessfully: "Quadrant order updated successfully",
    thisBenefitAlreadyExistsAsOrganizationalBenefitAndItIsNotPossibleToDeactivateAssignPointsOrDefineItWithAccessModeThroughPointsRedemptionFirstItMustBeDeletedFromOrganizationalBenefitsBeforeProceedingWithTheseChanges:
        "This benefit already exists as an Organizational Benefit and it is not possible to deactivate it, assign points, or define it with access mode through point redemption. It must first be removed from Organizational Benefits before proceeding.",
    last3Years: "Last 3 years",
    unauthorized: "Unauthorized",
    massiveDepartmentalStructureChangeCompletedSuccessfully:
        "Massive departmental structure change completed successfully",
    concepts: "Concepts",
    executionMoment: "Execution moment",
    viewCalendar: "View calendar",
    competencyEvaluationsDifferences: "Competency evaluations (differences)",
    youMustSelectASingleRecord: "You must select a single record",
    youCannotAccessBecauseYourPinRecoveryHasExpiredPleaseRecoverYourPinAgain:
        "You cannot access because your PIN recovery has expired. Please recover your PIN again.",
    accountingAccountDescription: "Accounting account description",
    changePositions: "Change positions",
    potentialPtsFor9Boxes3: "Potential pts. for 9-Boxes 3",
    periodFrom: "Period from",
    legalDaysCanContainUpTo3Decimals: "Legal days can contain up to 3 decimals",
    deletedValuesPressSaveToMakeChangesPermanent: "Deleted values. Press save to make changes permanent.",
    potentialUntil: "Potential until",
    allPayrolls: "All payrolls",
    ifNecessaryIncludeAnAttachment: "Include an attachment if necessary",
    classificationDeletedSuccessfully: "Classification deleted successfully",
    editAbsence: "Edit absence",
    cannotExistValuesWithTheSameTypeCodeAndName: "There cannot be values with the same Type, Code, and Name",
    parameterNumber: "Parameter number",
    queriesForGeoanalysis: "Geoanalysis queries",
    forExistenceControlDuringRecordDeletion: "For existence control during record deletion",
    youMustChooseADocument: "You must choose a document",
    medicalLeaveManagement: "Medical leave management",
    assignmentDateToFunction: "Assignment date to function",
    earnedAdditionalOrProgressive: "Earned (additional or progressive)",
    noShiftAssigned: "No shift assigned",
    youCannotEditYourOwnVacations: "You cannot edit your own vacations",
    calculationSequence: "Calculation sequence",
    neutral: "Neutral",
    cannotExistMoreThanOneMaterialOrResourceWithTheSameCodeOrName:
        "There cannot be more than one material or resource with the same code or name",
    assessedPosition: "Assessed position",
    pleaseEnterNameDescriptionAndApplicationOfTheFunctionTheseDataWillReplaceTheOriginals:
        "Please enter the name, description, and application of the function. These data will replace the originals.",
    noObjectiveTypesFound: "No objective types found",
    cannotExistMoreThanOneUnionWithTheSameCodeOrName: "There cannot be more than one union with the same code or name",
    stepName: "Step name",
    costCenter2: "Cost center 2",
    queryDefinitionCreatedSuccessfully: "Query definition created successfully",
    queryDefinitionExportedSuccessfully: "Query definition exported successfully",
    queryDefinitionImportedSuccessfully: "Query definition imported successfully",
    queryDefinitionImplementedSuccessfully: "Query definition implemented successfully",
    generateWithAI: "Create with AI",
    promptHistory: "Prompt history",
    implementQuery: "Save query",
    summary: "Summary",
    warnings: "Warnings",
    minimumScores: "Minimum scores",
    youMustSelectASingleItem: "You must select a single item",
    youMustSelectAPeriod: "You must select a period",
    earningsAndDiscounts: "Earnings and discounts",
    summaryDisplay: "Summary display",
    calculationIndicatorString: "Calculation indicator string",
    openDetailTable: "Open detail table",
    permissionsForRequests: "Permissions for requests",
    conceptsInputStructureImportedSuccessfully: "Concept input structure imported successfully",
    enableEditorsForSystemTable: "Enable editors for system table",
    activeCustomization: "Active customization",
    determineForSelectedCollaboratorsWhoWillBeTheirEvaluator:
        "Determine for the selected collaborators who their evaluator will be",
    entitlementDays: "Entitlement days",
    youMustSelectTypeFirst: "You must select Type first",
    newFormatTypeForPublications: "New format type for publications",
    locationAndOrganizationalData: "Location and organizational data",
    theNumericValueOfTheScoreMustBeLessThan10000: "The numeric value of the score must be less than 10,000",
    unjustifiedAbsences: "Unjustified absences",
    selectedPlural: "Selected",
    itIsNotPossibleToDeleteStructuresBecauseTheyHaveEarningsOrDiscountsReportedInThem:
        "Cannot delete structures because they have earnings or discounts reported",
    onePoorPerformance: "1 Poor performance",
    availableForCollaborator: "Available for collaborator",
    npsVeryGood: "NPS very good",
    workOrJob: "Work or job",
    payrollTypeName: "Payroll type name",
    weeklyContractHours: "Weekly contract hours",
    selectFamilyAndSurveyTypeToStart: "Select family and survey type to start",
    performancePtsFor9Boxes1: "Performance pts. for 9-Boxes 1",
    evaluatesCrossCompetencies: "Evaluates cross competencies?",
    vitalSalary: "Vital salary",
    paidValue: "Paid value",
    itIsNotPossibleToDeleteTheRecordBecauseItIsInUse: "Cannot delete the record because it is in use",
    completionDate: "Completion date",
    formDesign: "Form design",
    noteitemstatusfilter: "NoteItemStatusFilter",
    cannotExistMoreThanOneStudyTypeWithTheSameCodeOrName:
        "There cannot be more than one study type with the same code or name",
    projectString: "Project String",
    shiftAssignmentDate: "Shift assignment date",
    optional: "Optional",
    aProcessWithTheSameCodeOrNameAlreadyExists: "A process with the same code or name already exists",
    nameScheduledTime: "Name of the scheduled time",
    regionalStructure: "Regional structure",
    generateVoucherAndSendToCollaboratorForDigitalSignature:
        "Generate voucher and send to collaborator for digital signature",
    vacationTableXlsx: "Vacation table.xlsx",
    returnDate: "Return date",
    costCenter5: "Cost center 5",
    doYouWantToDeleteTheScheduleAlt: "Do you want to delete the schedule?",
    calibrationGroup: "Calibration group",
    nov: "Nov",
    itIsNotPossibleToSelectDifferentTypesOfEvaluationToAssignEvaluators:
        "It is not possible to select different types of evaluations to assign evaluators",
    extraHoursWorked: "Extra hours worked",
    anExceptionForThisDayAlreadyExists: "An exception for this day already exists",
    descriptiveText: "Descriptive text",
    oneLimitedPotential: "1 Limited potential",
    valueUntilClock: "Value until Clock",
    itIsNotPossibleToDeleteThePermissionBecauseItIsInUse:
        "It is not possible to delete the permission because it is in use",
    groupNumber: "Group number",
    reasonsForPointDeliveryLong: "Reasons for point delivery",
    specialProcessDeletedSuccessfully: "Special process successfully deleted",
    resizePositionsAndModify: "Resize positions and modify",
    doYouWantToDeleteTheVacations: "Do you want to delete the vacations?",
    viewResult: "View result",
    cannotExistMoreThanOneConsentTypeWithTheSameCodeOrName:
        "There cannot be more than one consent type with the same code or name",
    contractTypes: "Contract types",
    distribution: "Distribution",
    processStatusLong: "Process status",
    cannotEditTheCalendarBecauseItIsInHistoricalState: "Cannot edit the calendar because it is in historical state",
    collaboratorList: "Collaborator list",
    visaStatus: "Visa status",
    applicablePeriod: "Applicable period",
    recognitions: "Recognitions",
    currentContract: "Current contract",
    referenceCodeString: "Reference code string",
    communicationStatus: "Communication status",
    thisFieldHasAnAutomaticTableRelationshipThereforeTheDropdownListWillLoadAutomaticallyUnlessYouEnterYourOwnSqlForTheList:
        "This field has an automatic table relationship. Therefore, the dropdown list will load automatically unless you enter your own SQL for the list.",
    quadrantPositionYX: "Quadrant position (Y,X)",
    calibratedPerformanceNumericScore: "Calibrated numeric performance score",
    mustHaveScheduledStatus: "Must have Scheduled status",
    periodForObjectives: "Period for objectives",
    copyDataToReplicate: "Copy data to replicate",
    conceptType: "Concept type",
    specifyCompetencyScale: "Specify competency scale",
    viewSql: "View SQL",
    doYouWantToDeleteHealthInstitution: "Do you want to delete the health institution?",
    commentsColon: "Comments:",
    studyTypeUpdatedSuccessfully: "Study type successfully updated",
    cannotDeleteGroupClassificationBecauseItIsInUse: "Cannot delete group classification because it is in use",
    execute: "Execute",
    mustSelectAtLeastOneRow: "You must select at least one row",
    recordCreatedSuccessfully: "Record created successfully",
    thePaymentOfTheIndicatedValueWillBeMadeInYourPayrollCalculation:
        "The payment of the indicated value will be made in your payroll calculation",
    specifyCompetenciesToEvaluate: "Specify competencies to evaluate",
    project: "Project",
    summaryAndCharts: "Summary and charts",
    organizationObjectivesPoints: "Organization objective weights",
    allergies: "Allergies",
    indexUpdatedSuccessfully: "Index updated successfully",
    numnone: "NumNone",
    collaboratorsWithInProgressStatus: "Collaborators with in-progress status",
    scaleTypeCreation: "Scale type creation",
    holidaysAndFestiveDays: "Holidays and festive days",
    absenceTypeIsMandatory: "Absence type is mandatory",
    newStudyType: "New study type",
    competencyDeletedSuccessfully: "Competency successfully deleted",
    noPublicationChannelTypesFound: "No publication channel types found",
    assignmentDateToResponsible: "Assignment date to responsible",
    scheduleDeletedSuccessfully: "Schedule successfully deleted",
    doYouWantToDeleteTheEarnings: "Do you want to delete the earnings?",
    doYouWantToDeleteTheSpecialization: "Do you want to delete the specialization?",
    group09: "Group 09",
    deleteEarnings: "Delete earnings",
    goldMedals: "Gold medals",
    payrollCalculationProcesses: "Payroll calculation processes",
    noThirdPartyClassificationsFound: "No third-party classifications found",
    permissionCreatedSuccessfully: "Permission created successfully",
    allocationCreatedSuccessfully: "Allocation created successfully",
    entryDelayTolerance: "Entry delay tolerance",
    netShiftHours: "Net shift hours",
    licenseTypeString: "License type string",
    bronzeShields: "Bronze shields",
    listShort: "List",
    calibrationResponsible: "Calibration responsible",
    viewTypes: "View types",
    planIdentification: "Plan identification",
    allocationUpdatedSuccessfully: "Allocation updated successfully",
    editHistoricalAccumulator: "Edit historical accumulator",
    relativeCode: "Relative code",
    searchExcelFile: "Search Excel file",
    cannotDeleteRecordBecauseThereArePaidInstallmentsInTheInstallmentDetailOnlyPrepaymentIsAllowed:
        "Cannot delete the record because there are paid installments in the installment detail. Only prepayment is allowed.",
    group01: "Group 01",
    clickOnTheChartsToViewDetails: "Click on the charts to view details",
    doYouWantToDeleteCostCenter: "Do you want to delete the cost center?",
    pleaseEnterConceptCodeAndNameTheseDataWillReplaceTheOriginals:
        "Please enter the concept code and name. These data will replace the originals.",
    entryHours: "Entry hours",
    someConceptCodesEnteredDoNotExistInTheDatabase: "Some of the entered concept codes do not exist in the database.",
    cannotDeleteStudyTypeBecauseItIsInUse: "Cannot delete the study type because it is in use",
    descriptiveRatings: "Descriptive ratings",
    payrollTypes: "Payroll types",
    mustSelectARecordToReplicate: "You must select a record to replicate",
    calendarDeletedSuccessfully: "Calendar deleted successfully",
    mustBePositiveNumber: "Must be a positive number",
    classificationName: "Classification name",
    mustSelectNewStatus: "You must select a new status",
    currentAccounts: "Current accounts",
    performanceAndTalentAnalyticsSettings: "Performance and talent analytics settings",
    messageBodyText: "Message body text",
    physicalCodeOfField: "Physical code of the field",
    changeShifts: "Change shifts",
    personalData: "Personal data",
    evaluationStartDate: "Evaluation start date",
    doYouWantToMarkSelectedRecordsAsObserved: "Do you want to mark the selected records as observed?",
    negative: "Negative",
    cannotDeleteJobClassificationBecauseItIsInUse: "Cannot delete the job classification because it is in use",
    benefitTypes: "Benefit types",
    payrollEnablement: "Payroll enablement",
    editorForModificationOnly: "Editor for modification only",
    completeNodeNameAndCode: "Complete the node name and code.",
    selectAnIncomeStructure: "Select an income structure",
    historicalAccumulatorUpdatedSuccessfully: "Historical accumulator updated successfully",
    receiptSentSuccessfully: "Payslip sent successfully",
    latitudeAndLongitude: "Latitude and longitude",
    relatedTableField: "Related table field",
    medicalLeaveTypes: "Medical leave types",
    unblockUser: "Unblock user",
    sqlStatements: "SQL statements",
    appearanceSequence: "Appearance sequence",
    mustSelectAnEmployee: "You must select an employee",
    valueBetween1And9999: "Value between 1 and 9999",
    calibratedCompetenciesRating: "Calibrated competencies rating",
    toClassifyCommunicationYouMustBeTheResponsibleInChargeOfTheAttentionIfNecessaryAssignYourselfFirstAsTheResponsible:
        "To classify the communication, you must be the person responsible for the attention. If necessary, assign yourself first as the responsible party.",
    analyticalAccountingEntry: "Analytical accounting entry",
    enteredDescriptionWillBePartOfTheUploadedFileName: "The entered description will be part of the uploaded file name",
    createAttendanceMark: "Create attendance mark",
    editAttendanceMark: "Edit/complete attendance mark",
    enterReasonForDeletion: "Enter reason for deletion",
    valueFromYellow: "Value from Yellow",
    tableType: "Table type",
    sqlForDropdownList: "SQL for dropdown list",
    duplicateFunction: "Duplicate function",
    queryParameterDeletedSuccessfully: "Query parameter deleted successfully",
    valuesForDetail: "Values for detail",
    attentionResponsible: "Attention responsible",
    featuredNews: "Featured news",
    evaluateOrganizationObjectives: "Evaluate organization objectives?",
    toGiveFeedbackTheEvaluatedScoreStateMustBeFinalScore:
        "To give feedback, the evaluated score state must be 'Final Score'",
    currentCollaboratorsToProcess: "Current collaborators to process",
    onSpecificDate: "On specific date",
    adminAccessGroup: "Admin access group",
    evaluatorComments: "Evaluator comments",
    onboardingEndDate: "Onboarding end date",
    doYouWantToDeleteThePreventionInstitution: "Do you want to delete the prevention institution?",
    planUpdatedSuccessfully: "Plan updated successfully",
    avatar: "Avatar",
    goalScale: "Goal scale",
    cannotManageModificationOfOwnInformation: "You cannot manage the modification of your own information",
    import: "Import",
    personal: "Personal",
    grantedLoanValue: "Granted loan value",
    unionCreatedSuccessfully: "Union created successfully",
    applicationStartDate: "Application start date",
    verifyWeighted: "Verify weighted",
    toAccessBenefitsYouNeedToReviewAndAcceptTheConsentToUse:
        "To access benefits, you must review and accept the consent to use",
    fri: "Fri",
    system: "System",
    fileName: "File name",
    noteTypeName: "Note type name",
    doYouWantToDeleteTheTemplate: "Do you want to delete the template?",
    assignmentDate: "Assignment date",
    employee: "Employee",
    viewingRole: "Viewing role",
    quadrantClassification: "Quadrant classification",
    indemnityForAllEvents: "Indemnity for all events",
    massiveJobChange: "Massive job change",
    cannotApproveProcessBecauseNoCollaboratorsWereProcessed:
        "Cannot approve the process because no collaborators were processed",
    values: "Values",
    thirdPartyClassificationUpdatedSuccessfully: "Third-party classification updated successfully",
    incomeByConcept: "Income by concept",
    indexCreatedSuccessfully: "Index created successfully",
    enterComment: "Enter comment",
    inputUser: "Input user",
    formType: "Form type",
    calibrationCommittee: "Calibration committee",
    consentAlreadyAcceptedFinalDot: "Consent already accepted.",
    incomeByConceptSet: "Income by concept set",
    deleteGroupClassification: "Delete group classification",
    descending: "Descending",
    specialProcessCreatedSuccessfully: "Special process created successfully",
    evaluationProcessUpdatedSuccessfully: "Evaluation process updated successfully",
    cannotDeleteUserWithSignedDocuments: "Cannot delete user with signed documents",
    newReminderDateForAlert: "New reminder date for alert",
    onDate: "On date",
    bankDistribution: "Bank distribution",
    fieldStructure: "Field structure",
    editPermission: "Edit permission",
    imputation: "Imputation",
    processScheduleDeletedSuccessfully: "Process schedule deleted successfully",
    valuesDeletedSuccessfully: "Values deleted successfully",
    specialProcessAlreadyAssociatedWithAnotherAlertOrNoticeAndWithSameExecutionModeItCannotBeAssociatedAgainWithSameExecutionMode:
        "The special process is already associated with another alert or notice with the same execution mode. It cannot be associated again with the same execution mode.",
    holidaysAndFestiveDaysXlsx: "Holidays and festive days.xlsx",
    forMassiveContractChangeYouMustSelectOnlyActiveCollaborators:
        "For massive contract changes, you must select only active collaborators",
    forMassiveDivisionChangeYouMustSelectOnlyActiveCollaborators:
        "For massive business unit changes, you must select only active collaborators",
    forMassiveManagementCenterChangeYouMustSelectOnlyActiveCollaborators:
        "For massive publication center changes, you must select only active collaborators",
    createIndex: "Create index",
    totalDaysToBeUsedInTheFuture: "Total days to be used in the future",
    noteTypeWithEnteredNameAlreadyExists: "A note type with the entered name already exists",
    cannotCreateParametersBecauseSpecialProcessIsAssociatedWithUserAlertOrNotice:
        "Cannot create parameters because the special process is associated with a user alert or notice",
    maxRatingsQty: "Max ratings quantity",
    vacationManagement: "Vacation management",
    hasAssociatedValues: "Has associated values",
    noEvaluationsRegisteredYet: "No evaluations registered yet.",
    viewOnly: "View only",
    absenceType: "Absence type",
    evaluationPeriod: "Evaluation period",
    calendarWithSamePeriodAndCalendarTypeAlreadyExists:
        "A calendar with the same period and calendar type already exists",
    competencyName: "Competency name",
    alertsDeletedSuccessfully: "Alerts deleted successfully",
    finalPotentialNoteType: "Final potential note type",
    doYouWantToDeleteOrganizationalBenefit: "Do you want to delete the organizational benefit?",
    changeCostCentersOfManagement: "Change management cost centers",
    mustSelectAnOption: "You must select an option",
    vacationsCreatedSuccessfully: "Vacations created successfully",
    permissionTypeString: "Permission type string",
    verifyFirstLevelOfGeographicalOrganization: "Verify the first level of geographical organization",
    attached: "Attached",
    geminiDisclaimer: "ICARIUS AI may display inaccurate information",
    geminiErrorMessage: "An unknown error occurred.",
    geminiInputPlaceholder: "Type something...",
    botInitialMessage: "Hello, how can I help you today?",
    geminiChatbox: "ICARIUS AI Chatbox",
    invalidSizeGemini: "The file size cannot exceed {maxSize} MB",
    invalidFileTypeGemini:
        "The file type is invalid. Only images, text files, PDF documents, and Excel files are allowed",
    maxFilesGemini: "Only up to {maxFiles} files can be attached",
    photograph: "Photograph",
    areYouSureYouWantToDeleteThePlan: "Are you sure you want to delete the plan?",
    thirdParties: "Third parties",
    seniorityUntilYears: "Seniority until (years)",
    back: "Back",
    createKpiAndChartsForPayrollDashboard: "Create KPIs and charts for payroll dashboard",
    hoursAndMinutesHhmm: "Hours and minutes (hhmm)",
    selectATimeCalendar: "Select a time calendar",
    timePicker: "Time picker",
    structuresDeletedSuccessfully: "Structures deleted successfully",
    pointsToObtain: "Points to obtain",
    deleteShift: "Delete shift",
    observationsUpdatedSuccessfully: "Observations updated successfully",
    parameterOrderNumber: "Parameter order number",
    sub: "Sub",
    massiveLoadOfAccountingCostDistribution: "Massive load of accounting cost distribution",
    deleteThirdPartyClassification: "Delete third party classification",
    newStep: "New step",
    transfer: "Transfer",
    customFormula: "Custom formula",
    createConsentType: "Create consent type",
    exportEmptyTemplate: "Export empty template",
    noFileTypesFound: "No file types found",
    createStudyTypes: "Create study types",
    incomeType: "Income type",
    deleteCalendar: "Delete calendar",
    ifYouChangeMomentOrActionTypeThereAreMaterialsOrResourcesLinkedToOnboardingStepThatDoNotMatchTheTypeOfMomentOrActionYouAreDefiningAndWillBeDeletedDoYouWantToProceedAnyway:
        "If you change the moment or action type, there are materials or resources linked to the onboarding step that do not match the type of moment or action you are defining and will be deleted. Do you want to proceed anyway?",
    setPersonalObjectives: "Set personal objectives",
    until: "Until",
    fileTypeDeletedSuccessfully: "File type deleted successfully",
    toAcceptOrObjectYourPerformanceEvaluationYouMustBeTheEvaluated:
        "To accept or object to your performance evaluation, you must be the evaluated person",
    ascendingEvaluation: "Ascending evaluation",
    paymentMethodUpdatedSuccessfully: "Payment method updated successfully",
    cannotHaveMoreThanOneHealthInstitutionSharingSameCodeOrName:
        "There cannot be more than one health institution sharing the same code or name",
    massiveUpdateOfCostCentersFinishedSuccessfully: "Massive update of cost centers finished successfully",
    activeFemale: "Active",
    authorizedExtraHours: "Authorized extra hours",
    editVacations: "Edit vacations",
    newSetOfConcepts: "New set of concepts",
    areYouSureYouWantToDeleteCollaboratorOnboardingProcess:
        "Are you sure you want to delete the collaborator's onboarding process?",
    executionDayOfWeek: "Execution day of the week",
    onlyTransactionsWithStatusEnteredCanBeDeleted: "Only transactions with status 'Entered' can be deleted",
    costCenterDeletedSuccessfully: "Cost center deleted successfully",
    evaluationAcceptedByEvaluated: "Evaluation accepted by evaluated",
    authorizedExtraHoursSuccessfully: "Authorized extra hours successfully",
    entryTime: "Entry time",
    allFieldsAreRequiredAndNewGroupCannotBeInUse: "All fields are required and the new group cannot be in use",
    requestedSalaryIncreaseJustificationDetail: "Detail of the requested salary increase justification",
    newActionType: "New action type",
    processPublished: "Process published",
    doYouWantToDeleteTheAccumulator: "Do you want to delete the accumulator?",
    departmentalStructure: "Departmental structure",
    cannotDeleteThirdPartyClassificationBecauseItIsInUse:
        "Cannot delete third party classification because it is in use",
    noResponsibleAssigned: "No responsible assigned",
    authorizationAlreadyExistsForThisDay: "Authorization already exists for this day",
    sqlForContextManagement: "SQL for context management",
    deleteStudyType: "Delete study type",
    ofConcepts: "Of concepts",
    userTableEditors: "User table editors",
    areYouSureYouWantToDeleteSelected9BoxesClassificationRecords:
        "Are you sure you want to delete the selected 9-Boxes classification records?",
    selectedFileIsNotPdfFormat: "The selected file is not in .pdf format",
    totalLegalDeductions: "Total legal deductions",
    byDate: "By date",
    myScheduledShifts: "My scheduled shifts",
    createCalculationReference: "Create calculation reference",
    youMustSelectAtLeastOnePayroll: "You must select at least one payroll",
    publicationManagementCenters: "Publication management centers",
    importFamilyGroupTemplate: "Import family group template",
    jobId: "Job ID",
    startDiagrammingYourStructure: "Start diagramming your structure!",
    calibratedPotentialRating: "Calibrated potential rating",
    tableName: "Table name",
    massUploads: "Mass uploads",
    newGroupClassification: "New group classification",
    cannotDeleteClassificationTypeBecauseItIsInUse: "Cannot delete classification type because it is in use",
    selectSpecialActionYouWantToExecute: "Select the special action you want to execute",
    available: "Available",
    othersCanContainUpTo3Decimals: "Others can contain up to 3 decimals",
    fromTheSystem: "From the system",
    alertOrNoticeWithSameNameAndRecipientAlreadyExists:
        "An alert or notice with the same name and recipient already exists",
    acceptingTheEvaluationWillGenerateADocumentWithADigitalSignatureThatWillBeSavedInYourDigitalFolder:
        "Accepting the evaluation will generate a document with a digital signature that will be saved in your digital folder",
    cannotSelectYourself: "You cannot select yourself",
    calculationCondition: "Calculation condition",
    thousands: "Thousands",
    onboardingProcessUpdatedSuccessfully: "Onboarding process updated successfully",
    cannotHaveMoreThanOneQuerySharingSameCodeOrName:
        "There cannot be more than one query sharing the same code or name",
    accumulatorCode: "Accumulator code",
    createProvision: "Create provision",
    motivationalPotentialOfTheJobCanRangeFrom1To125: "The motivational potential of the job can range from 1 to 125.",
    reasonForDeletion: "Reason for deletion",
    createClassificationTypes: "Create classification types",
    youMustSelectAtLeastOneConcept: "You must select at least one concept",
    cannotMoveBecauseTreeHeightExceedsLimit: "Cannot move because the tree height exceeds the limit!",
    functionNameLong: "Function name",
    realEstateAppraisalRole: "Real estate appraisal role",
    createNewActionOrResponse: "Create new action or response",
    cannotExistValuesWithSameTypeStartDateAndEndDate:
        "Values with the same type, start date, and end date cannot exist",
    assignCollaborators: "Assign collaborators",
    conceptInputStructure: "Concept input structure",
    generalIndicesAndValues: "General indices and values",
    costCenterDesc5: "Cost center desc 5",
    annotationsRegistration: "Annotations registration",
    familyMemberTypes: "Family member types",
    doYouWantToDeleteTheFormatType: "Do you want to delete the format type?",
    familyMemberRecordDeletedSuccessfully: "Family member record deleted successfully",
    error: "Error.",
    byAccountAndConcept: "By account and concept",
    specifyObjectiveScale: "Specify objective scale",
    calibrationComments: "Calibration comments",
    specialClassifications: "Special classifications",
    weightedPeerEvaluation: "Weighted peer evaluation",
    functionWhenFinished: "Function when finished",
    youMustSelectASingleEmployee: "You must select a single employee",
    scheduledEntry: "Scheduled entry",
    expectedEntry: "Expected entry",
    realEntry: "Real entry",
    breakTime: "Break time",
    jobStructure: "Job structure",
    justificationCompletedSuccessfully: "Justification completed successfully",
    bankAndBankAccountFieldsCannotBeEmpty: "Bank and bank account fields cannot be empty",
    massTerminations: "Mass terminations",
    totalAssignedCollaborators: "Total assigned collaborators",
    evaluationDate: "Evaluation date",
    deleteCostCenter: "Delete cost center",
    lastUpdateDate: "Last update date",
    downloadR8DesktopVersion: "Download R8 desktop version",
    publicationChannelTypes: "Publication channel types",
    updateTime: "Update time",
    wasCalibrated: "Was calibrated",
    shiftChangeCompletedSuccessfully: "Shift change completed successfully",
    noCalibratedRecordsToUpdate: "No calibrated records to update",
    consentTypeString: "Consent type string",
    massShiftChanges: "Mass shift changes",
    massDivisionChanges: "Mass business unit changes",
    managementCenterChanges: "Mass publication center changes",
    newConceptGroupAlt: "New concept group",
    licenseCode: "License code",
    areYouSureYouWantToGeneratePermissionReceiptAlreadyApprovedByYouThatMustBeDigitallySignedByTheCollaboratorAndAfterSignatureReceiptWillBeSentByEmail:
        "Are you sure you want to generate a permission receipt already approved by you, which must be digitally signed by the collaborator, and after signature the receipt will be sent by email?",
    licenseType: "License type",
    evaluationPeriodShort: "Evaluation period",
    massTerminationsCompletedSuccessfully: "Mass terminations completed successfully",
    youSelectedTheHighestRatingJustifyWithYourCommentsPlease:
        "You selected the highest rating, please justify with your comments",
    attendanceAnalysis: "Attendance analysis",
    calibration: "Calibration",
    evaluationProcessCreatedSuccessfully: "Evaluation process created successfully",
    noOccupant: "(No occupant)",
    selectedCollaborators: "Selected collaborators:",
    relatedTableDeletedSuccessfully: "Related table deleted successfully",
    sqlRecipients: "SQL recipients",
    autocomplete: "Autocomplete",
    newOnboardingActionType: "New onboarding action type",
    byObjective: "By objective",
    completeFolder: "Complete folder",
    classificationCode: "Classification code",
    areYouSureYouWantToDeleteTheParameter: "Are you sure you want to delete the parameter?",
    noActionTypesFound: "No action types found",
    recordModifiedSuccessfully: "Record modified successfully",
    doYouWantToDeleteTheObjectiveType: "Do you want to delete the objective type?",
    scheduledBreak: "Scheduled break",
    competence: "Competence",
    planVisualization: "Plan visualization",
    cannotEditYourOwnAbsences: "You cannot edit your own absences",
    userAlertsAndNotices: "User alerts and notices",
    cannotExistMoreThanOneWorkplaceSharingSameCodeOrName:
        "There cannot be more than one workplace sharing the same code or name",
    cannotExceed23_59: "Cannot exceed 23:59",
    massRehire: "Mass rehire",
    costCenterAssignmentDate: "Cost center assignment date",
    elementWithNodeCodeAlreadyExists: "An element with the node code already exists!",
    doYouWantToRemoveObservationFromSelectedRecords: "Do you want to remove the observation from selected records?",
    processName: "Process name",
    massDepartmentStructureChange: "Mass department structure change",
    codeAlt: "Code",
    ascendingEvaluator: "Ascending evaluator",
    midnight: "0:00",
    saveStep: "Save step",
    moveToNewDate: "Move to new date",
    noDocumentTemplatesFound: "No document templates found",
    descendingEvaluation: "Descending evaluation",
    daysWithScheduleChange: "Days with schedule change",
    participation: "Participation",
    addCollaborator: "Add collaborator",
    conditionalConcept3: "Conditional concept 3",
    familyTypeString: "Family type string",
    cannotRunSameCalculationProcess2OrMoreTimesAtOnceTheSelectedCalculationProcessIsCurrentlyRunning:
        "Cannot run the same calculation process 2 or more times at once. The selected calculation process is currently running.",
    workgroup: "Workgroup",
    sep: "Sep",
    dropdownList: "Dropdown list",
    doYouWantToDeleteOnboardingStepForProfile: "Do you want to delete the onboarding step for the profile?",
    jobSpecificCompetencies: "Job specific competencies",
    myPersonal: "My PERSONAL",
    totalUsed: "Total used",
    recompositionOfHistoricalAccumulators: "Recomposition of historical accumulators",
    evaluatedCode: "Evaluated code",
    published: "Published",
    doYouWantToDeleteFileType: "Do you want to delete the file type?",
    noteStatus: "Note status",
    veryNegative: "Very negative",
    evaluatePersonalObjectivesQuestionMark: "Evaluate personal objectives?",
    aScheduleWithTheseDataAlreadyExists: "A schedule with these data already exists",
    valueOfEachPoint: "Value of each point",
    promoters: "Promoters",
    importLicenses: "Import licenses",
    areYouSureYouWantToDelete: "Are you sure you want to delete?",
    totalTaxableWages: "Total taxable wages",
    oneOfTheEnteredCollaboratorsIsAlreadyAssociatedWithTheProcess:
        "One of the entered collaborators is already associated with the process",
    legalDaysMustBeGreaterThanZero: "Legal days must be greater than zero",
    paid: "Paid",
    personalObjective2: "Personal objective 2",
    deleteImage: "Delete image",
    timeCalendar: "Time calendar",
    creationOfWagesAndDeductions: "Creation of wages and deductions",
    periodName: "Period name",
    enus: "en-US",
    evaluationNotes: "Evaluation notes",
    fileDescriptionText: "File description text",
    hoursToJustify: "Hours to justify",
    legalAndOtherBalance: "Balance (legal and others)",
    health: "Health",
    totalCompanyCost: "Total company cost",
    generalCommentsFromEvaluatorOrCalibrationCommittee: "General comments from evaluator or calibration committee",
    parameterDuplicatedSuccessfully: "Parameter duplicated successfully",
    upTo500CollaboratorsCanBeSelected: "Up to 500 collaborators can be selected",
    doYouWantToDeleteTheAbsence: "Do you want to delete the absence?",
    jan: "Jan",
    seniorityInYears: "Seniority in years",
    aug: "Aug",
    cannotDeleteSelectedStructuresBecauseTheyAreInUse: "Cannot delete selected structures because they are in use",
    competenceDuplicatedSuccessfully: "Competence duplicated successfully",
    duplicateQuestion: "Duplicate question",
    additionalOrProgressiveUsedDays: "Used days (additional or progressive)",
    costDistributionXlsx: "Cost distribution.xlsx",
    attention: "Attention",
    createPermission: "Create permission",
    collaboratorsWithPlannedStatus: "Collaborators with planned status",
    class: "Class",
    selectedRecordMustBeInState: "The selected record must be in state ",
    noRecipientFoundForYourRequestItCannotBeSentReportThisToHumanResources:
        "No recipient found for your request. It cannot be sent. Report this to Human Resources.",
    cannotDeleteOnboardingStageProfileBecauseItIsInUse: "Cannot delete onboarding stage profile because it is in use",
    cannotDeleteYourOwnVacations: "You cannot delete your own vacations",
    areYouSureYouWantToRunTheProcess: "Are you sure you want to run the process?",
    resolved: "Resolved",
    connectionRestored: "Connection restored",
    requestVacation: "Request vacation",
    noConnection: "No connection",
    requestPermission: "Request permission",
    requestLoan: "Request loan",
    newConcept: "New concept",
    evaluatePotential: "Evaluate potential",
    generateUsageCertificate: "Generate usage certificate",
    cannotHaveMoreThanOneReasonSharingSameCodeOrName: "Cannot have more than one reason sharing the same code or name",
    benefitTypeCreatedSuccessfully: "Benefit type created successfully",
    massContractChange: "Mass contract change",
    cannotAssignPositionBecauseNoVacancies: "Cannot assign position because there are no vacancies",
    addWithDataReplica: "Add with data replica",
    parameterListSelectorType: "Parameter list selector type",
    mustSelectAtLeastOneRecord: "Must select at least one record",
    mustSelectAtLeastOneSpecificRecord: "Must select at least one specific type record",
    scheduledTimeForToday: "Scheduled time for today",
    currentStartDate: "Current start date",
    totalCompanyCostWithCorporateBenefits: "Total company cost with corporate benefits",
    studyTypes: "Study types",
    responsibleAssignmentTime: "Responsible assignment time",
    areYouSureYouDoNotAuthorizeAnyOvertime00_00: "Are you sure you do not authorize any overtime (00:00)?",
    cannotDeleteVacationsBecauseTheyAreInUse: "Cannot delete vacations because they are in use",
    fromCommunicationChannel: "From communication channel",
    fromDataAnalytics: "From data analytics",
    SHOW_IA_QUERIES: "Activate AI queries",
    groupAppearanceSequence: "Group appearance sequence",
    publicationDeletedSuccessfully: "Publication deleted successfully",
    cannotDeletePostingBecauseItIsInUse: "Cannot delete posting because it is in use",
    indexWithSamePeriodAlreadyExists: "Index with same period already exists",
    search: "Search",
    deleteSchedule: "Delete schedule",
    mustSelectRecipient: "Must select recipient",
    municipalPatentRole: "Municipal patent role",
    riskCenter: "Risk center",
    establishmentCode: "Establishment code",
    establishmentType: "Establishment type",
    calibratedClassification: "Calibrated classification",
    paymentDateWillBeDeterminedByHR: "* Payment date will be determined by HR",
    cannotDeletePeriodBecauseItIsInUse: "Cannot delete period because it is in use",
    objectiveRatingScale: "Objective rating scale",
    noHiringDateRegistered: "No hiring date registered",
    absenceCreatedSuccessfully: "Absence created successfully",
    planDetail: "Plan detail",
    userName: "User name",
    authorizedOvertimes: "Authorized overtime",
    doYouWantToDeleteFeedbackPurpose: "Do you want to delete the feedback purpose?",
    hiringReason: "Hiring reason",
    allFieldsAreRequired: "All fields are required",
    doYouWantToDeletePosting: "Do you want to delete the postings?",
    alertOrNoticeCode: "Alert or notice code",
    noCompetenciesForThisGroup: "No competencies available",
    noCompetenciesForThisPosition: "No competencies for this position",
    createCompetencyWarning:
        'If the competency type is transversal, the group field will automatically be set to "Transversal"',
    addCompetencies: "Add competencies",
    viewIndicators: "View competencies for this group",
    viewIndicatorsPosition: "View competencies for this position",
    viewCompetenciesForThisPosition: "View competencies for their position",
    yourObjectiveRating: "Your objective rating",
    postingDeletedSuccessfully: "Posting deleted successfully",
    internalRecordCode: "Internal record code",
    startDiagrammingYourOrganizationalChart: "Start diagramming your organizational chart!",
    doYouWantToDeleteFamilyAssignment: "Do you want to delete the family assignment?",
    thisProcessTypeCannotBePublishedBecauseItIsSpecialOrSimulationProcess:
        "This process type cannot be published because it is a special or simulation process",
    evaluatesTransversalCompetencies: "Evaluates transversal competencies",
    transversalCompetency: "Transversal",
    specificCompetency: "Specific",
    transversalSingularCompetency: "Transversal",
    specificSingularCompetency: "Specific",
    doYouWantToDeleteFieldDefinitionFromTable: "Do you want to delete the field definition from the table?",
    totalReservedForFutureUse: "Total reserved for future use",
    cannotHaveMoreThanOneDefinitionWithSameSourceTableAndField:
        "Cannot have more than one definition with the same source table and field",
    maximum: "Maximum",
    selectedRecordCannotBeDeleted: "The selected record cannot be deleted",
    nameCode: "Name",
    documentPublications: "Document publications",
    benefitRequestProcessedSuccessfully: "Benefit request processed successfully",
    mustSelectAtLeastOneImage: "Must select at least one image",
    calibratedPerformanceFinalGrade: "Calibrated performance final grade",
    relatedTable: "Related table",
    mustSelectAtLeastOnePerformanceEvaluation: "Must select at least one performance evaluation",
    processDuration: "Process duration",
    forNpsSurveyTypeOnly1QuestionWithOptionsCanBeCreatedContainingOptionsFrom1To10:
        "For NPS survey type only 1 question with options can be created containing options from 1 to 10",
    indicatorCreatedSuccessfully: "Indicator created successfully",
    areYouSureYouWantToDeleteQueryDefinition: "Are you sure you want to delete the query definition?",
    alertOrNoticeOrigin: "Alert or notice origin",
    attendanceMarkCreatedSuccessfully: "Attendance mark created successfully",
    cannotHaveMoreThanOneCalculationReferenceSharingSameCodeOrName:
        "Cannot have more than one calculation reference sharing the same code or name",
    weightedObjectives: "Weighted objectives",
    deleteSpecialization: "Delete specialization",
    classificationTypeDeletedSuccessfully: "Classification type deleted successfully",
    reasonCreation: "Reason creation",
    doYouWantToDeleteSelectedRows: "Do you want to delete the selected rows?",
    mydesktop: "MyDesktop",
    executionStartDate: "Execution start date",
    entryDate: "Entry date",
    mustSelectOnlyOneConcept: "Must select only one concept",
    generalValuesXlsx: "General values.xlsx",
    toCreateAnActionOrResponseYouMustBeResponsibleForTheAttentionIfRequiredAssignYourselfAsTheResponsibleFirst:
        "To create an action or response you must be responsible for the attention. If required, assign yourself as responsible first.",
    activeStatus: "Status: Active",
    canReceiveRequestsAffirm: "Can receive requests",
    ctrlfToSearchTextWithinTrace: "Ctrl+F to search text within the Trace",
    paymentDate: "Payment date",
    sexString: "Sex string",
    surveyComparison: "Survey comparison",
    doYouWantToDeleteActionType: "Do you want to delete the action type?",
    authorizedOvertimeHours: "Authorized overtime hours",
    cannotDeleteFamilyAssignmentBecauseItIsInUse: "Cannot delete family assignment because it is in use",
    generateFieldNamesForQueries: "Generate field names for queries",
    onboardingProfileUpdatedSuccessfully: "Onboarding profile updated successfully",
    onboardingStatus: "Onboarding status",
    formDesignName: "Form design name",
    saveAlt: "Save",
    delegationCreation: "Delegation creation",
    unions: "Unions",
    loanTypeAlt: "Loan type",
    viewUnpostedConcepts: "View unposted concepts",
    sourceFieldName: "Source field name",
    whatsappTemplates: "WhatsApp templates",
    workplaceAlt: "Workplace",
    authorizedOvertimeHoursLong: "Authorized overtime hours",
    noProjectsFound: "No projects found",
    incomeStructure: "Income structure",
    publicationUpdatedSuccessfully: "Publication updated successfully",
    statusTranslated: "Status",
    doubleClickInBlankSpaceToCreateAuthorizationForOvertime:
        "Double-click in blank space to create authorization for overtime",
    quadrantFeatures: "Quadrant features",
    acceptScheduleChangeRequest: "Do you accept the schedule change request?",
    canOnlyDeleteRecordWhen: "Can only delete record when",
    evaluatorSelectionWithFreeSelection: "Evaluator selection with free selection",
    ufOfTheDay9: "UF of the day 9",
    evaluatorPosition: "Evaluator position",
    updateCompletedSuccessfully: "Update completed successfully",
    valueUntilIcon2: "Value until Icon 2",
    referenceColumnNumbers: "Reference column numbers",
    accessMode: "Access mode",
    createConceptGroup: "Create concept group",
    evaluationsByObjectiveDifferences: "Evaluations by objective (differences)",
    deleteFileType: "Delete file type",
    cannotDeleteScheduleBecauseItIsInUse: "Cannot delete schedule because it is in use",
    planned: "Planned",
    edit9boxClassification: "Edit 9-box classification",
    globalAveragesOfEvaluationsByGradeType: "Global averages of evaluations by grade type",
    definitionOfSpecialProcesses: "Definition of special processes",
    oct: "Oct",
    columnSelectorTypes: "Column selector types",
    cannotDeleteThirdPartyBecauseItIsInUse: "Cannot delete third party because it is in use",
    cannotSelectSelfEvaluationToAssignEvaluatorsBecauseEvaluatorWillBeTheCollaborator:
        "Cannot select self-evaluation to assign evaluators because the evaluator will be the collaborator",
    scheduleWithSameCodeOrNameAlreadyExists: "Schedule with same code or name already exists",
    quadrantName: "Quadrant name",
    amount: "Amount",
    survey: "Survey",
    approvedRequestRememberToSaveChanges: "Request approved, remember to save changes",
    onboardingStartDate: "Onboarding start date",
    kpiDefinitionCreatedSuccessfully: "KPI definition created successfully",
    newMedicalLeaveType: "New medical leave type",
    selectedCompetenciesMustBeSpecificType: "Selected competencies must be of Specific type",
    feedbackDate: "Feedback date",
    exportTemplateForImport: "Export template for import",
    motivatorPotential1To125: "Motivator potential (1 to 125)",
    decimals0To5: "Decimals (0 to 5)",
    performanceFormCreatedSuccessfully: "Performance form created successfully",
    assignToOnboardingProcess: "Assign to onboarding process",
    planWithSameCodeAndNameAlreadyExists: "A plan with the same code and name already exists",
    mustSelectAtLeastOneRole: "You must select at least one role",
    doYouWantToDeleteMedicalLeaveType: "Do you want to delete the medical leave type?",
    performanceEvaluationProcessStart: "Start of the performance evaluation process",
    hasRequestWithPendingDocumentationForApprovalInProcess:
        "There is a request with pending documentation for approval in process",
    bulkFileUploadInDigitalFolder: "Bulk file upload in digital folder",
    setName: "Set name",
    mustCompleteAllValues: "You must complete all values",
    dom: "Dom",
    before: "Before",
    inactiveEditor: "Inactive editor",
    informativeGraphics: "Informative graphics",
    entryHelp: "Entry help",
    noGroupClassificationsFound: "No group classifications found",
    kpiDescriptionText: "KPI descriptive text",
    bronzeMedals: "Bronze medals",
    usesConfetti: "Uses confetti",
    sqlForLevel2GraphicsTitleOptional: "SQL for Level 2 graphics title (optional)",
    doYouWantToDeleteConsent: "Do you want to delete the consent?",
    channelTypeIsInUseInApplicantMaster: "The channel type is in use in the Applicant Master",
    highlightByTags: "Highlight by tags",
    gridTableMenuOrAssociatedQuery: "Grid, table, menu or associated query",
    jobGroup: "Job group",
    employeeCodeChange: "Employee code change",
    veryPositive: "Very positive",
    newInstallmentIncome: "New installment income",
    enteredValueCannotBeGreaterThanTotalOvertime: "Entered value cannot be greater than total overtime",
    youCanSelectEvaluatorFreely: "You can freely select the evaluator.",
    conceptUpdatedSuccessfully: "Concept updated successfully",
    performanceGood2: "2 Good performance",
    notification: "Notification",
    newCalculationReference: "New calculation reference",
    legalVacationsAndOthers: "Legal vacations and others",
    toBeUsedInTheFutureLegalAndOthers: "To be used in the future (legal and others)",
    sourceField: "Source field",
    workplaceDeletedSuccessfully: "Workplace deleted successfully",
    bankString: "Bank string",
    millions: "Millions",
    euro: "Euro",
    companyCost: "Company cost",
    prepay: "Prepay",
    extraHoursToAuthorize: "Extra hours to authorize",
    locationGroup: "Location group",
    documentationType: "Documentation type",
    communicationAssignedToAnotherEmployer: "The communication is already assigned to another employer",
    noSpecializationsFound: "No specializations found",
    cannotEditThisRecordBecauseNoEditPermission: "Cannot edit this record because you have no edit permission",
    genericReference1: "Generic reference 1",
    massiveFamilyGroupUpload: "Massive family group upload",
    costCenterDesc: "Cost center description",
    conceptInUseInOtherTables: "Concept is in use in other tables.",
    incomeStructuresOfConcepts: "Income structures of concepts",
    massiveHolidaysAndFestiveDaysDuplication: "Mass duplication of holidays and festive days",
    cannotDeleteClassificationBecauseInUse: "Cannot delete classification because it is in use",
    totalExtras: "Total extras",
    familyAllowanceCreatedSuccessfully: "Family allowance created successfully",
    jobGroupsForEvaluations: "Job groups for evaluations",
    approvingProcessAndPassingItToHistoryMeansNoRecalculations:
        "Approving a process and passing it to history means no recalculations or alterations can be made.",
    positionAssignmentDateAlt: "Position assignment date",
    timeDefinition: "Time definition",
    recomposePositions: "Recompose positions",
    collaboratorsInPlans: "Collaborators in plans",
    cannotHaveValuesWithSameTypeSeniorityFromAndUntil:
        "Cannot have values with same Type, Seniority From and Seniority Until",
    standardPerformanceNumericScore: "Standard performance numeric score",
    organizationChartPdf: "OrganizationChart.pdf",
    duplicateHolidaysAndFestiveDays: "Duplicate holidays and festive days",
    programmingStatus: "Programming status",
    projectsAndWorks: "Projects and works",
    specificCompensationWeights: "Specific compensation weights",
    absenceHours: "Absence hours",
    anotherNodeWithSameCodeExists: "Another node with the same code exists.",
    loans: "Loans",
    cannotHaveMoreThanOneShiftWithSameCodeOrName: "Cannot have more than one shift with the same code or name",
    cannotEditOwnPermissions: "Cannot edit your own permissions",
    view: "View",
    executionTime: "Execution time",
    mustSelectACalendar: "You must select a calendar",
    deleteReason: "Delete reason",
    unionCreation: "Union creation",
    potential: "Potential",
    numericEdit: "Numeric edit",
    icon2MinimumValue: "Icon 2 minimum value",
    removeObservationFromReviewedRecords: "Remove observation from reviewed records",
    reset: "Reset",
    onboardingProfileCreatedSuccessfully: "Onboarding profile created successfully",
    newPaymentMethod: "New payment method",
    compensation: "Compensation",
    habAndDescConceptsSetXlsx: "Hab. and Desc. - Concept set.xlsx",
    functionOnStart: "Function on start",
    processApprovalSavesDataInHistoryForFutureQueriesAndUpdatesCalculations:
        "Process approval will save all data in history for future queries and update accumulators essential for subsequent calculation processes. A process in historic status will only allow: consulting the process results, accessing its dashboard, and issuing payslips, but will NOT allow recalculations.",
    noOnboardingActionTypesFound: "No onboarding action types found",
    cannotHaveFunctionsWithSameName: "Functions with the same name cannot exist",
    functionDefinition: "Function definition",
    duplicatePayrollType: "Duplicate payroll type",
    fromAlt: "From",
    specializationCreation: "Specialization creation",
    evaluatedFunction: "Evaluated function",
    treeStructure: "Tree structure",
    activeEditor: "Active editor",
    standardPotentialFinalScore: "Standard potential final score",
    toDefinePaymentConceptLinkedToBenefitValueOfBenefitMustBeGreaterThanZero:
        "To define a remunerative payment concept linked to a benefit, the benefit value must be greater than zero",
    executionDateUntil: "Execution date until",
    canReceiveRequestsQuestionMarks: "Can receive requests?",
    groupClassificationCreation: "Group classification creation",
    licenseCreatedSuccessfully: "License created successfully",
    minimumWage: "Minimum wage",
    alphanumericNotEligibleAsMarker: "Alphanumeric and not eligible as marker",
    familyAllowanceDeletedSuccessfully: "Family allowance deleted successfully",
    cannotDeleteConceptSetBecauseInUse: "Cannot delete concept set because it is in use",
    esES: "es-ES",
    addAtLeastOneStep: "Add at least one step",
    consentReceived: "Consent received",
    canOnlyRequestEvaluatorsWithPendingPerformanceState:
        "You can only request evaluators to perform ratings when the performance state is Pending",
    ranking: "Ranking",
    costCenterCreation: "Cost center creation",
    toCreateCollaboratorsOrDeleteThemProcessMustBeOpen:
        "To create or delete collaborators in the process, you must first change the process status from “Closed” to “Open”",
    assignedToResponsible: "Assigned to responsible",
    dataGridSortingFields: "Fields for sorting data grid",
    occupiedPositions: "Occupied positions",
    conceptDuplicatedSuccessfully: "Concept duplicated successfully",
    numericScore: "Numeric score",
    formEvaluatorType: "Form evaluator type",
    application: "Application",
    geoanalysisQueryDefinitionModifiedSuccessfully: "Geoanalysis query definition modified successfully",
    acceptOrObjectEvaluation: "Accept or object evaluation",
    thankYouForAcceptingConsent: "Thank you very much for accepting the consent",
    noQueryAssociatedWithThisProcess: "No query associated with this process",
    periodCreatedSuccessfully: "Period created successfully",
    weightedSumMustBe100: "Weighted sum must be 100",
    destinationCodeField: "Destination code field",
    wantToDeleteProcessSchedule: "Do you want to delete the process schedule?",
    inFeedback: "In feedback",
    unionUpdatedSuccessfully: "Union updated successfully",
    competenciesWeighted: "Competencies weighted",
    queryCode: "Query code",
    specificEmails: "Specific emails",
    loanUpdatedSuccessfully: "Loan updated successfully",
    dailyContractHours: "Daily contract hours",
    forMassTerminationsYouMustSelectOnlyActiveCollaborators:
        "For mass terminations you must select only active collaborators",
    templateCreation: "Template creation",
    calendarCreatedSuccessfully: "Calendar created successfully",
    publicationDateFrom: "Publication date from",
    costCenterString: "Cost center string",
    cannotCalibrateCompetencyIndicatorBecauseItDoesNotCorrespondToEvaluation:
        "Cannot calibrate competency indicator because it does not correspond to its evaluation",
    objectivesByEvaluation: "Objectives by evaluation",
    extraHoursAuthorizationXlsx: "Extra hours authorization.xlsx",
    cannotExistMoreThanOnePaymentMethodWithSameCodeOrName:
        "More than one payment method with the same code or name cannot exist",
    inProgress: "In progress",
    competenciesVsObjectivesRatings: "Competencies vs. objectives ratings",
    jobGroupForEvaluationCreatedSuccessfully: "Job group for evaluation created successfully",
    weightedScores: "Weighted scores",
    newPermissionType: "New permission type",
    userMenuDefinition: "User menu definition",
    evaluation: "Evaluation",
    bronzeShield: "Bronze shield",
    periodUpdatedSuccessfully: "Period updated successfully",
    free: "Free",
    superiorPosition: "Superior position",
    employeeType: "Employee type",
    geoanalysisQueriesDefinition: "Geoanalysis queries definition",
    corporateBenefitsTotalCorporateBenefits: "Total corporate benefits",
    departmentCode: "Department code",
    groupEditedSuccessfully: "Group edited successfully",
    recordDeletedSuccessfully: "Record deleted successfully",
    dateType: "Date",
    errorEditingNodeOccurred: "An error occurred editing the node.",
    peerEvaluation: "Peer evaluation",
    initialLoadTime: "Initial load time",
    planMaximumBudget: "Plan maximum budget",
    noModifiedDataToSave: "No modified data to save",
    toDefineAccessModeWithFreeDispositionCannotHavePointsOrAuthorizedAbsenceDaysOrRelatedPaymentConcept:
        "To define access mode with free disposition, it cannot have points, authorized absence days, or related payment concepts",
    descendantEvaluator: "Descendant evaluator",
    missing: "Missing",
    forFinalResultOfPerformanceEvaluation: "For the final result of the performance evaluation",
    cannotHaveGroupsWithSameName: "Groups with the same name cannot exist",
    earnedDays: "Earned days",
    costCenter4: "Cost center 4",
    variableCodesContainsCalculationProcessCodesToBeDeleted:
        "Variable #CODES# contains calculation process codes to be deleted",
    normal: "Normal",
    withDigitalSignature: "With digital signature",
    classification: "Classification",
    specializationUpdatedSuccessfully: "Specialization updated successfully",
    selectedRecordCannotBeEdited: "Selected record cannot be edited",
    group12: "Group 12",
    attendanceAnalysisSheet: "Attendance analysis sheet",
    changeProjectOrWork: "Change project or work",
    finalPotentialScoreAlternative: "Final potential score",
    hasPendingPinRecoveryInProcess: "You already have a PIN recovery in process.",
    objectivesWeighted: "Objectives weighted",
    thirdPartyCreation: "Third party creation",
    consentTypeCreation: "Consent type creation",
    globalPerformanceAverage: "Global performance average",
    finalSummary: "Final summary",
    newWorkplace: "New workplace",
    valueUntilIcon1: "Value until Icon 1",
    noWorkplacesFound: "No workplaces found",
    jobGroupsForEvaluationsCreation: "Job groups creation for evaluations",
    performancePointsUntilFor9Boxes3: "Performance points until for 9-Boxes 3",
    talentClassification9boxes: "Talent classification (9-Boxes)",
    requiresBank: "Requires bank",
    seat: "Seat",
    pending: "Pending",
    contractor: "Contractor",
    goldMedal: "Gold medal",
    historicalCostDistribution: "Historical cost distribution",
    jobClassificationCreatedSuccessfully: "Job classification created successfully",
    templateCreatedSuccessfully: "Template created successfully",
    highlightPositionsWithVacancies: "Highlight positions with vacancies",
    loanInstallments: "Loan installments",
    workplaceCreatedSuccessfully: "Workplace created successfully",
    createPeriodForObjectives: "Create period for objectives",
    reference1: "Reference 1",
    valueFromClock: "Value from clock",
    competenciesAverage: "Competencies average",
    mobile: "Mobile",
    costCenterCreatedSuccessfully: "Cost center created successfully",
    cannotDisableEditorCreationForSelectedSystemTableBecauseEditorsExist:
        "Cannot disable editor creation for the selected system table because one or more editors already use it. You must delete existing editors before disabling.",
    paymentMethodString: "Payment method string",
    modificationOnly: "Modification only",
    totalExtraHours: "Total extra hours",
    enterLocationToGetCoordinates: "Enter location to get coordinates",
    digitalWarehouseFileTypeCreation: "Digital warehouse file type creation",
    calendarUpdatedSuccessfully: "Calendar updated successfully",
    amountToPay: "Amount to pay",
    documentWithDigitalSignatureAlreadyPublishedUsingSelectedTemplateSelectAnotherOrGenerateNewTemplateCodeForDocument:
        "A document published with a digital signature already uses the selected template. Please select another or generate a new template code for this document.",
    closingDate: "Closing date",
    healthInstitutionUpdatedSuccessfully: "Health institution updated successfully",
    youCannotAuthorizeYourOwnOvertime: "You cannot authorize your own overtime",
    relatedTableCreatedSuccessfully: "Related table created successfully",
    dayAndMonthOfExecutionYear: "Day and month of execution year",
    awardsAndPromotion: "Awards and promotion",
    scaleTypeCode: "Scale type code",
    replicate: "Replicate",
    classificationTypeCreatedSuccessfully: "Classification type created successfully",
    exportFamilyGroupTemplate: "Export family group template",
    processScheduleUpdatedSuccessfully: "Process schedule updated successfully",
    averageRanking: "Average ranking",
    noUnionsFound: "No unions found",
    accountingEntryForExport: "Accounting entry for export",
    simple: "Simple",
    actionRegistrationDate: "Action registration date",
    paidInstallments: "Paid installments",
    nameCannotBeModifiedBecauseItIsUsedInConceptFormulasOrFunctions:
        "Name cannot be modified because it is used in concept formulas or functions",
    redFemale: "Red (female)",
    onboardingActionTypes: "Onboarding action types",
    calculationTerminationReason: "Calculation termination reason",
    toDeleteEvaluatedAndEvaluatorRecordsTheSelectedRecordsMustBeOfTheSameEvaluationType:
        "To delete evaluated and evaluator records, the selected records must be of the same evaluation type",
    inProgressAlternative: "In progress",
    digitalizationOptions: "Digitalization options",
    createHistoricalAccumulator: "Create historical accumulator",
    totalAdditionalVacation: "Total additional vacation",
    entry: "Entry",
    withSignature: "With signature",
    noKpiQueriesAvailable: "No KPI queries available",
    requestDeletion: "Request deletion",
    highlightByCompetencyGroup: "Highlight by competency group",
    schedule: "Schedule",
    unauthorizedOvertimeShort: "Unauthorized OT",
    partialViewVisibleToCollaboratorsInTheirAccessGroups:
        "PARTIAL VIEW - Visible to collaborators in their access groups",
    employersUppercase: "EMPLOYERS",
    previewTemplate: "Preview template",
    pleaseEnterCodeAndNameOfPayrollTypeThisDataWillReplaceOriginals:
        "Please enter the payroll type code and name. This data will replace the originals.",
    changeDepartmentalStructure: "Change departmental structure",
    wantToDeleteJobGroupForEvaluation: "Do you want to delete the job group for evaluation?",
    cannotHaveMoreThanOneActionTypeWithSameCodeOrName:
        "More than one action type with the same code or name cannot exist",
    deletePermissionType: "Delete permission type",
    cannotDeletePayrollTypeBecauseItIsInUse: "Cannot delete payroll type because it is in use",
    onboarding: "Onboarding",
    reference2: "Reference 2",
    standardClassification: "Standard classification",
    workOrProject: "Work or project",
    noAccessToPermissionManagement: "No access to permission management",
    evaluatesOrganizationObjectives: "Evaluates organization objectives",
    scheduleCreatedSuccessfully: "Schedule created successfully",
    receiptNumber: "Receipt number",
    noteNameCannotExceed60Characters: "Note name cannot exceed 60 characters",
    benefitsUsageDetail: "Benefits usage detail",
    performanceEvaluationCalibration: "Performance evaluation calibration",
    previredCode: "Previred code",
    cannotDeleteCompetencyBecauseItIsInUse: "Cannot delete competency because it is in use",
    hours: "Hrs.",
    selectEvaluationTypesToIncludeInFormAndTheirWeights: "Select evaluation types to include in form and their weights",
    visible: "Visible",
    viewWithIndicators: "View the skills for the group",
    viewWithIndicatorsPosition: "View the skills for the position",
    wantToSendEvaluatorsMessageIndicatingStartOfPerformanceEvaluationProcess:
        "Do you want to send the selected evaluators a message indicating the start of the performance evaluation process and that they can begin their ratings?",
    ifYouDeleteAnOnboardingStageProfileAllItsStepsWillBeDeletedAreYouSureYouWantToDeleteIt:
        "If you delete an onboarding stage profile, all its steps will also be deleted. Are you sure you want to delete it?",
    onboardingStartDateAlt: "Onboarding start date",
    publishOnWall: "Publish on wall",
    evaluationProcessDuplicatedSuccessfully: "Evaluation process duplicated successfully",
    searchInFormulas: "Search in formulas",
    periodString: "Period string",
    healthInstitutionDeletedSuccessfully: "Health institution deleted successfully",
    payrollsAndHistories: "Payrolls and histories",
    globalPotentialAverageByEvaluation: "Global potential average by evaluation",
    wantToDeleteIndicator: "Do you want to delete the indicator?",
    conditionalConcept2: "Conditional concept 2",
    bold13pxArial: "bold 13px Arial",
    neutralMale: "Neutral",
    sqlForKpiTitleRequiredForAllKpi: "SQL for KPI title (Required for all KPIs)",
    quadrant: "Quadrant",
    totalTaxableIncome: "Total taxable income",
    evaluationProcessCode: "Evaluation process code",
    publicCommentForAction: "Public comment for action:",
    downloadSurveySummary: "Download survey summary",
    reportedValueType: "Reported value type",
    areYouSureYouWantToDeleteThePerformanceForm: "Are you sure you want to delete the performance form?",
    discountPeriod: "Discount period",
    cannotDeleteProjectBecauseItIsInUseAlt: "Cannot delete the project because it is in use",
    wantToDeleteShift: "Do you want to delete the shift?",
    completed: "Completed",
    createAbsenceTypes: "Create absence types",
    cannotDeletePrevisionInstitutionBecauseItIsInUse: "Cannot delete the prevision institution because it is in use",
    incomeStructures: "Income structures",
    helpText: "Help text",
    objectiveScaleType: "Objective scale type",
    createThirdParty: "Create third party",
    attendanceMarkDeletedSuccessfully: "Attendance mark deleted successfully",
    withReception: "With reception",
    paymentToThirdParties: "Payment to third parties",
    editorsCanDeleteTableRecords: "Can editors delete table records?",
    modifyTable: "Modify table",
    createTable: "Create table",
    disabled: "Disabled",
    updateObservations: "Update observations",
    noClassificationTypesFound: "No classification types found",
    deleteHealthInstitution: "Delete health institution",
    judicialRetention: "Judicial retention",
    fieldsForDataFilterInGrid: "Fields for data filtering in grid",
    deleteProcessSchedule: "Delete process schedule",
    typeString: "Type string",
    calibratedPerformanceFrom9boxes1A3: "Calibrated performance from 9-Boxes (1 to 3)",
    daysToUseInFutureLegalAndOther: "Days to use in future (legal and others)",
    myPlannedActions: "My planned actions",
    sqlForLevel2ChartsHorizontalVerticalPieOrLine: "SQL for Level 2 Charts (Horizontal, Vertical, Pie or Line)",
    tableControlField: "Table control field",
    employeePhoto: "Employee photo",
    actionName: "Action name",
    mustSelectARecord: "You must select a record",
    cannotHaveMoreThanOneThirdPartyClassificationWithSameCodeOrName:
        "There cannot be more than one third-party classification with the same code or name",
    wantToDeleteGroupClassification: "Do you want to delete the group classification?",
    cannotDeleteBenefitForHistoricalPlan: "Cannot delete benefit for historical plan",
    salaryGrade1a: "Salary Grade 1-A",
    databaseCatalog: "Database catalog",
    consultEmployeesNotParticipatingInProcess: "Consult employees not participating in the process",
    benefit: "Benefit",
    competencyScaleType: "Competency scale type",
    entryAttendancePlace: "Entry attendance place",
    wantToDeletePermissionType: "Do you want to delete the permission type?",
    ifYouWantToIncludeSQLDataInEmailBodyCheck: "If you want to include SQL display data in the email body, check",
    maxRatingsQtyNoDot: "Max ratings quantity",
    interviewAndFeedback: "Interview and feedback",
    endOfScheduledBreak: "End of scheduled break",
    wantToDeleteThirdParty: "Do you want to delete the third party?",
    competencyGroup: "Competency group",
    classificationUpdatedSuccessfully: "Classification updated successfully",
    maximumRatings: "Maximum ratings",
    areYouSureYouWantToDeleteVacationPeriod: "Are you sure you want to delete the vacation period?",
    authorizeOvertime: "Authorize overtime",
    thirdPartyClassificationCreatedSuccessfully: "Third party classification created successfully",
    wantToDeleteRecord: "Do you want to delete the record?",
    organizationalObjectives: "Organizational objectives",
    massAssignmentToOnboardingProcessCompletedSuccessfully:
        "Mass assignment to onboarding process completed successfully",
    familyUpdatedSuccessfully: "Family updated successfully",
    scheduledHours: "Scheduled hours",
    cannotHaveMoreThanOneSpecializationWithSameCodeOrName:
        "There cannot be more than one specialization with the same code or name",
    specificCompetency1OfJob: "Specific competency 1 of the job",
    specificCompetency2OfJob: "Specific competency 2 of the job",
    cannotDeleteValuesBecauseSelectedValuesAreInUse: "Cannot delete values because the selected values are in use",
    cannotHaveConceptsWithSameCode: "Concepts cannot have the same code",
    absenceManagement: "Absence management",
    clearCopiedData: "Clear copied data",
    downloadDocument: "Download document",
    evaluated: "Evaluated",
    documentGeneratedSuccessfullyAndSentToEmployeeDigitalFolder:
        "Document generated successfully and sent to employee digital folder",
    superiorPositionId: "Superior position ID",
    cannotDeleteIndicatorBecauseItIsInUse: "Cannot delete indicator because it is in use",
    fieldComment: "Field comment",
    deleteAccumulator: "Delete accumulator",
    thisDocumentTypeRequiresMultipleApproversOrSigners: "This document type requires multiple approvers or signers.",
    calibratedPotential9boxes: "Calibrated potential 9-Boxes",
    awardDelivery: "Award delivery",
    performanceEvaluationCalibratedSuccessfully: "Performance evaluation calibrated successfully",
    add: "Add",
    noAbsenceTypesFound: "No absence types found",
    evaluatePotentialQuestionMark: "Evaluate potential?",
    last10Years: "Last 10 years",
    viewVisualizationTree: "View visualization tree",
    responsibleAssigner: "Responsible assigner",
    redeemedPoints: "Redeemed points",
    purposeCode: "Purpose code",
    areYouSureYouWantToDeleteTemplate: "Are you sure you want to delete the template?",
    employeeAnnotations: "Employee annotations",
    specialProcessWithSameNameOrCodeAlreadyExists: "A special process with the same name or code already exists",
    valuesByConcept: "Values by concept",
    editSchedule: "Edit schedule",
    incomeInInstallments: "Income in installments",
    checkThatRatingValuesAreInAscendingOrder: "Check that rating values are in ascending order",
    absenceTypeString: "Absence type string",
    balance: "Balance",
    lastUpdateTime: "Last update time",
    stepAndStageReview: "Step and stage review",
    bankRequiredForPaymentMethod: "Bank is required for the payment method",
    periodUntil: "Period until",
    myActionsAndReminders: "My actions and reminders",
    descriptiveAdditions: "Descriptive additions",
    deleteLoan: "Delete loan",
    specialActions: "Special actions",
    ageGroup: "Age group",
    originalConceptCode: "Original concept code",
    columnSelectorForEachSQLColumnType: "Column selector for each SQL column type",
    ddmmyyyyHhmm: "DD-MM-YYYY hh:mm",
    attendanceMark: "Attendance mark",
    numericRatingValue: "Numeric rating value",
    additionalOrProgressiveBalance: "Additional or progressive balance",
    cannotDeleteObjectiveTypeBecauseInUseInEmployeeGoals:
        "Cannot delete objective type because it is used in employee goals",
    silverMedal: "Silver medal",
    incomeBySociety: "Income by society",
    thirdPartyClassificationDeletedSuccessfully: "Third-party classification deleted successfully",
    geoanalysisQueryDuplicatedSuccessfully: "Geoanalysis query duplicated successfully",
    cannotHaveMoreThanOneObjectiveTypeWithSameCodeOrName:
        "There cannot be more than one objective type with the same code or name",
    pointsAndRedemptionScheme: "Points and redemption scheme",
    potentialIndicator9boxes: "Potential indicator 9-Boxes",
    wantToDeleteProject: "Do you want to delete the project?",
    evaluationEndDate: "Evaluation end date",
    generateReceipt: "Generate receipt",
    noObjectives: "No objectives",
    competencyDescription: "Competency description",
    assistant: "Assistant",
    dic: "Dec",
    enterPositionName: "Enter position name",
    entryDateAlt: "Entry date",
    usageManual: "User manual",
    noCommonQuestionsBetweenSelectedSurveys: "No common questions between the selected surveys",
    earningsAndDeductionsBySocietyxlsx: "Income and Deductions - By society.xlsx",
    ofBenefits: "Of benefits",
    keyField: "Key field",
    historicalAccumulators: "Historical accumulators",
    userCodeThatBlocked: "User code that blocked",
    geoanalysisQueryCreatedSuccessfully: "Geoanalysis query created successfully",
    hiringType: "Hiring type",
    conceptToProcess: "Concept to process",
    massiveCostCenterChange: "Massive cost center change",
    thisDocumentTypeDoesNotRequireThisField: "This document type does not require this field",
    projectCreatedSuccessfully: "Project created successfully",
    cannotDeleteHealthInstitutionBecauseInUse: "Cannot delete health institution because it is in use",
    administrator: "Administrator",
    gatheringInformation: "Gathering information",
    onboardingProcess: "Onboarding process",
    lastRecognitionDate: "Last recognition date",
    receptionDate: "Reception date",
    sqlForChartsHorizontalVerticalPieLinePolarOrRadar:
        "SQL for charts (Horizontal, Vertical, Pie, Line, Polar or Radar)",
    potentialScaleType: "Potential scale type",
    overtimeTypesDefinition: "Overtime types definition",
    cannotDeleteSpecializationBecauseInUse: "Cannot delete specialization because it is in use",
    assignEvaluator: "Assign evaluator",
    toUseInFutureAdditionalOrProgressive: "To use in future (additional or progressive)",
    specifyObjectivesToEvaluate: "Specify objectives to evaluate",
    workShiftType: "Work shift type",
    dropdownAndNotEligibleAsMarker: "Dropdown and not eligible as marker",
    massRehireCompletedSuccessfully: "Mass rehire completed successfully",
    massRehireWithDeleteCompletedSuccessfully:
        "Mass rehire completed successfully. Checking accounts have also been closed.",
    rehireWithVacationLine1:
        'Do you want to DELETE the "current balances for vacation, loan, and permission" for the employee or employees you are rehiring, or do you want to KEEP them?',
    rehireWithVacationLine2:
        "If the new contract is a continuation of the previous one, they should be retained; otherwise, the entire history of the current balances should be deleted.",
    feb: "Feb",
    keepHistory: "Keep",
    fileTypeName: "File type name",
    mustSelectNextSigner: "You must select the next signer",
    noSurveysFoundForSelectedFilters: "No surveys found for the selected filters",
    accumulators: "Accumulators",
    viewRole: "View role",
    youHaveModifiedFamilyGroupAndEmployeeExistsInCurrentCalculationProcessReprocessingIsRequired:
        "You have modified the family group and the employee exists in a current calculation process; reprocessing is required",
    forecastInstitutionCreatedSuccessfully: "Forecast institution created successfully",
    maximumPossibleScore: "Maximum possible score",
    changeEmployeeCode: "Change employee code",
    myEvaluators: "My evaluators",
    permissionManagement: "Permission management",
    calibrationStartDate: "Calibration start date",
    aJobWithSameIdAlreadyExists: "A job with the same ID already exists",
    editNumericWith2Decimals: "Edit numeric with 2 decimals",
    youCannotEditYourOwnOvertime: "You cannot edit your own overtime",
    modifiedEntrySuccessfully: "Entry modified successfully",
    timeManagementSettings: "Time management settings",
    deleteUnion: "Delete union",
    createSigner: "Create signer",
    forMultipleEmailsSeparateWith: "For multiple emails separate with ;",
    importAbsences: "Import absences",
    indicateFormTypeAndItsWeightings: "Indicate the form type and its weightings",
    formCode: "Form code",
    treeStructureWithRightShift: "Tree structure with right shift",
    noPublicationsGeneratedYet: "No publications generated yet",
    verifyThatAllFieldsAreComplete: "Verify that all fields are complete",
    allocationPeriod: "Allocation period",
    deleteConcept: "Delete concept",
    wantToDeleteUserMenu: "Do you want to delete the user menu?",
    dateValue: "Date value",
    cannotHaveMoreThanOneGeoanalysisQueryWithSameCodeOrName:
        "There cannot be more than one geoanalysis query with the same code or name",
    searchEmployee: "Search employee",
    payrollTypeCode: "Payroll type code",
    processStages: "Process stages",
    months: "Months",
    response: "Response",
    earningsDeletedSuccessfully: "Earnings deleted successfully",
    target: "Target",
    catalogTableCode: "Catalog table code",
    institutionCode: "Institution code",
    all: "All",
    totalDiscounts: "Total discounts",
    organizationGoal1: "Organization goal 1",
    mondayShort: "Mon",
    coWorkersSameGroupsSameManagementSameFunctionOrSharingSamePosition:
        "Co-workers (same groups, same management, same function, or sharing the same position).",
    noForecastInstitutionsFound: "No forecast institutions found",
    formatName: "Format name",
    noIndicatorsInThisCategory: "No indicators in this category",
    viewVacationAccount: "View vacation account",
    positionGroupOfEvaluated: "Position group of evaluated",
    managementDepartmentsAndSections: "(Managements, Departments, and Sections)",
    conceptSheet: "Concept sheet",
    numericWithDecimals: "Numeric with decimals",
    only5DecimalsAllowed: "Only 5 decimals allowed.",
    goalLinkedPeriod: "Period linked to the goal",
    importEntry: "Import entry",
    loanCreatedSuccessfully: "Loan created successfully",
    employeesWithCompletedOnboarding: "Employees with completed onboarding",
    successfulDeletion: "Successful deletion",
    fonasaContributionPercentage: "FONASA contribution percentage",
    currency: "Currency",
    cannotDeletePerformanceFormBecauseInUse: "Cannot delete performance form because it is in use",
    modifyMarkingSystem: "Modify marking system",
    byConceptSet: "By concept set",
    acceptedByEvaluator: "Accepted by evaluator",
    potentialPointsFor9boxes2: "Potential points for 9-Boxes 2",
    group03: "Group 03",
    competencyCreatedSuccessfully: "Competency created successfully",
    errors: "Errors-",
    calibratedPotentialNumericScore: "Calibrated potential numeric score",
    clickEachOneForMoreInformation: "Click each one for more information",
    newAbsenceType: "New absence type",
    createPositionClassification: "Create position classification",
    newClassificationType: "New classification type",
    mySuggestions: "My suggestions",
    deleteConsentType: "Delete consent type",
    valueFromGreen: "Value from Green",
    instanceString: "Instance string",
    hoursAndMinutes: "Hours and minutes",
    editNumericWith5Decimals: "Edit numeric with 5 decimals",
    userMenu: "User menu",
    classString: "Class string",
    emailBodyText: "Email body text",
    specificCompetency1OfPosition: "Specific competency 1 of position",
    specificCompetency2OfPosition: "Specific competency 2 of position",
    blockUser: "Block user",
    thirdPartyString: "Third party string",
    totalEarnedDays: "Total earned days",
    calibratedTalentClassification: "Calibrated talent classification",
    peerEvaluator: "Peer evaluator",
    entryDelays: "Entry delays",
    cannotHaveMoreThanOneCompetencyWithSameName: "There cannot be more than one competency with the same name",
    fechanone: "DateNone",
    noActivePerformanceEvaluationsFound: "No active performance evaluations found",
    specifyParametersForNewPerformanceForm: "Specify parameters for new performance form",
    surveys: "Surveys",
    cannotDeleteMaterialOrResourceBecauseInUseInOnboardingProfiles:
        "Cannot delete material or resource because it is in use in onboarding profiles",
    forMassSalaryChangeSelectOnlyActiveEmployeesWithSameCurrencyType:
        "For mass salary change, select only active employees with the same currency type",
    channelName: "Channel name",
    thirdPartyCode: "Third party code",
    replicatedEntrySuccessfully: "Replicated entry successfully",
    customized: "Customized",
    importCalendars: "Import calendars",
    positionCode: "Position code",
    monComma: "Mon,",
    list: "List",
    unionFee: "Union fee",
    generateQueryWithAI: "Create query with AI",
    importVacations: "Import vacations",
    totalUsedDays: "Total used days",
    potentialUpdateDate: "Potential update date",
    overtimeAuthorization: "Overtime authorization",
    createOnboardingActionTypes: "Create onboarding action types",
    feedbackPurposes: "Feedback purposes",
    ALLOW_MODIFY_UPDATE_DATE_VACATIONS_EMPLOYEE_MASTER:
        "The update date for the vacation master record can be modified",
    asAdminYouAreViewingAllCommunications: "As admin you are viewing all communications",
    authorizedOvertimeHoursNoDot: "Authorized overtime hours",
    OBLIGATORY_FIELDS_EMPLOYEE_MASTER: "Obligatory fields in Employee master",
    catalogTablesList: "Catalog tables list",
    goalEvaluationPeriod: "Goal evaluation period",
    aiGeneratedSQL: "Type the query you want to create with AI in natural language",
    performanceEvaluationAnalytics: "Performance evaluation analytics",
    loanTotal: "Loan total",
    paymentTypeString: "Payment type string",
    consentTypeDeletedSuccessfully: "Consent type deleted successfully",
    order: "Order",
    theEmployee: "The employee",
    discrepancy: "Discrepancy",
    periodStatus: "Period status",
    pendingApproval: "Pending approval",
    newPositionClassification: "New position classification",
    deleteClassificationType: "Delete classification type",
    startYear: "Start year",
    cannotDeleteSpecialProcessBecauseInUse: "Cannot delete special process because it is in use",
    halfHour: "Half hour",
    positionMotivatorPotentialMustBeANumber: "Position motivator potential must be a number",
    contextInformation: "Context information",
    fileTypeUpdatedSuccessfully: "File type updated successfully",
    enableInPayrolls: "Enable in payrolls",
    province: "Province",
    emailSubjectAndName: "Email subject and name",
    costCenterShort: "Cost center",
    goalPeriods: "Goal periods",
    salariesWithoutContribution: "Salaries without contribution",
    headerValues: "Header values",
    createOrganizationalBenefit: "Create organizational benefit",
    exchange: "Exchange",
    digitalFolder: "Digital folder",
    payrolls: "Payrolls",
    selectEmployees: "Select employees",
    scheduledTime: "Scheduled time",
    sqlForLevel3ChartTitleOptional: "SQL for Level 3 Chart Title (Optional)",
    newClassification: "New classification",
    legalDaysLong: "Legal days",
    recordMustHaveUnjustifiedAbsences: "The record must have unjustified absences",
    gender: "Gender",
    massEnableInPayrolls: "Mass enable in payrolls",
    valueFromRed: "Value from Red",
    noTraceOfCalculationProcessToView: "No trace of calculation process to view",
    editCalendar: "Edit calendar",
    importTableDefinition: "Import table definition",
    classificationState: "Classification state",
    destinationTable: "Destination table",
    descendingEvaluator: "Descending evaluator",
    profileName: "Profile name",
    profileComments: "Profile comments",
    permissionsAccountInHours: "Permissions account in hours",
    apr: "Apr",
    cannotHaveMoreThanOneProjectWithSameCodeOrName: "Cannot have more than one project with the same code or name",
    exportImportStructure: "Export import structure",
    setNameAlreadyInUse: "Set name already in use",
    selectPayrollTypeToStart: "Select payroll type to start",
    linkAlt: "Link or URL",
    averages: "Averages",
    scheduleProgramming: "Schedule programming",
    maria: "Maria",
    goldShields: "Gold shields",
    viewBenefitForPlan: "View benefit for plan",
    costCenters: "Cost centers",
    evaluatedEmployeeCode: "Evaluated employee code",
    deleteAttendanceMark: "Delete attendance mark",
    deletePositionClassification: "Delete position classification",
    employeeTypes: "Employee types",
    checkThatCellsInDateAreComplete: "Check that the cells in 'Date' are complete",
    hrs: "Hrs",
    minAndMaxScoresCannotBeGreaterThan9999: "Min and max scores cannot be greater than 9999",
    fromOrgChart: "From org chart",
    calculationProcessApprovalCompletedSuccessfully: "Calculation process approval completed successfully",
    editFamilyRecord: "Edit family record",
    filtersAppliedSuccessfully: "Filters applied successfully",
    selectProcessToRun: "Select process to run",
    minimumRatingValueIs01: "Minimum rating value is 0.1",
    yellowMale: "Yellow",
    massPayrollEnablementCompletedSuccessfully: "Mass payroll enablement completed successfully",
    performance: "Performance",
    structureTypeOrSetType: "Structure type or set type",
    startDateOrDateFromCannotBeSaturdaySundayOrHoliday:
        "Start date or 'date from' cannot be Saturday, Sunday or holiday",
    createMedicalLeave: "Create medical leave",
    accumulatorsImport: "Accumulators import",
    associatedQuery: "Associated query",
    onboardingProfileDeletedSuccessfully: "Onboarding profile deleted successfully",
    myUsedBenefits: "My used benefits",
    actionDeletedSuccessfully: "Action deleted successfully",
    conceptsInSet: "Concepts in set",
    conceptTypeString: "Concept type string",
    destinationDescriptionField: "Destination description field",
    viewOnboardingSurveys: "View onboarding surveys",
    deleteThirdPartyClassificationConfirmation: "Do you want to delete the third party classification?",
    evaluatedCostCenterManagement: "Evaluated cost center management",
    mustSelectOnlyOneItem: "You must select only one item",
    timeControlType: "Time control type",
    mustSelectOnlyOneRow: "You must select only one row",
    mustSelectOneRecordOrNone: "You must select one record or none",
    multipleFiltersApplied: "Multiple filters applied",
    deleteAbsenceTypeConfirmation: "Do you want to delete the absence type?",
    executionDayOfMonth: "Execution day of month",
    medalTable: "Medal table",
    conceptInputStructureUpdatedSuccessfully: "Concept input structure updated successfully",
    functions: "Functions",
    newScaleType: "New scale type",
    evaluatedPhoto: "Evaluated photo",
    deleteUnionConfirmation: "Do you want to delete the union?",
    selectTransversalCompetenciesAndWeightingsForForm:
        "Select transversal competencies and weightings to include in the form",
    cannotHaveMoreThanOnePeriodWithSameCodeOrName: "Cannot have more than one period with the same code or name",
    cannotDeleteMenuBecauseInUse: "Cannot delete menu because it is in use",
    calculationProcessApproval: "Calculation process approval",
    permissionExceedsAvailableDailyTimeForEmployee: "Permission exceeds available daily time for employee",
    valueOfEachRecognition: "Value of each recognition",
    consentDoesNotHaveAssociatedDocument: "Consent does not have associated document",
    editSpecialProcess: "Edit special process",
    systemAlertsAndNotices: "System alerts and notices",
    changeContracts: "Change contracts",
    noJobClassificationsFound: "No job classifications found",
    recordReplica: "Record replica",
    payrollEnablementCompletedSuccessfully: "Payroll enablement completed successfully",
    quadrantDescription: "Quadrant description",
    inconsistentMarks: "Inconsistent marks",
    createRelatedTableDefinition: "Create related table definition",
    feedbackRequestedInPeriod: "Feedback requested in the period",
    calculationProcessNotCurrentlyPublished: "Calculation process is not currently published",
    deleteFamilyAssignment: "Delete family assignment",
    employeeHasNoAvailableHours: "Employee has no daily hours assigned to contract",
    loadResponsible: "Load responsible",
    recognitionLevel: "Recognition level",
    goldShield: "Gold shield",
    codeForBook: "Code for book",
    percentage: "Percentage",
    functionDeletedSuccessfully: "Function deleted successfully",
    plus9: "+9",
    userNameThatBlocked: "User name that blocked",
    descendingEvaluationWeighting: "Descending evaluation weighting",
    minimumRatingsQty: "Minimum ratings quantity",
    newAccumulator: "New accumulator",
    competenciesCalibratedSuccessfully: "Competencies calibrated successfully",
    cannotDeleteUnionBecauseInUse: "Cannot delete union because it is in use",
    dimension2: "Dimension 2",
    noPublicationsGeneratedYetWarning: "You haven't generated any publication yet",
    onlyEvaluatedBySelectedCommittee: "Only those evaluated by the selected committee",
    confirmDeleteWorkplace: "Do you want to delete the workplace?",
    benefitValue: "Benefit value",
    massShiftChangeCompletedSuccessfully: "Mass shift change completed successfully",
    massDivisionChangeCompletedSuccessfully: "Mass business unit change completed successfully",
    massManagementCenterChangeCompletedSuccessfully: "Mass publication center change completed successfully",
    employeesUnderEvaluatedManagementDependentJobsLevel1:
        "Employees under evaluated management (dependent jobs Level 1).",
    checkThirdLevelOfGeographicalOrganization: "Check third level of geographical organization",
    lreCode: "LRE code",
    delayInBreak: "Delay in break",
    competencyAlreadyExists: "Competency already exists",
    viewInCalendar: "View in calendar",
    noCompetenciesAddedYet: "No competencies added.",
    noCompetencyGroupDefined: "No competency group defined",
    noTargets: "No competency targets found",
    createSpecificCompetencyWarning:
        'For the "Competency Group" field, either enter a name that will be shared by one or more positions, or enter the exact "Position Name" for a specific position.',
    specificCompetencyGroup: "Competency group",
    targetRatingScales: "Equivalent level of this rating for the development of competencies",
    conceptCreatedSuccessfullyRememberToAssignToAnIncomeStructureOrConceptSet:
        "Concept created successfully. Remember to assign it to an income structure or concept set",
    fieldNameAlt: "Field name",
    mapAddress: "Map address",
    deleteAbsenceType: "Delete absence type",
    noCompetencies: "No competencies",
    confirmApproveProcessAndMoveToHistoric: "Do you want to approve the process and move it to historic?",
    queryDefinitionDeletedSuccessfully: "Query definition deleted successfully",
    parameterModifiedSuccessfully: "Parameter modified successfully",
    modify: "Modify",
    saveOrder: "Save order",
    actionDescription: "Action description",
    cannotHaveMoreThanOneParameterWithSameCodeOrName: "Cannot have more than one parameter with the same code or name",
    reminderDateForAlert: "Reminder date for alert",
    scheduleCodeShort: "Schedule code",
    languageDeletedSuccessfully: "Language deleted successfully",
    calculateAttendanceAnalysis: "Calculate attendance analysis",
    selfAssessment: "Self-assessment",
    legalTerminationReason: "Legal termination reason",
    create9boxClassification: "Create 9-box classification",
    feedbackDelivered: "Feedback delivered",
    performancePointsFromFor9Boxes3: "Performance points from for 9-Boxes 3",
    purposeName: "Purpose name",
    createSpecialProcess: "Create special process",
    groupCreatedSuccessfully: "Group created successfully",
    completedFemale: "Completed",
    deleteDescendantEvaluationRecordConfirmation:
        "If you delete records with descending evaluation type, all evaluation types for the selected employee(s) will also be deleted and excluded from the process. Do you want to continue?",
    dimension4: "Dimension 4",
    queryParameterCreatedSuccessfully: "Query parameter created successfully",
    overallPerformanceAverageByEvaluation: "Overall performance average by evaluation",
    createGradeType: "Create grade type",
    newQuestion: "New question",
    newFamilyAssignment: "New family assignment",
    entryOrModificationDate: "Entry or modification date",
    globalPerformanceAveragePotential: "Global performance average potential",
    cannotHaveMoreThanOneDefinitionWithSameCodeOrName:
        "Cannot have more than one definition with the same code or name",
    newUnion: "New union",
    kpiDefinitionModifiedSuccessfully: "KPI definition modified successfully",
    talentAnalytics: "Talent analytics",
    assignEmployeesToProcess: "Assign employees to process",
    overtimeCode: "Overtime code",
    medalPoints: "Medal points",
    systemTableEditors: "System table editors",
    ratingPercentage: "Rating percentage",
    deleteDocuments: "Delete documents",
    sqlVisualizationColumnSelectorsTypes:
        "For each SQL visualization column, selector types can be: Lista, Fecha, Alfa, Num, Mon.",
    relatedTableUpdatedSuccessfully: "Related table updated successfully",
    deleteJobGroupForEvaluation: "Delete job group for evaluation",
    seniority: "Seniority",
    performancePointsFromFor9Boxes1: "Performance points from for 9-Boxes 1",
    evaluatesSpecificSkills: "Evaluates specific competencies",
    generalCommentsFromEvaluator: "General comments from evaluator",
    cannotDeleteCalendarBecauseInHistoricalState: "Cannot delete calendar because it is in historical state",
    chooseHowRecordWillAppearInNotes: "Choose how record will appear in notes",
    imputationAlreadyExistsForSameConceptImputationTypeAndEntry:
        "Imputation already exists for the same concept, imputation type, and entry",
    byConcept: "By concept",
    formAndWeightings: "Form and weightings",
    massiveSalaryModificationCompletedSuccessfully: "Massive salary modification completed successfully",
    mustEnterClassification: "Must enter classification",
    benefitDescription: "Benefit description",
    conceptSet: "Concept set",
    imputationDuplicatedSuccessfully: "Imputation duplicated successfully",
    permissionSingular: "Permission",
    importCostDistributionTemplate: "Import cost distribution template",
    requireApprovalFromReceiver: "Require approval from receiver",
    sqlToGetValueListForParameter: "SQL to get value list for parameter",
    filters: "Filters",
    deleteProject: "Delete project",
    createProject: "Create project",
    groupDuplicatedSuccessfully: "Group duplicated successfully",
    specialLocationGroupsMyStaffPeopleMasterPersonalDataUserMenuAndTest:
        "Special location groups: My staff, People master, Personal data, User menu and test",
    numericRatings: "Numeric ratings",
    permissionCurrentAccount: "Current permission account",
    modifiedCostAccountingDistributionAndEmployeeInCurrentCalculationProcessReprocessingNeeded:
        "Cost accounting distribution modified and employee exists in current calculation process; reprocessing needed",
    earningsAndDeductionsSummary: "Income and Deductions summary",
    commune: "Commune",
    jobGroupForEvaluationUpdatedSuccessfully: "Job group for evaluation updated successfully",
    startPeriod: "Start period",
    includesEmployerDigitalSignature: "Includes employer digital signature?",
    replaceEvaluator: "Replace evaluator",
    endDateOfApplication: "End date of application",
    generateAndSendToEmail: "Generate and send to email",
    calculationProcess: "Calculation process",
    finalPotentialScore: "Final potential score",
    govHolidays: "Government holidays",
    byCompetency: "By competency",
    scheduleFieldIsRequired: "Schedule field is required",
    viewContextResult: "View context result",
    massiveWorkOrTaskChange: "Massive work or task change",
    cannotDeleteBenefitBecauseItHasBeenUsedLeaveInactiveButCannotDelete:
        "Cannot delete benefit because it has been used. You can mark it as inactive but cannot delete",
    sendReminderForPending: "Send reminder for pending",
    visibleToEmployee: "Visible to employee",
    duplicateConcept: "Duplicate concept",
    objectiveAnalysis: "Objective analysis",
    historicalAccumulatorCreatedSuccessfully: "Historical accumulator created successfully",
    npsValue: "NPS value",
    viewOnlyIncompleteMarks: "View only incomplete marks",
    cannotRunCalculationProcessBecauseNoEmployeesSelected:
        "Cannot run calculation process because no employees selected",
    fromTheOrganization: "From the organization",
    expirationDate: "Expiration date",
    searchConceptByName: "Search concept by name",
    exportSurvey: "Export survey",
    mustEnterCommunicationComment: "Must enter communication comment",
    createDocumentTemplate: "Create document template",
    mySelfAssessmentComments: "My self-assessment comments",
    newJobGroupForEvaluation: "New job group for evaluation",
    pointsEarned: "Points earned",
    corporateEmailAlreadyExistsForAnotherEmployeeChangeIt:
        "Corporate email already exists for another employee, please change it",
    noJobGroupsFoundForConcept: "No job groups found for concept",
    thu: "Thu",
    scheduleType: "Schedule type",
    confirmation: "Confirmation",
    abbreviatedSchedule: "Abbreviated schedule",
    group06: "Group 06",
    evaluationProcessDeletedSuccessfully: "Evaluation process deleted successfully",
    recognitionPlanAlreadyAssociatedWithSelectedBenefitType:
        "Recognition plan already associated with selected benefit type",
    newFeedbackPurpose: "New feedback purpose",
    string: "String",
    totalStandardCompanyCost: "Total standard company cost",
    closed: "Closed",
    showNameInScoreboard: "Show name in scoreboard",
    endDateOfTimes: "End date of times",
    viewConceptsBySociety: "View concepts by society",
    vacations: "Vacations",
    situation: "Situation",
    objectiveTypeDeletedSuccessfully: "Objective type deleted successfully",
    planAssignmentDate: "Plan assignment date",
    loanDeletedSuccessfully: "Loan deleted successfully",
    allFieldsRequiredAndAtLeastOneNote: "All fields required and at least one note",
    editAuthorizedOvertime: "Edit authorized overtime",
    mandatory: "Mandatory",
    highlightByManagement: "Highlight by management",
    selectNextSignerWhoMustAlsoApproveThisDocumentAfterYouSignIt:
        "Select the next signer who must also approve this document after you sign it",
    visnote: "Visnote",
    icon3minimumvalue: "icon3MinimumValue",
    allHistorical: "All historical",
    createFieldDefinition: "Create field definition",
    costDistribution: "Cost distribution",
    indicatorUpdatedSuccessfully: "Indicator updated successfully",
    labels: "Labels",
    viewOrganizationalBenefit: "View organizational benefit",
    concept: "Concept",
    canceled: "Canceled",
    executionMode: "Execution mode",
    selectTableTypeAndYear: "Select table type and year",
    cannotDeleteTemplateBecauseInUse: "Cannot delete template because it is in use",
    onboardingProcessCreatedSuccessfully: "Onboarding process created successfully",
    unprocessableEntity: "Unprocessable entity",
    deleteScaleType: "Delete scale type",
    exitAction: "Exit",
    addEmployees: "Add employees",
    personalObjective1: "Personal objective 1",
    activePluralFemale: "Active",
    activeBenefit: "Active benefit",
    selectedEmployees: "Selected employees",
    endDateAlternative: "End date",
    globalValues: "Global values",
    cannotDeleteAccumulatorBecauseInUse: "Cannot delete accumulator because it is in use",
    valuesUpdatedSuccessfully: "Values updated successfully",
    deleteObjectiveType: "Delete objective type",
    conceptId: "Concept ID",
    listanone: "ListNone",
    activeStatusShort: "Active",
    conditionalConcept1: "Conditional concept 1",
    schedulesUpdatedSuccessfully: "Schedules updated successfully",
    areYouSureYouWantToDeleteConceptSet: "Are you sure you want to delete the concept set?",
    conceptsAnalysisByStructure: "Concepts analysis by structure",
    codeCode: "Code",
    createCalendar: "Create calendar",
    updateName: "Update name",
    cannotHaveConceptSetsWithSameNameOrCode: "Concept sets cannot have the same name or code",
    conditionalInstallment: "Conditional installment",
    reasonName: "Reason name",
    normalHours: "Normal hours",
    deleteChannelType: "Delete channel type",
    viewBalances: "View balances",
    silverMedals: "Silver medals",
    performanceEvaluationsDetailsForHistoricalAnalysis: "Performance evaluations details for historical analysis",
    conceptWithSameNameAlreadyExists: "A concept with the same name already exists.",
    selectedEvaluationAlreadyHasAssociatedFeedback:
        "The selected evaluation already has associated feedback. To modify it, access My Feedback from My Desk",
    unauthorizedOvertimeShortDots: "Unauthorized OT Hrs.",
    atLeastOneTypeOfCompetencyMustBeEvaluated: "At least one type of competency must be evaluated",
    creatingMedicalLeaveTypes: "Creating medical leave types",
    previsionInstitutionDeletedSuccessfully: "Prevision institution deleted successfully",
    performanceFormWithSameCodeTypeAndJobGroupAlreadyExists:
        "A performance form with the same code, type, and job group already exists",
    others: "Others",
    scalesForRatings: "Scales for ratings",
    specificWeight: "Specific weight",
    ascending: "Ascending",
    calibratedPotentialFrom9boxes1To3: "Calibrated potential from 9-Boxes (1 to 3)",
    cannotHaveRatingsWithSameName: "Ratings cannot have the same name",
    usedAdditionalOrProgressive: "Used (additional or progressive)",
    overtimeTolerance: "Overtime tolerance",
    noDataRetrieved: "No data retrieved",
    earningsWithContributions: "Earnings with contributions",
    newShift: "New shift",
    newGrade: "New grade",
    allProcesses: "All processes",
    profileCode: "Profile code",
    reportedValue: "Reported value",
    week: "Week",
    finalGradeRangesFor9boxes: "Indicate the final grade ranges to be used for 9-Boxes",
    valid: "Valid",
    jobGroupForEvaluationDeletedSuccessfully: "Job group for evaluation deleted successfully",
    digitalSignatureConsent: "Consent for digital signature",
    potentialPointsFromFor9boxes3: "Potential points from for 9-Boxes 3",
    surveyWithEnteredNameAlreadyExists: "A survey with the entered name already exists",
    onboardingMaterialsAndResources: "Onboarding materials and resources",
    downloadFinalEvaluationSummary: "Download final evaluation summary",
    specificExecutionDate: "Specific execution date",
    executionYearMonth: "Execution year month",
    cannotDeleteObjectivePeriodBecauseInUseInPerformanceEvaluationProcesses:
        "Cannot delete objective period because it is in use in performance evaluation processes",
    hideContextResult: "Hide context result",
    mustEnterNewEmployeeCode: "You must enter a new employee code",
    evaluationProcessDefinitionSettings: "Evaluation process definition settings",
    youHaveSelectedTheLowestRatingPleaseJustifyWithYourComments:
        "You have selected the lowest rating, please justify with your comments",
    shareInformationWithYourTeamToMotivateThem: "Share information with your team to motivate them",
    newPayrollType: "New payroll type",
    finalCalibratedPotentialGrade: "Final calibrated potential grade",
    group10: "Group 10",
    cannotDeleteGroupBecauseRelatedToActionsAndReminders:
        "Cannot delete group because it is related to actions and reminders",
    top10: "Top 10",
    competencies: "Competencies",
    cannotDeleteGroupBecauseInUse: "Cannot delete group because it is in use",
    areYouSureYouWantToDeleteKPIDefinition: "Are you sure you want to delete the KPI definition?",
    scheduleRequest: "Schedule request",
    blockedUserCode: "Blocked user code",
    cannotDeleteAbsenceBecauseInUse: "Cannot delete absence because it is in use",
    processTypeCannotBeApprovedBecauseItIsASpecialOrSimulationProcess:
        "Process type cannot be approved because it is a special or simulation process",
    pendingBalance: "Pending balance",
    firstLevelOfGeographicalOrganizationIsRequired: "First level of geographical organization is required",
    icon2MaximumValue: "icon2MaximumValue",
    forSQLChartsYouMustAlwaysSelect2Columns:
        "For SQL charts, you must always select 2 columns: the first alphanumeric to be used as the series name, and the second numeric to be the series value, except for Radar charts where multiple numeric columns can be selected (ideal between 5 and 10)",
    goalDescription: "Goal description",
    icon3MaximumValue: "icon3MaximumValue",
    duplicatedQueryDefinitionSuccessfully: "Query definition duplicated successfully",
    deleteGroup: "Delete group",
    programmerUser: "Programmer user",
    youMustSelectAtLeastOneExcelTemplate: "You must select at least one Excel template",
    centralization: "Centralization",
    workOnUnscheduledDays: "Work on unscheduled days",
    recordMustHaveUnauthorizedOvertime: "Record must have unauthorized overtime",
    classificationTypesForApplicants: "Classification types for applicants",
    classifyCommunication: "Classify communication",
    endDateAlt: "End date",
    deleteFeedbackPurpose: "Delete feedback purpose",
    userCode: "User code",
    paymentPlace: "Payment place",
    benefitName: "Benefit name",
    criticalNPS: "Critical NPS",
    unauthorizedExtras: "Unauthorized extras",
    fileTypes: "File types",
    familyGroup: "Family group",
    editScheduleAlt: "Edit schedule",
    lastProcessTime: "Last process time",
    createAbsence: "Create absence",
    hourType: "Hour type",
    goalStatus: "Goal status",
    templateIsRequiredWhenInstanceIsSelected: "Template is required when an instance is selected",
    fromAnEmployeeWithSubordinateStaff: "From an employee with subordinate staff",
    nineBoxesPerformanceIndicator: "9-Boxes performance indicator",
    toChangeJobsInBulkAllSelectedEmployeesMustHaveTheSameJob:
        "To change jobs in bulk, all selected employees must have the same job",
    earningsAndDiscountsByCompanyAutomatic: "Earnings and discounts - By company (Automatic)",
    accessMap: "Access map",
    totalLegalAndOtherDays: "Total legal and other days",
    totalSocialLaws: "Total social laws",
    noPaymentMethodsFound: "No payment methods found",
    modificationMadeSuccessfully: "Modification made successfully",
    areYouSureYouWantToDeleteTheCalendar: "Are you sure you want to delete the calendar?",
    performancePointsFor9Boxes2: "Performance points up to 9-Boxes 2",
    contractEndDateForCurrentContract: "Contract end date for the current contract",
    newPrevisionInstitution: "New prevision institution",
    shiftCode: "Shift code",
    forMassRehiringYouCanOnlySelectInactiveEmployees: "For mass rehiring, you can only select inactive employees",
    goodNPS: "Good NPS",
    weighted: "Weighted",
    destination: "Destination",
    templateDeletedSuccessfully: "Template deleted successfully",
    last5Years: "Last 5 years",
    employeeBalance: "Employee balance",
    bulkEntry: "Bulk entry",
    doYouWantToDeleteTheStudyType: "Do you want to delete the study type?",
    newMaterialOrResource: "New material or resource",
    performanceFormUpdatedSuccessfully: "Performance form updated successfully",
    myNotesAlt: "My notes",
    overtimeTypes: "Overtime types",
    thereCannotBeMoreThanOneJobClassificationWithTheSameCodeOrName:
        "There cannot be more than one job classification with the same code or name",
    theDateMustBeEqualOrGreaterThanTheCurrentDate: "The date must be equal to or greater than the current date",
    competencyAnalysis: "Competency analysis",
    conceptName: "Concept name",
    doYouWantToDeleteJobClassification: "Do you want to delete the job classification?",
    w16Ml0Whitetext: "w-16 ml-0 whiteText",
    attendanceDate: "Attendance date",
    doYouWantToDeleteConcept: "Do you want to delete the concept?",
    activeDocument: "Active document?",
    toIndicateThatTheTableHasVisadoYouMustEnterAccessType:
        "To indicate that the table has visa, you must enter 'Access Type': Employee, Manager, or Employer.",
    notApplicable: "(Not applicable)",
    planBudget: "Plan budget",
    minimumRatingsQtyDot: "Minimum ratings quantity",
    totalAdditionalOrProgressiveDays: "Total additional or progressive days",
    doYouWantToDeleteMaterialOrResource: "Do you want to delete the material or resource?",
    summaryAndResults: "Summary and results",
    doYouWantToDeleteClassification: "Do you want to delete the classification?",
    myComplaints: "My complaints",
    deleteFunction: "Delete function",
    deleteUserMenu: "Delete user menu",
    formIdentification: "Form identification",
    ascendingWeighted: "Weighted ascending",
    codeCannotExceed3Characters: "Code cannot exceed 3 characters!",
    withoutCategory: "Without category",
    workShiftCode: "Work shift code",
    holidaySchedule: "Holiday schedule code",
    bankAccountRequiredForPaymentMethod: "Bank account required for payment method",
    doYouWantToDeletePayrollType: "Do you want to delete the payroll type?",
    scheduleGroup: "Schedule group",
    consentName: "Consent name",
    specificCompetencies: "Specific competencies",
    check: "Check",
    fileNameAlt: "File name",
    onboardingProfileWithSameCodeTypeAndJobGroupAlreadyExists:
        "An onboarding profile with the same code, type, and job group already exists",
    overtimeTypesXlsx: "Overtime types.xlsx",
    forEachSQLColumnSelectorTypesCanBeListDateAlphanumericNumericCurrency:
        "For each SQL column, selector types can be: List, Date, Alphanumeric, Numeric, Currency",
    newFileType: "New file type",
    accountingEntries: "Accounting entries",
    successfulDuplication: "Successful duplication",
    timePerDayString: "Time per day string",
    vacationTable: "Vacation table",
    includeInDigitalFolder: "Include in digital folder?",
    factor: "Factor",
    cannotExistMoreThanOneThirdPartyWithSameCodeOrName:
        "There cannot be more than one third party with the same code or name",
    consentIsInUseInOnboardingMaterialsAndResourcesCannotBeDeleted:
        "Consent is in use in onboarding materials and resources, cannot be deleted",
    exceptions: "Exceptions",
    performanceFormDeletedSuccessfully: "Performance form deleted successfully",
    pointsToGetIt: "Points to get it",
    conceptDeletedSuccessfully: "Concept deleted successfully",
    goalTypeUpdatedSuccessfully: "Goal type updated successfully",
    valueBetween0And100: "Value between 0 and 100",
    importedTableDefinitionSuccessfully: "Table definition imported successfully",
    defineAffiliationInstitutions: "Define affiliation institutions",
    costCenterDesc3: "Cost center description 3",
    alertOrNoticeType: "Alert or notice type",
    groupsForConcepts: "Groups for concepts",
    createSchedule: "Create schedule",
    feedbackPurposeCodeCannotBeDeletedItIsInUse: "Feedback purpose code cannot be deleted, it is in use",
    finalPerformanceScore: "Final performance score",
    valueUpToIcon3: "Value up to Icon 3",
    cannotExistMoreThanOneCostCenterWithSameCodeOrName:
        "There cannot be more than one cost center with the same code or name",
    twoMediumPotential: "2 Medium potential",
    copiedToClipboard: "Copied to clipboard",
    parameterCreatedSuccessfully: "Parameter created successfully",
    deleteNoteType: "Delete note type",
    editIndex: "Edit index",
    competencyRatingScale: "Competency rating scale",
    hhmm: "HH:mm",
    areYouSureYouWantToDeleteUserFromList: "Are you sure you want to delete the user from the list?",
    processScheduleDuplicatedSuccessfully: "Process schedule duplicated successfully",
    changeMarkingSystem: "Change marking system",
    noConceptSetsFound: "No concept sets found",
    viewObservations: "View observations",
    cannotDeleteFormBecauseItIsInUseInEvaluationProcesses:
        "Cannot delete the form because it is in use in evaluation processes",
    finalStandardPerformanceScore: "Final standard performance score",
    indicateParametersForNewEvaluationProcess: "Indicate parameters for the new evaluation process",
    assignmentDueDate: "Assignment due date",
    geographicalOrganization: "Geographical organization",
    scheduleModifiedSuccessfully: "Schedule modified successfully",
    additionalDaysPermissions: "Additional days",
    kpiType: "KPI type",
    versionCode: "Version code",
    tableGroup: "Table group",
    noJobGroupsFoundForEvaluations: "No job groups found for evaluations",
    editMedicalLeave: "Edit medical leave",
    entryWorkTime: "Entry work time",
    performanceDefinitions: "Performance definitions",
    forInternalUse: "For internal use:",
    currencyColon: "Currency:",
    workerType: "Worker type",
    activeStandard: "Active standard",
    setCode: "Set code",
    youMustSelectTableType: "You must select table type",
    totalEarnings: "Total earnings",
    userMenuCreation: "User menu creation",
    fieldType: "Field type",
    whenPassingCommunicationToStates: "When passing the communication to states",
    forMassEnablingInPayrollYouMustSelectOnlyActiveEmployees:
        "For mass enabling in payroll, you must select only active employees",
    onboardingStepsForProfile: "Onboarding steps for profile",
    cannotDeleteAccumulatorBecauseItIsUsedInFormulas: "Cannot delete accumulator because it is used in formulas",
    dataEntryViaApi: "Data entry via API",
    noBenefitsAvailableAtTheMoment: "No benefits available at the moment",
    jobClassification: "Job classification",
    withObservations: "With observations",
    hrsWithTrailingSpace: "Hrs ",
    actionOrMomentType: "Action or moment type",
    noThirdPartiesFound: "No third parties found",
    enterYourCommentsHere: "Enter your comments here",
    conceptSetDeletedSuccessfully: "Concept set deleted successfully",
    sqlToDetermineValueListForParameter: "SQL to determine value list for parameter",
    actionCreatedSuccessfully: "Action created successfully",
    cannotDeleteOwnAbsences: "You cannot delete your own absences",
    ufLastDayOfCurrentMonth: "UF last day of current month",
    icon1MaximumValue: "icon1MaximumValue",
    menuName: "Menu name",
    planDeletedSuccessfully: "Plan deleted successfully",
    bronzeMedal: "Bronze medal",
    jun: "Jun",
    send: "Send",
    valueFromIcon1: "Value from Icon 1",
    average: "Average",
    searchEllipsis: "Search...",
    performancePointsFor9Boxes1: "Performance points up to 9-Boxes 1",
    tableIsEmptyIfHeaderDataFilledPress: "The table is empty. If header data has been filled, press ",
    numericStandardPotentialScore: "Numeric standard potential score",
    hireDate: "Hire date",
    origin: "Origin",
    communicationClassificationSingular: "Communication classification",
    showNameInMarker: "Show name in marker",
    missingPlural: "Missing",
    duplicateByCompetencyGroup: "Duplicate by competency group",
    forMassShiftChangeYouMustSelectOnlyActiveEmployees: "For mass shift change, you must select only active employees",
    cannotDeleteOwnPermissions: "You cannot delete your own permissions",
    massive: "Massive",
    youCanAlsoChangePlanStatusToHistoric: "You can also change the plan status to historic.",
    classificationTypeUpdatedSuccessfully: "Classification type updated successfully",
    variables: "Variables",
    sqlForOptionalKpiSubtitleAndItWillDependOnEachKpi: "SQL for optional KPI subtitle (depends on each KPI)",
    earningsAndDeductionsInstallmentEntry: "Income and Deductions - Installment entry",
    goalsAndObjectivesShort: "Goals and objectives",
    queryDefinitionModifiedSuccessfully: "Query definition modified successfully",
    scheduledHoursPlan: "Scheduled hours plan",
    ifYouEnterAuthorizedAbsenceDaysYouMustDefineAccessModeViaRequestToManager:
        "If you enter authorized absence days, you must define access mode via request to manager",
    doYouWantToDeleteClassificationType: "Do you want to delete the classification type?",
    movementDate: "Movement date",
    evaluationWithSpace: "Evaluation ",
    oneOfTheEnteredEmployeesIsAlreadyAssociatedWithThePlan:
        "One of the entered employees is already associated with the plan",
    sectionAlt: "Section",
    deleteActionType: "Delete action type",
    noFeedbackPurposesFound: "No feedback purposes found",
    selectEmployeeOrReferenceGroup: "Select employee or reference group",
    youMustPreviewFileBeforeSigningIt: "You must preview the file before signing it",
    brandGeoposition: "Brand geoposition",
    toDefineAccessModeViaRequestToManagerYouMustHaveAuthorizedAbsenceDays:
        "To define access mode via request to manager, you must have authorized absence days",
    provinceCode: "Province code",
    calibrationDate: "Calibration date",
    commentColon: "Comment:",
    performanceIndicator: "Performance indicator",
    planName: "Plan name",
    sqlToDisplayNumberInBoxOrClock: "SQL to display number in box or clock",
    group07: "Group 07",
    genericReference2: "Generic reference 2",
    geoanalysisQueryDefinitionDeletedSuccessfully: "Geoanalysis query definition deleted successfully",
    totemManagement: "Totem management",
    group04: "Group 04",
    myDigitalFolder: "My digital folder",
    managementCode: "Management code",
    updatedPrevisionInstitutionSuccessfully: "Prevision institution updated successfully",
    saveReference: "Save reference",
    yAxisFor9Boxes: "Y axis for 9-boxes",
    legalAndOtherUsed: "Used (legal and others)",
    highlightMotivatorPotential: "Highlight motivator potential",
    selectedDocumentsNotFound: "Selected documents not found",
    rating: "Rating",
    createFormatTypesForPublications: "Create format types for publications",
    sectionCode: "Section code",
    planStatus: "Plan status",
    totalTax: "Total tax",
    enableEditors: "Enable editors?",
    ifNotPayingTotalInstallmentsThePrepaidInstallmentsWillAlwaysBeTheLast:
        "If not paying total installments upfront, prepaid installments will always be the last",
    daysToUseInFutureAdditionalOrProgressive: "Days to use in future (additional or progressive)",
    usedDays: "Used days",
    alfanone: "AlfaNone",
    cannotExistMoreThanOneClassificationWithSameCodeOrName:
        "There cannot be more than one classification with the same code or name",
    viewConcepts: "View concepts",
    communicationType: "Communication type",
    fromEmployeeMaster: "From Employee Master",
    planCreatedSuccessfully: "Plan created successfully",
    updatedFamilyAllowanceSuccessfully: "Family allowance updated successfully",
    doYouWantToDeletePermission: "Do you want to delete the permission?",
    hiringDateColon: "Hiring date: ",
    createPermissionTypes: "Create permission types",
    processScope: "Process scope",
    standardPotential9Boxes: "Standard potential 9-Boxes",
    checkFormatItShouldBeForExample0900: "Check the format. It should be, for example, 09:00.",
    queryParameterModifiedSuccessfully: "Query parameter modified successfully",
    goals: "Goals",
    thankYouForRespondingNowCommunicationReturnedToResponsibleEmployerToContinueTheirAttention:
        "Thank you for responding. Now the communication has returned to the responsible employer to continue their attention.",
    standardTalentClassification: "Standard talent classification",
    progressControl: "Progress control",
    onboardingProcessAssignment: "Onboarding process assignment",
    associatedSystemTable: "Associated system table",
    difference: "Difference",
    conceptSetUpdatedSuccessfully: "Concept set updated successfully",
    workplaces: "Workplaces",
    cannotRemovePublicationFromCalculationProcessBecauseDocumentsWithDigitalSignatureHaveAlreadyBeenGeneratedForThatProcess:
        "Cannot remove publication from calculation process because documents with digital signature have already been generated for that process",
    cannotExistMoreThanOneGroupWithSameCodeOrName: "There cannot be more than one group with the same code or name",
    conceptEntryStructure: "Concept entry structure",
    enteredTextWillBeFileNameWhenUploaded: "Entered text will be the filename when uploaded",
    withNumberValueRelatedIconWillBeShownInBoxOrNeedleInClock:
        "With the number value, related icon will be shown in the box or needle in clock",
    exitDate: "Exit date",
    scheduleDefinitions: "Schedule definitions",
    forConditionalSqlFiltersRememberYouHaveVariablesCodempAndEmployeeWhichContainEmployeeCodeAndWillDisplayAvailableBenefits:
        "For conditional SQL filters remember you have variables #CODEMP# and #EMPLOYEE# which contain employee code and will display available benefits",
    youMustSelectARow: "You must select a row",
    hiringDate: "Hiring date",
    selectConcepts: "Select concepts",
    blockedUsername: "Blocked username",
    lastProcessDate: "Last process date",
    valuesCannotExistWithSameEmployeeAndDate: "Values cannot exist with same employee and date",
    youMustEnterResponsibleForCommunication: "You must enter the responsible for communication",
    cannotDeleteCrossCompetenceBecauseItIsInUseInPerformanceForms:
        "Cannot delete cross competence because it is in use in performance forms",
    familyType: "Family type",
    specialProcessToExecute: "Special process to execute",
    cannotExistMoreThanOneCompetenceWithSameNameAndGroup:
        "There cannot be more than one competence with the same name and group",
    jobDescription: "Job description",
    userMenuDeletedSuccessfully: "User menu deleted successfully",
    onboardingProcessDeletedSuccessfully: "Onboarding process deleted successfully",
    alertOrNoticeWithSameNameAlreadyExists: "An alert or notice with the same name already exists",
    relatedElementsToDocument: "Related elements to document",
    alphanumeric: "Alphanumeric",
    rate: "Rate",
    transversal: "Transversal",
    conceptString: "Concept string",
    cannotDeleteRecordInUse: "Cannot delete a record that is in use",
    judicialRetentionString: "Judicial retention string",
    functionDuplicatedSuccessfully: "Function duplicated successfully",
    taxBase: "Tax base",
    userPermissionError: "User permission error",
    initialLoadDate: "Initial load date",
    cannotDeleteFunctionInUse: "Cannot delete function because it is in use",
    deleteClassification: "Delete classification",
    group02: "Group 02",
    jul: "Jul",
    totalVariousDiscounts: "Total various discounts",
    areYouSureYouWantToDeleteRecord: "Are you sure you want to delete the record?",
    valueUntilYellow: "Value until Yellow",
    xAxisFor9Boxes: "X axis for 9-boxes",
    hrsDot: "Hrs.",
    silverShields: "Silver shields",
    workedDays: "Worked days",
    checkSecondLevelOfGeographicOrganization: "Check the second level of geographic organization",
    parameterDeletedSuccessfully: "Parameter deleted successfully",
    yourCompetenceRating: "Your competence rating",
    viewDetail: "View detail",
    surveyAnalysis: "Survey analysis",
    benefitTypeDeletedSuccessfully: "Benefit type deleted successfully",
    specialProcessUpdatedSuccessfully: "Special process updated successfully",
    vacationType: "Vacation type",
    markerIcon: "Marker icon",
    youCannotSendFeedbackForAnEvaluationYouAreBeingEvaluatedIn:
        "You cannot send feedback for an evaluation you are being evaluated in",
    recipientGroups: "Recipient groups",
    userMenuUpdatedSuccessfully: "User menu updated successfully",
    accessEvaluations: "Access evaluations",
    parameterName: "Parameter name",
    noPayrollTypesFound: "No payroll types found",
    reasonsForEntry: "Reasons for entry",
    nonExistent: "Non-existent",
    alertOrNoticeClass: "Alert or notice class",
    publicationDate: "Publication date",
    calendarDefinitions: "Calendar definitions",
    viewGroupsWithThisClassification: "View groups with this classification",
    scheduledBreakStart: "Scheduled break start",
    actionTypeCreatedSuccessfully: "Action type created successfully",
    cannotExistMoreThanOneTemplateWithSameCodeOrName:
        "There cannot be more than one template with the same code or name",
    associatedUserTable: "Associated user table",
    benefitTypeImage: "Benefit type image",
    ifChangeAppliesToEmployeesWithoutExistingContractNewHiresTopTwoDataWillBeIgnored:
        "If the change applies to employees without existing contract (new hires), the top two data will be ignored",
    isCustomFormula: "Is custom formula",
    recordsModifiedSuccessfully: "Records modified successfully",
    evaluatedManager: "Evaluated manager",
    showWeek: "Show week",
    registrationDate: "Registration date",
    number: "Number",
    positionRecompositionSuccessfullyDone: "Position recomposition successfully done",
    shiftDefinitions: "Shift definitions",
    reasonForCurrentContractTermination: "Reason for current contract termination",
    unjustifiedAbsencesAlt: "Unjustified absences",
    feedbackStartDate: "Feedback start date",
    exchangeObligation: "Exchange obligation",
    requiresBankAccount: "Requires bank account",
    cannotExistConceptSetsWithSameName: "Concept sets with the same name cannot exist",
    areYouSureYouWantToDeleteGeoAnalysisQueryDefinition:
        "Are you sure you want to delete the geo-analysis query definition?",
    enterNumericValueBetween1And125: "Enter a numeric value between 1 and 125.",
    numericGradeAveragesByEvaluators: "Numeric grade averages by evaluators",
    calibratedFrom9Boxes: "Calibrated from 9-Boxes",
    byAccountAndCostCenter: "By account and cost center",
    processedEmployees: "Processed employees",
    calculationProcessCannotBeDeletedBecauseDigitalSignedDocumentsHaveBeenGeneratedForThatProcess:
        "Calculation process cannot be deleted because digitally signed documents have been generated for that process",
    license: "License",
    plantStaff: "Plant staff",
    executionSQL: "Execution SQL",
    editBenefitType: "Edit benefit type",
    expirationDateString: "Expiration date string",
    icon3Box: "3 BOX icon",
    earningsWithoutContributions: "Earnings without contributions",
    fileTypeCreatedSuccessfully: "File type created successfully",
    totalValueOfLoansGranted: "Total value of loans granted",
    createPublicationChannelTypes: "Create publication channel types",
    illnesses: "Illnesses",
    searchInSQL: "Search in SQL",
    forAssignmentYouMustSelectOnlyActiveEmployees: "For assignment, you must select only active employees",
    endTime: "End time",
    cannotExistMoreThanOneTableWithSameNameAndVersionCode:
        "There cannot be more than one table with the same name and version code",
    enter: "Enter",
    selectedUser: "Selected user",
    motivatorPotential: "Motivator potential",
    cannotExistMoreThanOneFieldWithSameCodeOrName: "There cannot be more than one field with the same code or name",
    sqlContextResult: "SQL context result",
    scheduleCreatedSuccessfullyAlt: "Schedule created successfully",
    maxValueForCashRedemption: "Maximum value for cash redemption",
    competenciesPerEvaluation: "Competencies per evaluation",
    chooseAwardDeliveryAndDiffusionType: "Choose award delivery and diffusion type",
    enteredPersonalEmailAlreadyExistsForAnotherEmployeeMustChangeIt:
        "Entered personal email already exists for another employee, it must be changed",
    feedbackProcessStart: "Feedback process start",
    processPeriodLong: "Process period",
    areYouSureYouWantToGenerateVacationCertificateAlreadyApprovedByYouAndThatMustBeDigitallySignedByEmployeeToReceiveItByEmail:
        "Are you sure you want to generate a vacation certificate already approved by you, which must be digitally signed by the employee to receive it by email?",
    entryCoordinates: "Entry coordinates",
    selfEvaluationWeight: "Self-evaluation weight",
    noHealthInstitutionsFound: "No health institutions found",
    saveCalibrations: "Save calibrations",
    objectivesWeight: "Objectives weight",
    noAccessToLicenseManagement: "No access to license management",
    ifYouDeleteThisPayrollTypeAllConceptsAndEmployeesRelatedToThisPayrollTypeWillBeDisabledDoYouWantToContinue:
        "If you delete this payroll type, all concepts and employees related to this payroll type will be disabled. Do you want to continue?",
    options: "Options",
    classificationCreatedSuccessfully: "Classification created successfully",
    valueUntilRed: "Value until Red",
    totalExemptEarnings: "Total exempt earnings",
    downloadCapture: "Download capture",
    dateAndNotEligibleAsMarker: "Date and not eligible as marker",
    thirdPartiesUpdatedSuccessfully: "Third parties updated successfully",
    noConsentTypesFound: "No consent types found",
    hasRelatedEditors: "Has related editors",
    contextComments: "Context comments",
    competencyScale: "Competency scale",
    areYouSureYouWantToSaveChanges: "Are you sure you want to save changes?",
    showMonth: "Show month",
    conceptCreatedSuccessfully: "Concept created successfully",
    noClassificationsFound: "No classifications found",
    selectedEmployee: "Selected employee",
    totalGrossEarnings: "Total gross earnings",
    doYouWantToDownloadSelectedFiles: "Do you want to download selected files?",
    setCodeAlreadyInUse: "Set code already in use",
    userUnlockedSuccessfully: "User unlocked successfully",
    loanValues: "Loan values",
    functionModifiedSuccessfully: "Function modified successfully",
    performancePointsFromFor9Boxes2: "Performance points from for 9-Boxes 2",
    deletePaymentMethod: "Delete payment method",
    creationDate: "Creation date",
    communeCode: "Commune code",
    accumulatorCreation: "Accumulator creation",
    cannotHaveNotesWithSameName: "Cannot have notes with the same name",
    reviewFollowingFormSummary: "Review the following form summary",
    newCostCenter: "New cost center",
    scheduled: "Scheduled",
    gridColumnType: "Grid column type",
    potentialPointsFromFor9Boxes2: "Potential points from for 9-Boxes 2",
    goalAssigner: "Goal assigner",
    healthInstitutionCreatedSuccessfully: "Health institution created successfully",
    familyAllowanceString: "Family allowance string",
    remuneration: "Remuneration",
    maxPlanBudgetInCash: "Maximum plan budget in cash",
    allDataFieldsAreRequired: "All data fields are required",
    otherConcepts: "Other concepts",
    vacationsDeletedSuccessfully: "Vacations deleted successfully",
    allMale: "All",
    deltaSoftSa: "Delta Soft SA",
    noteTypeCode: "Note type code",
    quadrantClassificationLong: "Quadrant classification",
    entryReference: "Entry reference",
    ratingName: "Rating name",
    jobClassificationUpdatedSuccessfully: "Job classification updated successfully",
    cannotChangeCalendarToState: "Cannot change calendar to state",
    noScaleTypesFound: "No scale types found",
    enteredTimeExceedsEmployeeWorkday: "Entered time exceeds employee workday",
    overtimeReleased: "Overtime released",
    actionsShort: "Actions",
    feedbackResponsible: "Feedback responsible",
    bySociety: "By society",
    overtime: "Overtime",
    competencyWeight: "Competency weight",
    specifyDocumentAcceptanceTypeRequiredFromEmployee:
        "Specify the type of acceptance required from the employee for the document.",
    benefitImage: "Benefit image",
    cannotDeleteActionTypeBecauseInUse: "Cannot delete action type because it is in use",
    familyAllocations: "Family allocations",
    noteTypeWithEnteredCodeAlreadyExists: "A note type with the entered code already exists",
    queryCodeLong: "Query code",
    currentPlural: "Current",
    byCompetenciesAndEvaluators: "By competencies and evaluators",
    paymentMethodCreatedSuccessfully: "Payment method created successfully",
    doNotApplyChanges: "Do not apply changes",
    cannotExistMoreThanOneRelativeWithSameCode: "There cannot be more than one relative with the same code",
    indicators: "Indicators",
    earlyWithdrawal: "Early withdrawal",
    stay: "Stay",
    percentages: "Percentages",
    receiverRole: "Receiver role",
    doYouWantToDeleteThePeriod: "Do you want to delete the period?",
    onlyOvertime: "Only overtime",
    competencyGroupSingular: "Competency group",
    calculationProcessPublication: "Calculation process publication",
    cannotDeleteObjectiveTypeBecauseInUse: "Cannot delete objective type because it is in use",
    legalDiscounts: "Legal discounts",
    size: "Size",
    cannotExistMoreThanOneMenuWithSameCodeOrFunctionName:
        "There cannot be more than one menu with the same code or function name",
    regionCode: "Region code",
    noAccessToVacationManagement: "No access to vacation management",
    cannotExistMoreThanOneAccumulatorWithSameCodeOrName:
        "There cannot be more than one accumulator with the same code or name",
    scaleTypeWithEnteredCodeAlreadyExists: "A scale type with the entered code already exists",
    newChannelTypeForPublications: "New channel type for publications",
    lockDate: "Lock date",
    potentialFrom: "Potential from",
    dimension3: "Dimension 3",
    redemptionType: "Redemption type",
    employeesInRecognitionPlans: "Employees in recognition plans",
    indexDuplicatedSuccessfully: "Index duplicated successfully",
    uploadDocument: "Upload document",
    jobGroupForEvaluation: "Job group for evaluation",
    onboardingStage: "Onboarding stage",
    num: "Num,",
    specifics: "Specifics",
    noCategory: "No category",
    deletePayrollType: "Delete payroll type",
    receiveNotice: "Receive notice",
    historicalPerformanceAnalysis: "Historical performance analysis",
    alpha: "Alfa",
    discountFrequency: "Discount frequency",
    deleteCalculationReference: "Delete calculation reference",
    evaluationStepsAndStages: "Evaluation steps and stages",
    exportPdf: "Export PDF",
    onboardingEndDateAlt: "Onboarding end date",
    periodsForObjectivesLong: "Periods for objectives",
    calculationFunctions: "Calculation functions",
    actionPerformanceEvaluationCalibration: "Action performance evaluation calibration",
    progressDateAlt: "Progress date",
    projectDesc: "Project description",
    groupDeletedSuccessfully: "Group deleted successfully",
    feedbacks: "Feedbacks",
    nineBoxesDefinition: "9-Boxes definition",
    evaluationProcessName: "Evaluation process name",
    familyAllowance: "Family allowance",
    benefitCode: "Benefit code",
    newThirdPartyClassification: "New third party classification",
    accountCode: "Account code",
    toMakeAnyChangeGoBackToTheAppropriateStep: "To make any change, go back to the appropriate step",
    processIdentification: "Process identification",
    detailedDataView: "Detailed data view",
    top5: "Top 5",
    calibrationState: "Calibration state",
    sqlForLevel3ChartsHorizontalVerticalPieOrLine: "SQL for Level 3 charts (Horizontal, Vertical, Pie or Line)",
    mypeople: "MyPeople",
    cannotDeleteCalculationReferenceBecauseInUse: "Cannot delete calculation reference because it is in use",
    doYouWantToDeleteTheGroup: "Do you want to delete the group?",
    parameterType: "Parameter type",
    cannotExistMoreThanOnePensionInstitutionWithSameCodeOrName:
        "There cannot be more than one pension institution with the same code or name",
    finalPerformanceGrade: "Final performance grade",
    totalShiftHours: "Total shift hours",
    userBlockedSuccessfully: "User blocked successfully",
    monthsMustBeBetween1And12: "Months must be between 1 and 12",
    dayWithScheduleChange: "Day with schedule change",
    importSurvey: "Import survey",
    highPotential3: "3 High potential",
    hidden: "Hidden",
    myClaims: "My claims",
    doYouWantToDeleteAllReadAlertsAndNotices: "Do you want to delete all read alerts and notices?",
    physicalTableCode: "Physical table code",
    doYouWantToDeleteTheReasonForPointDelivery: "Do you want to delete the reason for point delivery?",
    editOrganizationalBenefit: "Edit organizational benefit",
    forBulkTimecardSystemChangeYouMustSelectOnlyActiveEmployees:
        "For bulk timecard system change you must select only active employees",
    noPermissionTypesFound: "No permission types found",
    processNameAlt: "Process name",
    99: "+99",
    records: "Records",
    scaleTypeWithEnteredNameAlreadyExists: "A scale type with the entered name already exists",
    highlightByEvaluationGroup: "Highlight by evaluation group",
    doYouWantToDeleteTheConsentType: "Do you want to delete the consent type?",
    continue: "Continue",
    consentTypeCreatedSuccessfully: "Consent type created successfully",
    cannotDeleteNoteTypeBecauseInUseInPerformanceEvaluationProcesses:
        "Cannot delete note type because it is in use in performance evaluation processes",
    deleteFormatType: "Delete format type",
    selectedFiles: "Selected files",
    lorenzo: "Lorenzo",
    noUpdateDateRecorded: "No update date recorded",
    conceptModifiedSuccessfully: "Concept modified successfully",
    forMassiveJobChangeYouMustSelectOnlyActiveEmployees: "For massive job change you must select only active employees",
    conceptSetDuplicatedSuccessfully: "Concept set duplicated successfully",
    assignmentDateToPlan: "Assignment date to plan",
    talentAcquisitionDefinitions: "Talent acquisition definitions",
    cannotExistValuesWithSameCodeOrName: "Values with the same code or name cannot exist",
    shiftHours: "Shift hours",
    changeDate: "Change date",
    familyCreatedSuccessfully: "Family member created successfully",
    managementDefinitionConsultationsGeoAnalysisKPI: "Management definition (Consultations-GeoAnalysis-KPI)",
    doYouWantToDeleteCalculationReference: "Do you want to delete the calculation reference?",
    noCalculationReferencesFound: "No calculation references found",
    noShiftsFound: "No shifts found",
    incomeAddedSuccessfully: "Income added successfully",
    evaluatePersonalObjectives: "Evaluate personal objectives",
    detailTableCannotBeSelectedBecauseItIsInUse: "Detail table cannot be selected because it is in use.",
    filterOrgChart: "Filter org chart",
    noSalariesOrDiscountsFound: "No salaries or discounts found",
    result: "Result",
    dataForSeveranceSimulation: "Data for severance simulation",
    ifYouEnterRelatedPaymentConceptYouMustDefineAsAccessMethodViaEmployerRequest:
        "If you enter related payment concept you must define access method via employer request",
    cannotDeleteBenefitBecauseItIsRelatedToRecognitionPlan:
        "Cannot delete benefit because it is related to a Recognition Plan",
    includeCurrentYearProcesses: "Include current year processes",
    neutrals: "Neutrals",
    conceptStructureDoesNotExist: "Concept structure does not exist",
    performanceAndTalentAnalytics: "Performance and talent analytics",
    vacantPositions: "Vacant positions",
    youMustSelectAStructure: "You must select a structure",
    numericValue: "Numeric value",
    enteredBenefitTypeCodeAlreadyExists: "Entered benefit type code already exists",
    selectSchedule: "Select schedule",
    attendanceMarkEditedSuccessfully: "Attendance mark edited successfully",
    calibrationCompleted: "Calibration completed",
    permissionUpdatedSuccessfully: "Permission updated successfully",
    descendingWeighted: "Descending weighted",
    evaluator: "Evaluator",
    evaluationYear: "Evaluation year",
    evaluationMustBeInFeedbackState: "Evaluation must be in 'In Feedback' state",
    jobClassificationDeletedSuccessfully: "Job classification deleted successfully",
    noAvailablePositions: "No available positions",
    referenceGroup: "Reference group",
    newSpecialization: "New specialization",
    conditionalSQL: "Conditional SQL",
    periodCode: "Period code",
    createBenefitForPlan: "Create benefit for plan",
    registrationTime: "Registration time",
    sendApprovedRequestProofWithCopyTo: "Send approved request proof with copy to",
    only5DecimalsAllowedCannotEnter0: "Only 5 decimals allowed. Cannot enter 0.",
    strength: "Strength",
    totemCreation: "Totem creation",
    cannotExistMoreThanOneIndicatorWithSameNameOrNumber:
        "Cannot exist more than one indicator with the same name or number",
    editAction: "Edit action",
    shiftDetail: "Shift detail",
    evaluateJobSpecificCompetencies: "Evaluate job specific competencies?",
    specialProcessQuery: "Special process query",
    editFieldDefinition: "Edit field definition",
    projectDeletedSuccessfully: "Project deleted successfully",
    areYouSureYouWantToDeleteTheProcess: "Are you sure you want to delete the process?",
    dashboard: "Dashboard",
    paymentToThirdParty: "Payment to third party",
    markerScheme: "Marker scheme",
    theFileYouAreTryingToImportIsDamaged: "The file you are trying to import is damaged",
    selectedSingular: "Selected",
    authorizedOvertimeHoursShort: "Authorized overtime hours",
    queryCannotBeDeletedBecauseItIsAssociatedWithSpecialProcess:
        "Query cannot be deleted because it is associated with a special process",
    updateDate: "Update date",
    noDocumentsPublishedWithDigitalSignature: "No documents published with digital signature",
    doYouWantToDownloadTheFile: "Do you want to download the file?",
    languageCreatedSuccessfully: "Language created successfully",
    advancesForRequests: "Advances for requests",
    licenseDeletedSuccessfully: "License deleted successfully",
    integerNumericAndNotEligibleAsMarker: "Integer numeric and not eligible as marker",
    cannotReplaceEvaluatorBecauseNoGrades: "Cannot replace evaluator because there are no grades",
    detractors: "Detractors",
    overtimeHoursPerformed: "Overtime hours performed",
    myOnboardingProcess: "My onboarding process",
    potentialIndicator: "Potential indicator",
    doYouWantToSendReminderMessageToEmployeesToRequestVacation:
        "Do you want to send a reminder message to employees to request vacation?",
    calibratedQuadrantClassification: "Calibrated quadrant classification",
    internalUseCommentOnlyVisibleToManagersAndEmployers:
        "Internal use comment (These comments will only be visible to Managers and Employers):",
    variousDiscounts: "Various discounts",
    sendMessageToStartRatings: "Send message to start ratings",
    group05: "Group 05",
    descr: "Descr",
    approve: "Approve",
    mon: "Mon",
    youMustSelectAFunction: "You must select a function",
    weddingDate: "Wedding date",
    cannotExistFunctionsWithSameCode: "Functions with the same code cannot exist",
    canReceiveActions: "Can receive actions?",
    rehire: "Rehire",
    group08: "Group 08",
    newTemplate: "New template",
    forThisPermissionTypeAttachmentUploadIsRequired: "For this permission type, attachment upload is required",
    detailedInformation: "Detailed information",
    currentLoadedTemplateNoTemplateLoaded: "Currently loaded template: No template loaded",
    finished: "Finished",
    byEvaluatedAndCompetencies: "By evaluated and competencies",
    kpiDefinitionDuplicatedSuccessfully: "KPI definition duplicated successfully",
    contractors: "Contractors",
    importStructures: "Import structures",
    stepDescription: "Step description",
    youMustSelectAUser: "You must select a user",
    potentialPointsFromFor9boxes1: "Potential points from for 9-Boxes 1",
    executeQuery: "Execute query",
    anOpenCalculationProcessAlreadyExistsWithTheSamePayrollType:
        "An open calculation process already exists with the same payroll type",
    activePlans: "Active plans",
    codeTIsReservedForInternalUseCannotDefineIt: "Code T is reserved for internal use, cannot define it",
    yourPotentialRating: "Your potential rating",
    createRecord: "Create record",
    inInstallments: "In installments",
    classificationCreation: "Classification creation",
    thirdPartyDeletedSuccessfully: "Third party deleted successfully",
    accountingAllocations: "Accounting allocations",
    crossFunctionalPond: "Cross-functional weighting",
    thirdPartyCreatedSuccessfully: "Third party created successfully",
    totalLegalVacationsAndOthers: "Total legal vacations and others",
    functionNameLongAlt: "Function name",
    fees: "Fees",
    permanenceHours: "Permanence hours",
    studyTypeCreatedSuccessfully: "Study type created successfully",
    editRelatedTableDefinition: "Edit related table definition",
    associatedValues: "Associated values",
    actionTypesAndReminders: "Action types and reminders",
    noCharacteristicsDefinedForThisQuadrant: "No characteristics defined for this quadrant.",
    occupation: "Occupation",
    noEmployeesInSelectedQuadrant: "No employees in selected quadrant",
    selectGroups: "Select groups",
    publicationDateMustBeEqualOrLaterThanCurrentDate: "Publication date must be equal or later than the current date",
    ifYouDefinePotentialQuestionsTheyWillOnlyBeVisibleInTheDescendingEvaluationForm:
        "If you define potential questions, they will only be visible in the Descending evaluation form",
    kpiCode: "KPI code",
    indices: "Indices",
    costCenterDescription2: "Cost center description 2",
    noClassification: "No classification",
    marchShort: "Mar",
    conceptCannotBeDeletedBecauseItIsInUse: "Concept cannot be deleted because it is in use",
    languageUpdatedSuccessfully: "Language updated successfully",
    workplaceName: "Workplace name",
    emailSentSuccessfully: "Email sent successfully",
    licenses: "Licenses",
    costCenter3: "Cost center 3",
    communicationMustBeAssignedToAResponsiblePerson: "Communication must be assigned to a responsible person",
    transferFromPlan: "Transfer from plan",
    publicationFormatTypes: "Publication format types",
    noteName: "Note name",
    cannotDeleteConsentTypeBecauseItIsInUse: "Cannot delete consent type because it is in use",
    accountingPeriod: "Accounting period",
    requestingRole: "Requesting role",
    family: "Family",
    actionTypeUpdatedSuccessfully: "Action type updated successfully",
    bulkUploadOfEvaluatedAndTheirEvaluators: "Bulk upload of evaluated and their evaluators",
    youMustSelectASinglePerformanceEvaluation: "You must select a single performance evaluation",
    salariesAndDeductions: "Salaries and deductions",
    relatedPaymentConcept: "Related payment concept",
    silverShield: "Silver shield",
    newContract: "New contract",
    ratingCriteria: "Rating criteria",
    conceptModifiedSuccessfullyRememberToAssignConceptToAnIncomeStructureOrConceptSet:
        "Concept modified successfully. Remember to assign the concept to an income structure or concept set",
    employeeCodeAlreadyExistsCannotCreateNewEmployeeWithThatCode:
        "Employee code already exists, cannot create new employee with that code",
    notRequired: "Not required",
    highlightByWorkplace: "Highlight by workplace",
    functionCreatedSuccessfully: "Function created successfully",
    unionDeletedSuccessfully: "Union deleted successfully",
    unlink: "Unlink",
    cannotDeleteBenefitBecauseItIsEnabledAsOrganizationalBenefit:
        "Cannot delete benefit because it is enabled as organizational benefit",
    series: "Series",
    executionInProgressForSelectedSpecialAction: "Execution in progress for selected special action",
    associatedGroups: "Associated groups",
    selectConceptSet: "Select concept set",
    successfulModification: "Successful modification",
    dollar: "Dollar",
    anOpenCalendarAlreadyExistsForSameCalendarType: "An open calendar already exists for the same calendar type",
    performanceAndPotential: "Performance and potential",
    employeeCodeAlreadyExistsCannotUpdateEmployeeWithThatCode:
        "Employee code already exists, cannot update the employee with that code",
    shiftAssignmentDateShort: "Shift assignment date",
    kpiDefinitionDeletedSuccessfully: "KPI definition deleted successfully",
    hoursAndMinutesHhmmColon: "Hours and minutes (hh:mm)",
    cannotDeleteShiftBecauseItIsBeingUsed: "Cannot delete the shift because it is being used",
    cannotExistMoreThanOneClassificationTypeWithSameCodeOrName:
        "There cannot be more than one classification type with the same code or name",
    cannotExistMoreThanOneTableWithSameCodeOrName: "There cannot be more than one registry with the same code or name",
    verifyThatTheDateCellsAreComplete: "Verify that the date cells are complete",
    taxTablexlsx: "Tax table.xlsx",
    theMinimumNoteValueIs01: "The minimum note value is 0.1",
    newActionRegistrationDate: "New action registration date",
    integerNumeric: "Integer numeric",
    unpaidSalary: "Unpaid salary",
    organizationChart: "Organization chart",
    newObjectiveType: "New objective type",
    ratingNameCannotBeLongerThan60Characters: "Rating name cannot be longer than 60 characters",
    valueFromIcon2: "Value from Icon 2",
    viewAllMarks: "View all marks",
    noNoteTypesFound: "No note types found",
    visualComponentForEditor: "Visual component for editor",
    cannotExistMoreThanOneFileTypeWithSameCodeOrName:
        "There cannot be more than one file type with the same code or name",
    accumulatorDefinition: "Accumulator definition",
    familyAssignmentsCreation: "Family assignments creation",
    sendMessageToEvaluatorsRequestingPromptAttentionOnPerformanceRatings:
        "Do you want to send the selected evaluators a message requesting prompt attention to performance ratings?",
    bulkPhotoUpload: "Bulk photo upload",
    usedBenefits: "Used benefits",
    mandatoryPercentage: "Mandatory percentage",
    isDetailTable: "Is detail table",
    union: "Union",
    targets: "Targets",
    newRecordsCannotHaveSameTableTypeAndYearAsOriginalRecords:
        "New records cannot have the same table type and year as the original records",
    copy: "Copy",
    deleteRecordsConfirmation: "Do you want to delete the records?",
    youMustSelectACertificate: "You must select a certificate",
    nonChargeable: "Non-chargeable",
    structuresCannotHaveSameCodeOrName: "Structures cannot have the same code or name",
    executionDate: "Execution date",
    newReason: "New reason",
    recomposePeriodAccumulators: "Recompose period accumulators",
    cannotExistMoreThanOneFieldWithSameOrderNumber: "There cannot be more than one field with the same order number",
    selectUserToBlock: "Select which user you want to block",
    selectProcessToQuery: "Select process to query",
    requestDeletedSuccessfully: "Request deleted successfully",
    icon2Box: "Icon 2 BOX",
    deleteSpecialProcessConfirmation: "Do you want to delete the special process?",
    after: "After",
    documentName: "Document name",
    allAccessGroups: "All access groups",
    createAction: "Create action",
    sentimentAnalysis: "Sentiment analysis",
    accumulatorName: "Accumulator name",
    competencyUpdatedSuccessfully: "Competency updated successfully",
    responseDistribution: "Response distribution",
    modeling: "Modeling",
    uploadPhotos: "Upload photos",
    rangesFor9boxes: "Ranges for 9-Boxes",
    consentTypeUpdatedSuccessfully: "Consent type updated successfully",
    addCollaboratorList: "Add collaborator list",
    unsavedChangesConfirmation: "There are unsaved changes, are you sure you want to leave?",
    indicateProfileParameters: "Indicate profile parameters",
    postponeLoanInstallmentsConfirmation: "Are you sure you want to postpone the loan installments?",
    comparative: "Comparative",
    conceptSetCreatedSuccessfully: "Concept set created successfully",
    evaluationStatus: "Evaluation status",
    noteStatusMustBeFinalToAcceptOrObjectYourPerformanceEvaluation:
        "To accept or object to your performance evaluation, the note status must be final",
    kpiIconographyIcons: "KPI Iconography - Icons",
    queryParameterDuplicatedSuccessfully: "Query parameter duplicated successfully",
    pointsRedemption: "Points redemption",
    publicationEndDate: "Publication end date",
    minimumNote: "Minimum note",
    pointsForMedalTable: "Points for medal table",
    statusR2a:
        "If the final grades defined for the process award points for the medal table, these points will be assigned when this status is reached.",
    evaluationProcessUpdatedSuccessfullyMedalPoints:
        "Evaluation process successfully updated and points assigned to the medal tables of those evaluated according to their grades obtained",
    evaluationProcessUpdatedSuccessfullyMedalPointsDeleted:
        "Evaluation process updated successfully. Points awarded to the medal tables have been deleted.",
    newUserMenu: "New user menu",
    vacationsUpdatedSuccessfully: "Vacations updated successfully",
    sendReminderMessage: "Send reminder message",
    noMaterialsOrResourcesFound: "No materials or resources found",
    totalEmployerContributions: "Total employer contributions",
    objectiveTypeCreatedSuccessfully: "Objective type created successfully",
    employeeCannotBePublishedMoreThanOnceForSameConsentType:
        "Employee cannot be published more than once for the same consent type",
    positionName: "Position name",
    importPermissions: "Import permissions",
    blockedUsersInSocial: "Blocked users in Social",
    projectUpdatedSuccessfully: "Project updated successfully",
    specializationCreatedSuccessfully: "Specialization created successfully",
    standard: "Standard",
    createBenefitType: "Create benefit type",
    shiftCreation: "Shift creation",
    fromPublications: "From publications",
    clickOnTheGraphToSeeDetails: "Click on the graph to see details",
    recommendation: "Recommendation",
    queryMustBeActive: "Query must be active",
    loanDate: "Loan date",
    completedFemalePlural: "Completed",
    maxOvertimeHoursForPreauthorization: "Daily hours in contract",
    othersFemale: "Others",
    noSignatoriesRegistered: "No signatories registered",
    classification9boxes: "9-Boxes classification",
    recordUpdatedSuccessfully: "Record updated successfully",
    nameUnderWhichItWillBePublished: "Name under which it will be published",
    bulkDuplicate: "Bulk duplicate",
    deleteCompetencyConfirmation: "Do you want to delete the competency?",
    vacationTypeString: "Vacation type string",
    ascendingEvaluationWeighted: "Weighted ascending evaluation",
    atLeastOneObjectiveTypeMustBeEvaluated: "At least one objective type must be evaluated",
    earnedLegalAndOthers: "Earned (legal and others)",
    duplicateScheduling: "Duplicate scheduling",
    currentConsultationHour: "Current consultation hour",
    areYouSureYouWantToDeleteTheQuestion: "Are you sure you want to delete the question?",
    doYouWantToDeleteTheLoan: "Do you want to delete the loan?",
    markRecordsAsObservedForLaterReview: "Mark records as observed (For later review)",
    payrollTypeDuplicatedSuccessfully: "Payroll type duplicated successfully",
    destinationTableName: "Destination table name",
    acceptOrObject: "Accept or object",
    doYouWantToDeleteTheSelectedDocuments: "Do you want to delete the selected documents?",
    documentGeneratedSuccessfullyAndSentForEmployeeReceipt:
        "Document generated successfully and sent for employee receipt",
    periodDeletedSuccessfully: "Period deleted successfully",
    objectiveTypes: "Objective types",
    youCanSendUsYourQueriesMakeClaimsContributeSuggestionsAndReportComplaints:
        "You can send us your queries, make claims, contribute suggestions, and report complaints.",
    cannotDeleteFileTypeBecauseItIsInUse: "Cannot delete file type because it is in use",
    mayShort: "May",
    doYouWantToDeleteTheChannelType: "Do you want to delete the channel type?",
    importFinishedCheckFileForResult: "Import finished, check file for result",
    pointsAvailableForRedemption: "Points available for redemption",
    medicalLeaves: "Medical leaves",
    actionTypesCreation: "Action types creation",
    functionCodeLong: "Function code",
    noGeoPositionInAttendanceMarkToShowOnMap: "No geolocation in attendance mark to show on map",
    forAscendingEvaluatorSelectionAllSelectedCollaboratorsMustHaveTheSamePosition:
        "For ascending evaluator selection, all selected collaborators must have the same position",
    cannotDeleteCostCenterBecauseItIsInUse: "Cannot delete cost center because it is in use",
    youCanPublish: "You can publish",
    valueUpToGreen: "Value up to Green",
    employeeMasterAlt: "Employee master",
    positionClassifications: "Position classifications",
    toDo: "To do",
    current: "Current",
    calculationIndicator: "Calculation indicator",
    onlyOpenProcesses: "Only open processes",
    selectRedemptionFormat: "Select redemption format",
    folderWithoutHiddenFiles: "Folder without hidden files",
    youCanSendUsYourQueriesMakeClaimsContributeSuggestions:
        "You can send us your queries, make claims, contribute suggestions, and propose improvements.",
    markWithScheduledNotice: "Mark with scheduled notice",
    sat: "Sat",
    onlySystemTablesCanHaveEditorsEnabledUserTablesAreAlreadyAutomaticallyEnabledForEditorCreation:
        "Only system tables can have editors enabled. User tables are already automatically enabled for editor creation.",
    abbreviationLabels: "Abbreviation labels",
    plan: "Plan",
    cannotDeleteLicenseBecauseItIsInUse: "Cannot delete license because it is in use",
    viewBenefitType: "View benefit type",
    duplicateVacationTable: "Duplicate vacation table",
    doYouWantToDeleteThePaymentMethod: "Do you want to delete the payment method?",
    monnone: "MonNone",
    cannotDeleteWorkplaceBecauseItIsInUse: "Cannot delete workplace because it is in use",
    deleteCollaborator: "Delete collaborator",
    evaluatedComments: "Evaluated comments",
    areYouSureYouWantToApproveTheCalculationProcessAndMoveItToTheHistory:
        "Are you sure you want to approve the calculation process and move it to history?",
    licenseUpdatedSuccessfully: "License updated successfully",
    allFieldsAreRequiredAndAtLeastOneRatingMustExist: "All fields are required and at least one rating must exist",
    duplicateCompetency: "Duplicate competency",
    defaultProcess: "Default process",
    paymentMethodCreation: "Payment method creation",
    processDescriptionLong: "Process description",
    atLeastOneTransversalCompetencyMustBeSelected: "At least one transversal competency must be selected",
    wed: "Wed",
    evaluationGroup: "Evaluation group",
    noFamilyAssignmentsFound: "No family assignments found",
    columnSelectorType: "Column selector type",
    referenceQuotaNumber: "Reference quota number",
    profileCodeAlt: "Profile code",
    workdayChange: "Workday change",
    noStudyTypesFound: "No study types found",
    requestedValuePercentageOnSalary: "Requested value percentage on salary",
    timekeepingSystemChangeCompletedSuccessfully: "Timekeeping system change completed successfully",
    workplaceModifiedSuccessfully: "Workplace modified successfully",
    fromPeers: "From peers",
    subprocessType: "Subprocess type",
    benefitMaximumBudget: "Benefit maximum budget",
    maximumNote: "Maximum note",
    unemploymentInsuranceTaxableLimit: "Unemployment insurance taxable limit",
    monthlyContractHours: "Monthly contract hours",
    changeWorkday: "Change workday",
    noTemplatesFound: "No templates found",
    enterJobID: "Enter job ID",
    variableAccordingToType: "Variable according to type",
    managersUppercase: "Managers",
    recipientSelection: "Recipient selection",
    ufLastDayPreviousMonth: "UF last day of previous month",
    indicatorDeletedSuccessfully: "Indicator deleted successfully",
    theProcessScheduleWasCreatedSuccessfully: "Process schedule was created successfully",
    registrationName: "Registration name",
    specializationDeletedSuccessfully: "Specialization deleted successfully",
    alertAndEmailBodyText: "Text for alert and email body",
    dissemination: "Dissemination",
    extraFunction: "Extra function",
    noCostCentersFound: "No cost centers found",
    entryDelay: "Entry delay",
    noUserMenusFound: "No user menus found",
    commission: "Commission",
    versionCodeForDestinationTable: "Version code for destination table",
    mandatoryDocument: "Mandatory document",
    fieldsThatCouldNotBeDuplicated: "Fields that could not be duplicated",
    details: "Details",
    assignEmployeesToPlan: "Assign employees to plan",
    conceptEntryStructurexlsx: "Concept entry structure.xlsx",
    areYouSureYouWantToDeleteTheCommunication: "Are you sure you want to delete the communication?",
    sqlToExecuteWhenSaving: "SQL to execute when saving",
    timeReference: "Time reference",
    formName: "Form name",
    potentialEvaluationQuestions: "Questions for potential evaluation",
    benefitType: "Benefit type",
    noEvaluatorAssigned: "No evaluator assigned",
    cannotAccessBecausePINRecoveryIsInProcess: "Cannot access because PIN recovery is in process.",
    ratingString: "Rating string",
    evaluationTypesAndTheirWeights: "Evaluation types and their weights",
    objectiveTypesCreation: "Objective types creation",
    cannotHaveMoreThanOneFamilyAssignmentSharingSameBracket:
        "There cannot be more than one family assignment sharing the same bracket",
    cannotEditCommunicationBecauseItHasAssignedResponsible:
        "Cannot edit communication because it has an assigned responsible",
    newHealthInstitution: "New health institution",
    nullify: "Nullify",
    costCenterDesc4: "Cost center description 4",
    thirdPartyClassificationCreation: "Third-party classification creation",
    summaryAndVisualization: "Summary and visualization",
    noAccumulatorsFound: "No accumulators found",
    alertOrNoticeText: "Alert or notice text",
    usesMultipleApproversOrSigners: "Uses multiple approvers or signers?",
    usageFrequency: "Usage frequency",
    actionOrMomentCode: "Action or moment code",
    jobMotivationalPotential: "Job motivational potential",
    doYouWantToDeleteTheFile: "Do you want to delete the file?",
    mail: "Mail",
    birthDate: "Birth date",
    importOvertimeAuthorization: "Import overtime authorization",
    unauthorizedOvertime: "Unauthorized overtime",
    doYouWantToDeleteTheAlert: "Do you want to delete the alert?",
    companyDepartmentStructure: "Company department structure",
    exportCostDistributionTemplate: "Export cost distribution template",
    fieldCode: "Field code",
    finalRatingDate: "Final rating date",
    communicationsWhereYouAreResponsibleForTheAttentionOrCanSelfAssignResponsibility:
        "Communications where you are responsible for the attention or can self-assign responsibility",
    doYouWantToDeleteTheSchedule: "Do you want to delete the schedule?",
    cannotHaveMoreThanOnePayrollTypeSharingSameCodeOrName:
        "There cannot be more than one payroll type sharing the same code or name",
    additionalDaysCanContainUpTo3Decimals: "Additional days can contain up to 3 decimals",
    pendingQuotas: "Pending quotas",
    orderSavedSuccessfully: "Order saved successfully",
    organizationDefinition: "Organization definition",
    reasonCode: "Reason code",
    permissionDeletedSuccessfully: "Permission deleted successfully",
    dataImportMethod: "Data import method",
    accountUpdateDate: "Account update date",
    noMedicalLeaveTypesFound: "No medical leave types found",
    cannotDeleteJobGroupForEvaluationsBecauseItIsInUseInPerformanceForms:
        "Cannot delete job group for evaluations because it is in use in performance forms",
    alphanumericValue: "Alphanumeric value",
    forMassDepartmentalStructureChangeOnlyActiveEmployeesShouldBeSelected:
        "For mass departmental structure change only active employees should be selected",
    noIncomeStructuresFound: "No income structures found",
    transversalCompetenciesAndTheirWeightsDetail: "Detail of transversal competencies and their weights",
    justifyAbsence: "Justify absence",
    progressfilter: "Progress filter",
    cannotDeleteCommunicationBecauseItHasAssignedResponsible:
        "Cannot delete communication because it has an assigned responsible",
    generateImageWithGroupOfPeople: "Generate image with group of people",
    templateUpdatedSuccessfully: "Template updated successfully",
    laborInstance: "Labor instance",
    deleteMedicalLeaveType: "Delete medical leave type",
    paymentToThirdPartyComments: "Comments on payment to third party",
    activation: "Activation",
    quotaValue: "Quota value",
    byRole: "By role",
    icon1Box: "Icon 1 box",
    finalPerformanceRatingType: "Final performance rating type",
    whatsappTemplate: "WhatsApp template",
    employeeStatusInPlan: "Employee status in plan",
    fieldName: "Field name",
    recordsDeletedSuccessfully: "Records deleted successfully",
    noCurrentDataToGraph: "No current data to graph",
    cajaContributionPercentage: "CAJA contribution percentage",
    theFollowingStructuresCannotBeImportedBecauseTheyHaveDataInDestination:
        "The following structures cannot be imported because they have data in destination: ",
    absenceDeletedSuccessfully: "Absence deleted successfully",
    doYouWantToDeleteTheFunction: "Do you want to delete the function?",
    publicationCreatedSuccessfully: "Publication created successfully",
    numericFieldsMustHavePositiveValues: "Numeric fields must have positive values",
    payrollTypeCodeDoesNotExistInDatabase: "Payroll type code does not exist in database",
    managementCostCenter: "Management cost center",
    profileNameAlt: "Profile name",
    forecast: "Forecast",
    calibratedRatingObjectives: "Calibrated rating objectives",
    noValue: "No value",
    level: "Level",
    annotationsVisibilityOnlyAllowedInDescendingEvaluations:
        "Annotations visibility only allowed in descending evaluations",
    sourceTable: "Source table",
    printCurrentAccount: "Print current account",
    categories: "Categories",
    dimension5: "Dimension 5",
    groupLeftSuccessfully: "Group left successfully",
    permissionStartDate: "Permission start date",
    calculationBase: "Calculation base",
    totalEmployerContributionsNote: "Total employer contributions (employer payments)",
    totalHours: "Total hours",
    learnMore: "Learn more...",
    group11: "Group 11",
    minimumValue1: "Minimum value 1",
    discountStartPeriod: "Discount start period",
    forMassCostCenterChangeOnlyActiveEmployeesShouldBeSelected:
        "For mass cost center change only active employees should be selected",
    messageSentSuccessfully: "Message sent successfully",
    codeShort: "Code",
    pleaseSpecifyNewRecognitionPlanParameters: "Please specify the new recognition plan parameters",
    thereIsAlreadyASubmissionForThisDay: "There is already a submission for this day",
    evaluatedName: "Evaluated name",
    socialSecurityInstitution: "Social security institution",
    consentType: "Consent type",
    surveyDefinition: "Survey definition",
    standardPerformance9boxes: "Standard performance 9-Boxes",
    calibratedPerformance9boxes: "Calibrated performance 9-Boxes",
    valueFromIcon3: "Value from Icon 3",
    quotaNumber: "Quota number",
    evaluationType: "Evaluation type",
    youMustSelectAGeneralManagement: "You must select a general management",
    feedbackPurposeCreation: "Feedback purpose creation",
    duplicateEmployee: "Duplicate employee",
    medicalExamsDefinition: "Medical exams definition",
    setFixedFilters: "Set fixed filters",
    removeFixedFilters: "Remove fixed filters",
    actionTypeDeletedSuccessfully: "Action type deleted successfully",
    deleteWorkplace: "Delete workplace",
    createVacation: "Create vacation",
    additionalOrProgressiveDays: "Additional or progressive days",
    doYouWantToDeleteTheLicense: "Do you want to delete the license?",
    classificationStartDate: "Classification start date",
    authToken: "AuthToken",
    nameCannotExceed60Characters: "Name cannot exceed 60 characters!",
    numShort: "Num",
    recipient: "Recipient",
    openMapLatitudeLongitude: "Open map (Latitude and Longitude)",
    byAccountAndProject: "By account and project",
    used: "Used",
    linkedTask: "Linked task",
    requirementsAndConditions: "Requirements and conditions",
    medicalExams: "Medical exams",
    unsavedChangesDoYouWantToExitAnyway: "There are unsaved changes, do you want to exit anyway?",
    consents: "Consents",
    receiveNoticeString: "Receive notice string",
    requestBenefit: "Request benefit",
    positive: "Positive",
    consultationsDefinition: "Consultations definition",
    planCode: "Plan code",
    doYouWantToDeleteTheSelectedAlerts: "Do you want to delete the selected alerts?",
    contract: "Contract",
    noDocumentsPublishedWithoutDigitalSignature: "No documents published without digital signature",
    associatedGrid: "Associated grid",
    schoolCertificateYear: "School certificate year",
    reject: "Reject",
    deleteScheduleAlt: "Delete schedule",
    userMenuCreatedSuccessfully: "User menu created successfully",
    forMassWorkScheduleChangeOnlyActiveEmployeesShouldBeSelected:
        "For mass work schedule change, only active employees should be selected",
    managerColon: "Manager: ",
    totalLoansGranted: "Total loans granted",
    surveyIsInUseInOnboardingMaterialsCannotBeDeleted:
        "The survey is in use in onboarding materials and resources, it cannot be deleted",
    bankSettings: "Banks",
    bankSettingsCode: "Bank code",
    bankSettingsCollaboratorsWithThisBank: "Collaborators assigned to this bank",
    bankSettingsDuplicatedData: "The bank code or name is already in use",
    bankSettingsInUseAssetsDiscounts: "The bank is assigned to Income and Deductions",
    bankSettingsInUseCollaborator: "The bank is assigned to a collaborator",
    bankSettingsName: "Bank name",
    bankSettingsNew: "New bank",
    bankSettingsNoAssociatedCollaborator: "No collaborators assigned to this bank",
    bankSettingsNoBanksFound: "No banks found",
    createBankTitle: "Bank creation",
    deleteBankMessage: "Do you want to delete the bank?",
    deleteBankTitle: "Delete bank",
    viewBankAssociatedCollaborators: "View employees assigned to this bank",
    findEmoji: "Find emoji",
    emojisAndPeople: "Emojis and people",
    animalsAndNature: "Animals and nature",
    foodAndDrinks: "Food and drinks",
    activities: "Activities",
    travelAndPlaces: "Travel and places",
    objects: "Objects",
    symbols: "Symbols",
    noSystemTables: "No system tables available at the moment",
    noUserTables: "No user tables available at the moment",
    viewMyUsedBenefits: "View my used benefits",
    benefitsToRequest: "Benefits to request",
    youHaveAMoneyBenefit: "You have a direct payment benefit!",
    requestVacations: "Request vacations",
    activeCalendar: "Active calendar",
    clickScheduleToRequestChange: "Click on schedule to request change.",
    yourWeeklyHoursContract: "Your weekly hours by contract",
    filterTypes: "Filter types",
    assistanceExitPlace: "Assistance exit location",
    exitReference: "Exit reference",
    exitOrigin: "Exit origin",
    timeBetweenMarks: "Time between marks",
    exitCoordinates: "Exit coordinates",
    evaluatedFullName: "Evaluated full name",
    evaluatorFullName: "Evaluator full name",
    evaluationDateFrom: "Evaluation date from",
    evaluationDateTo: "Evaluation date to",
    partialNotePerformance: "Partial note performance",
    finalNotePerformance: "Final note performance",
    executeProcess: "Execute process",
    workMode: "Work mode",
    subsidyYoungWorker: "Subsidy young worker",
    insurancePolicyType: "MCC - Policy type",
    insuranceValueUF: "MCC - Premium value in UF",
    insurancePolicyNumber: "MCC - Policy number",
    rateAllEvent: "Idemnization rate all event",
    unitAssignationDate: "Unit assignation date",
    icariusAccessEnabled: "ICARIUS access enabled",
    icariusAccess: "ICARIUS access",
    clickScheduleToChangeDoubleCkickToAuth:
        "Click on schedule to change it. Double click on white area to authorize extra hours",
    types: "Types",
    assetsDiscountsIssues: "Income, deductions and issues",
    issueMatrix: "Issue matrix",
    selectTemplateSingle: "Select template",
    extraHoursToAuth: "Extra hours to authorize",
    onlyExtraHoursToAuth: "Only extra hours without authorization",
    openCalendars: "Open calendars",
    historicCalendars: "Historic calendars",
    audio: "Audio",
    mustEnterDisagreementReason: "Must enter disagreement reason",
    low: "Low",
    mid: "Mid",
    high: "High",
    withPerformanceClassificationNoPotential: "With performance classification but no potential",
    withAccessFor: "With access for",
    consent: "Consent",
    useOrAccessRequired: "Use or access required",
    answers: "Answers",
    viewAttachmentClickToOpen: "View attachment (click to open)",
    beforeAnsweringCheckAttachment: "Before answering, please check attachment (click to open)",
    clickImageToEnlarge: "Click image to enlarge",
    processStartedCorrectly: "Process started correctly",
    mustSelectAtLeastOneUser: "Must select at least one user",
    nextSigner: "Next signer",
    itContainsDigitalWarehouse: "It contains digital warehouse.",
    youHaveNoAccessToDigitalFolderOf: "You have no access to digital folder of",
    filesWithWrongCode: "There are files with the wrong code",
    filesWithWrongExtension: "There are files with the wrong extension",
    digitalWarehouseTypesOfFiles: "Digital Warehouse Types of Files",
    noInformationFound: "No information found",
    contractualDataSuccessfullyModified: "Contractual data has been successfully modified",
    resizingPositionsWarning:
        "If you click RESIZE POSITIONS AND MODIFY, the position change will be applied and for both positions (Origin and Destination) the number of positions will be automatically reassigned and will be fully occupied.",
    forbidden: "Forbidden",
    businessUnitCreation: "Business unit creation",
    anErrorOccurred: "An error has occurred",
    schoolingSuccessfullyDeleted: "Schooling successfully deleted",
    selectedAnnotationHasNoEvidence: "The selected annotation has no evidence",
    dataForRecalculation: "Data for recalculation",
    errorWhileTryingToDeleteProcess: "An error occurred while trying to delete the process.",
    invalidSelectors: "Invalid selectors",
    checkThresholdsMatch: "Verify that the minimum and maximum grade thresholds match",
    minimumGreaterThanMaximum: "Minimum score is greater than maximum score",
    unsupportedFileType: "Unsupported file type",
    confirmUserDeletionFromList: "Are you sure you want to remove the user from the list?",
    evaluatorFullNamePlural: "Evaluator's last name and first names",
    breakExit: "Break exit",
    businessUnitName: "Business unit name",
    onlyOneLanguageWithSameCodeOrNameAllowed: "Only one language with the same code or name is allowed",
    assumedAllReportsPaymentsAndAccountingDone:
        "It will be assumed that you have issued all reports related to the process, made all respective payments (to both employees and third parties: banks, pension institutions, etc.), and recorded them as well.",
    evaluatedFullNamePlural: "Evaluatee's last name and first names",
    silverShieldsCount: "Number of silver shields",
    entryMode: "Entry mode",
    specifyColumnNumbersSeparatedByComma: "and indicate the column numbers separated by commas (e.g. 1,2,5)",
    exitHours: "Exit hours",
    businessUnit: "Business unit",
    newBusinessUnit: "New business unit",
    schoolingCreation: "Schooling creation",
    attendanceMarkingRange: "Allowed range for attendance marking",
    confirmRecordDeletion: "Are you sure you want to delete the record?",
    rateObjectivesWithPercentage: "Rate objectives with %",
    noInformationRetrieved: "No information retrieved",
    scheduleChangeNotAllowedDueToExcessHours:
        "Schedule change is not allowed because the total number of hours scheduled for the week exceeds the number contractually agreed with the employee",
    dateComma: "Fecha,",
    fromTo: "{from} to {to}",
    competencyOrigin: "Competency origin",
    warningBeforeEnablingEmployeesInPayroll:
        "Before enabling the selected employees in the chosen payrolls, note that all existing payroll authorizations for those employees will be deleted first.",
    calculationProcessPublishedSuccessfully: "The calculation process has been successfully published",
    quantityForPeriod: "Quantity for the period",
    globalEvaluationCountByGradeType: "Gaussian bell curve by grade type",
    evaluationLockedDueToCalibration:
        "You cannot modify the evaluation because the evaluatee has already been calibrated. You will only have view access.",
    meritsReceived: "Merits received",
    newLanguage: "New language",
    analyticsSummary: "Analytics summary",
    incidentType: "Incident type",
    fromIncidents: "From incidents",
    employeeCodeUpdatedSuccessfully: "Employee code successfully updated",
    executionModeAlreadyHasProcessDefined:
        "A process is already defined for this execution mode. Only one process is allowed.",
    requesterParenthesis: " (Requester)",
    disabilityInsurance: "Disability insurance",
    attendanceMarksRequireEntryOrExit: "Attendance marks must include an entry or exit date",
    calculationProcessDeletedSuccessfully:
        "The calculation process has been successfully removed from the published processes",
    invalidYearEntry: "You must enter a valid year, e.g. 2022",
    disability: "Disability",
    transversalCompetenciesWithoutIndicators:
        "You selected transversal competencies that do not have defined indicators for evaluation",
    healthInstitutionUppercase: "Health Institution",
    jobStatistics: "Job statistics",
    workOrProjectModifiedSuccessfully: "The work or project has been successfully modified",
    protected: "Protected",
    generateInstallments: "Generate installments",
    schoolingSingular: "Schooling",
    performanceEvaluationCalibrationAlt: "Performance evaluation calibration",
    weighted20Percent: "Weighted 20%",
    goldShieldsCount: "Number of gold shields",
    processCodeAlt: "Process code",
    cannotDeleteBusinessUnitInUse: "Cannot delete the business unit because it is in use",
    gradesDisplayedAreNotFinal:
        "The grades and scores shown are not final and only consider evaluations completed so far.",
    invalidRut: "The entered RUT is not valid",
    demeritsReceived: "Demerits received",
    cannotSelectSelf: "You cannot select yourself",
    percentageRankingByEvaluated: "Percentage ranking (%) by evaluatee",
    variableByType: "Variable by type",
    invalidInstallmentCount: "Invalid number of installments",
    mustSelectSingleItem: "You must select a single item",
    nameExceeds60Characters: "The name cannot exceed 60 characters",
    geoAnalysisQueryDefinition: "Geo-analysis query definition",
    businessUnitCode: "Business unit code",
    schoolingUpdatedSuccessfully: "Schooling successfully updated",
    onlyOneSchoolingWithSameCodeOrNameAllowed: "Only one schooling with the same code or name is allowed",
    choosePointAmountAndRedemptionType:
        "Choose the number of points to reach each recognition, and the redemption type",
    invalidYear: "Invalid year",
    noLanguagesFound: "No languages found",
    conceptsWithoutAssignment: "Concepts without assignment",
    dailyUnit: "Daily unit",
    languageCreation: "Language creation",
    daysElapsed: "Days elapsed",
    conceptSetsWithDuplicateNameOrCodeNotAllowed: "Concept sets with duplicate name or code are not allowed",
    employeesWithPausedOnboarding: "Employees with paused onboarding",
    listComma: "Lista,",
    onboardingStepChangeWarning:
        "If you change the timing or action type, materials or resources linked to the onboarding step that do not match the defined timing or action type will be deleted. Do you want to proceed anyway?",
    enterValidNumericValue: "Enter a valid numeric value.",
    numberOfEvaluated: "Number of evaluatees",
    invalidDataOrDateTimeExceedsNow:
        "There is invalid data, and the date and time cannot exceed the current date and time",
    welcomeToCommunicationChannel: "You're in our communication channel, welcome!",
    entryAndExitDaysMustBeContiguous: "The entry and exit days must be contiguous or the same",
    startDateCannotBeWeekendOrHoliday: "The start date cannot be a Saturday, Sunday, or holiday",
    customFormulaUppercase: "Custom formula",
    criticalIncidentLog: "Critical incident log (Annotations)",
    enterValidPercentage: "Enter a valid percentage",
    duplicateProfileNamesNotAllowed: "Profiles cannot have duplicate names",
    clickAreaTrackingHelp:
        "to later know in which area of the chart the click was made. That code will be loaded into the variable #CODE1# and the",
    enteredCodeIsInvalid: "The entered code is invalid",
    dailyUnitString: "Daily unit string",
    silverMedalsCount: "Number of silver medals",
    mandatoryValue: "Mandatory value",
    averagePercentageRankingByEvaluator: "Average percentage ranking (%) by evaluator",
    attachmentsCount: "Number of attachments",
    useMultipleApproversOrSignatories: "Do you use multiple approvers or signatories?",
    deleteBusinessUnit: "Delete business unit",
    acceptingTheEvaluationWillGenerateADocument:
        "Accepting the evaluation will generate a digitally signed document that will be saved in your digital folder",
    cannotDeleteConsentForEmployee: "Cannot delete consent for the employee because it has already been received",
    disabilityString: "Disability string",
    daysElapsedSinceEntry: "Days elapsed since entry",
    goldMedalsCount: "Number of gold medals",
    invalidReferenceInstallmentNumber: "The reference installment number is invalid",
    confirmLanguageDeletion: "Do you want to delete the language?",
    incidentsAlreadyExistInDateRange: "There are already incidents within the entered dates, the leave cannot be saved",
    fullName: "Full name",
    activeAndPausedPlans: "Active and paused plans",
    schoolingString: "Schooling string",
    listSelectionTypeValidOnlyForParamsFromSQL:
        "List selection type is only valid for parameters whose value list is obtained using the SQL above",
    confirmProcessDeletion: "Are you sure you want to delete the process?",
    deleteSchooling: "Delete schooling",
    generalValuesUppercase: "General values",
    stopped: "Stopped",
    totalDaysSpentOnCare: "Total days spent on care",
    optionalKpiSqlDescription:
        "Optional. If present, the result of this SQL will be displayed in a grid when clicking on the KPI. If it is a nested KPI, it will be shown when clicking on the final chart.",
    allowedCharactersLettersNumbersDash: "Allowed: letters, numbers, and dash (-)",
    maxGrade: "Grade up to",
    newSchooling: "New schooling",
    confirmSchoolingDeletion: "Do you want to delete the schooling?",
    noMoreThanOneFieldWithSameOrderNumber: "There cannot be more than one field with the same order number",
    downloadEvidence: "Download evidence",
    sqlForKpiSubtitle: "SQL for KPI subtitle (Optional and depends on each KPI)",
    reviewDate: "Review date",
    functionNameRestrictions:
        "The function name can only contain characters from 'a' to 'z'. The letter 'ñ' and spaces are not allowed.",
    sqlVisualizationColumnTypes:
        "For each visualization SQL column, selector types can be: Lista, Fecha, Alfa, Num, Mon.",
    noDuplicateProfileCodes: "Profiles cannot have duplicate codes",
    weakness: "Weakness",
    incidentsAlreadyExistInEnteredDates:
        "There are already incidents within the entered dates, the absence cannot be saved",
    daysElapsedWithoutReception: "Days elapsed without reception",
    invalidEnteredTime: "The entered time is not valid",
    maxGradeCannotExceed9999: "The maximum grade cannot exceed 9999",
    communicationAlreadyCompleted: "The communication has already been completed",
    confirmBusinessUnitDeletion: "Do you want to delete the business unit?",
    schoolingCreatedSuccessfully: "Schooling created successfully",
    sqlGraphsColumnSelectionInstructions:
        "For SQL graphs you must always select 2 columns: the first must be alphanumeric and will be used as the series name, and the second must be numeric and will be used as the series value, except for Radar charts, where multiple numeric columns can be selected (ideally 5 to 10). For pie, horizontal, vertical, or line charts with nested KPIs, include a third alphanumeric column containing the",
    cannotEditBecauseDigitallySigned: "Cannot edit because it has been digitally signed",
    calculationSequenceUppercase: "Calculation sequence",
    exitTimeMustBeGreaterThanOrEqualToEntry: "Exit date and time must be greater than or equal to entry date and time",
    feedbacksReceivedDuringPeriod: "Feedbacks received during the period",
    noDuplicateStepNames: "Steps cannot have duplicate names",
    workDayDataSuccessfullyModified: "Workday data successfully modified",
    momentarilyStopped: "Momentarily stopped",
    allowedRangeFromGeoposition: "Allowed range from geoposition",
    numberOfPositionsCannotBeZero: "Number of positions cannot be zero",
    positionsMustBeANumber: "Number of positions must be a number",
    units: "Units",
    thankYouForReporting:
        "Thank you for sharing your report with us. We will assign a responsible person shortly and guarantee full confidentiality.",
    codeCannotExceed8Characters: "Code cannot exceed 8 characters",
    vacationTableDuplicatedSuccessfully: "Vacation table successfully duplicated",
    noMoreThanOneBusinessUnitWithSameCodeOrName:
        "There cannot be more than one business unit with the same code or name",
    percentageSumMustBe100: "The total percentage must be 100%",
    bronzeShieldsCount: "Number of bronze shields",
    recordDeletionPossibleOnlyWhen: "Record can only be deleted when",
    requiredPoints: "Required points",
    positionSuccessfullyModified: "Position successfully modified",
    validValuesList: "List of associated valid values",
    fieldHasValidValuesList:
        "This field has an associated list of valid values. Therefore, the dropdown will be loaded automatically unless you enter your own SQL for the list.",
    cannotDeleteSchoolingBecauseInUse: "Cannot delete schooling because it is in use",
    freePositionsMustBeANumber: "Free positions must be a number",
    gradeFrom: "Grade from",
    deleteField: "Delete field",
    createField: "Create field",
    modifyField: "Modify field",
    fieldCreatedOK: "Field created successfully",
    fieldEditedOK: "Field edited successfully",
    fieldNoExist: "The field you want to modify does not exist",
    fieldDeletedOK: "Field successfully deleted",
    defaultValue: "Default value",
    notNull: "Not null",
    addOption: "Add option",
    cannotDeleteBenefitOrDiscountBySociety: "Cannot delete a benefit or discount whose entry method is by society",
    requiredSeniorityMonths: "Required months of seniority",
    cannotDeleteLanguageBecauseInUse: "Cannot delete the language because it is in use",
    indicatorNumberAlt: "Indicator number",
    cannotDeleteRecordBecauseIntegrityControl:
        "Cannot delete the record because the associated detail table has integrity control",
    serverErrorOccurred: "A server error occurred",
    deleteLanguage: "Delete language",
    totalRecognitionsCount: "Total number of recognitions",
    processAlreadyPublished: "This process has already been published",
    globalEvaluationCountByGradeAndEvaluator: "Global evaluation count by grade type and evaluator",
    bankAndAccountFieldsCannotBeEmpty: "Bank and bank account fields cannot be empty",
    actionsOrResponsesCount: "Number of actions or responses",
    confirmDownloadFolderWithoutHiddenFiles: "Do you want to download the folder without hidden files?",
    cannotDeletePeriodForObjectivesBecauseInUse:
        "Cannot delete the period for objectives because it is used in defined Goals and Objectives for employees",
    installmentsCount: "Number of installments",
    invalidFileExtension: "Invalid file extension",
    feedbackCanOnlyBeGivenIfGradeStatusIsFinal: "To give feedback, the evaluatee's grade status must be 'Final Grade'",
    incidentsAlreadyExistInDateRangePermissionCannotBeSaved:
        "There are already incidents within the entered dates, the permission cannot be saved",
    requiredPointsForBenefitMustBeEntered: "You must enter the required points for the benefit",
    ifUnsureOfStructureUseWagesAndDiscountsFunction:
        "If you're unsure about the structure to use, go to the Wages and Discounts function, select an entry method, and within it select the desired structure. Then click the icon to export the import structure.",
    pleaseEnterConceptCodeAndName: "Please enter the concept code and name. These values will replace the originals.",
    historicalData: "Historical",
    noSeniorityRequired: "No seniority required",
    verifyThatCellsInDateAreComplete: "Verify that the 'On date' cells are complete",
    ifEnteringIntegrityControlDataEnterAll3Fields:
        "If entering data for integrity control, all 3 fields must be filled",
    numberOfPositionsCannotBeLessThanOccupiedPositions:
        "The number of positions cannot be less than the number of occupied positions",
    invalidEnteredValue: "The entered value is not valid",
    youHaveASubmissionWithPendingDocumentationApproval:
        "You have a request with pending documentation approval in progress",
    noBusinessUnitsFound: "No business units found",
    conceptCodeIsInvalidCanContainOnlyLettersNumbersAndCharacters:
        "The concept code is invalid. It can only contain letters, numbers, and the following characters",
    holidayTableDuplicatedSuccessfully: "Holiday table duplicated successfully",
    countryOfResidence: "Country of residence",
    sumOfCompetenciesMustBe100: "The sum of competencies must be 100%",
    allAnswers: "All answers",
    globalQuantities: "Global quantities",
    scheduledExit: "Scheduled exit",
    ifYouPressCancelNoModificationWillBeMade:
        "If you press CANCEL, no modification will be made, and you must reassign the number of positions for the target role from the 'Job Structure' function to free the required positions",
    verifyThatCellsHaveValidValues: "Verify that the cells have valid values",
    recognitionPointsReceived: "Recognition points received",
    forExternalDocumentsYouCanDecideIfAcceptanceIsRequired:
        "For external documents, you can decide if acceptance is required at the time of signing",
    whatsappTemplateAlt: "WhatsApp Template",
    sumOfPendingInstallmentsDoesNotMatchPendingBalance:
        "The sum of pending installments does not match the pending balance",
    totalCount: "Total count",
    occupiedPositionsMustBeANumber: "The number of occupied positions must be a number",
    evaluatedColon: "Evaluated:",
    fromClickedAreaFirstColumnInDescVariable:
        "from the clicked area, first column, in the variable #DESC1#. If a second chart is accessed, the same will happen and variables #CODE2# and #DESC2# will be loaded",
    quantity: "(Quantity)",
    atLeastOneCompetencyMustBeSelectedSumMustBe100:
        "At least one competency must be selected. The total sum of competencies must be 100%",
    unit: "Unit",
    uponRequest: "Upon request",
    viewGaussBell: "View Gaussian bell curve",
    gausBell: "Gaussian bell curve",
    noData: "No data available",
    averageGlobalPercentageRankingByGroups: "Average global percentage ranking by groups",
    noSchoolingsFound: "No schoolings found",
    sumOfAllWeightedEvaluationsMustBe100: "The total sum of all weighted evaluations must be 100%",
    cannotDeleteBecauseDigitallySigned: "Cannot delete because it has been digitally signed",
    bronzeMedalsCount: "Number of bronze medals",
    viewEntryHelp: "View entry help",
    pointsExchangeModeRequiresRequiredPoints:
        "To define access mode by point redemption, you must enter the required points",
    daysWorkedCount: "Number of days worked",
    incidentsAlreadyExistInEnteredDatesVacationsCannotBeSaved:
        "There are already incidents within the entered dates, the vacation cannot be saved",
    invalidDate: "Invalid date",
    chosenDateIsInUse: "The chosen date is already in use",
    considerThatSelectedFileMustBeCompatibleWithWagesAndDiscountsImportStructures:
        "The selected file must be compatible with the import structures for Wages and Discounts",
    doYouConsiderTheFollowingAs: "Do you consider the following as",
    enteredQuantityExceedsMaximumDaysForPermissionType:
        "The entered quantity exceeds the maximum number of days for this type of permission",
    currencySettings: "Currencies",
    deleteCurrencyTitle: "Delete currency",
    deleteCurrencyMessage: "Do you want to delete the currency?",
    viewCurrencyAssociatedCollaborators: "View employees with salary or wage assigned to this currency",
    createCurrencyTitle: "Create currency",
    currencySettingsCode: "Currency code",
    currencySettingsName: "Currency name",
    currencySettingsNew: "New currency",
    currencySettingsNoCurrenciesFound: "No currencies found",
    currencySettingsCollaboratorsWithThisCurrency: "Employees with salary or wage assigned to this currency",
    currencySettingsDuplicatedData: "The currency code or name is already in use",
    currencySettingsInUseCollaborator: "The currency is assigned to an employee's salary or wage",
    currencySettingsNoAssociatedCollaborator: "No employees with salary or wage assigned to this currency",
    currencyUpdatedOk: "The currency was succesfully updated",
    currencyCreatedOk: "The currency was succesfully created",
    currencyDeletedOk: "The currency was succesfully deleted",
    changeRole: "Change role",
    roleChangedOk: "Role changed successfully",
    noUtilsDownloads: "No utils downloads at the moment",
    previousMenuLocation: "Previous menu location",
    deleteWorkAndTask: "Delete work/task",
    doYouWishToDeleteWorkAndTask: "Do you wish to delete work/task?",
    workAndTaskCreation: "Work/task creation",
    newWorkAndTask: "New work/task",
    noWorkAndTask: "No work/task found",
    workTaskRepeatedCode: "There can't be more than one work/task with the same code",
    workTaskDeletedOk: "Work/task deleted successfully",
    workTaskCreatedOk: "Work/task created successfully",
    workTaskUpdatedOk: "Work/task updated successfully",
    areYouSureYouWantToRunTheProcessWithName: "Do you want to execute the process: {process}?",
    accessGroupsAmount: "{amount} access group(s)",
    accessCreation: "Access creation",
    userAssignedToCalculation1: "User is assigned to execution of alerts calculations.",
    userAssignedToCalculation2:
        "Before changing its status or deleting, replace user with other, in ‘Access and Properties",
    monthsBackwardsCalculations: "Months backwards for calculations",
    accumulatorDeletedOk: "Accumulator deleted succesfully",
    accumulatorCreatedOk: "Accumulator created succesfully",
    accumulatorUpdatedOk: "Accumulator updated succesfully",
    view2: "View",
    clickOnActionToChangeDate: "Click on planned action to change registration date or alert date",
    changeDates: "Change dates",
    actionTypeDeletedOk: "Action type deleted successfully",
    actionTypeCreatedOk: "Action type created successfully",
    actionTypeUpdatedOk: "Action type updated successfully",
    employersToReceiveRequests: "Employers to receive requests",
    alertActivation: "Alert activation",
    alertDefinition: "alert definition",
    howToIncludeSQLDataInMail:
        "If you wish to include SQL visualization data in the body of the mail, mark Save Reference and indicate the column numbers separeted by semicolon (Ex. 1,2,4)",
    systemAlerts: "System alerts",
    userAlerts: "User alerts",
    deleteAlertConfirmation: "Do you wish to delete the alert?",
    alertCreatedOk: "Alert created successfully",
    alertUpdatedOk: "Alert updated successfully",
    alertDeletedOk: "Alert deleted successfully",
    alertDuplicatedOk: "Alert duplicated successfully",
    alertActivationUpdateOk: "Alert activation updated successfully",
    templatesCreation: "Templates creation",
    deleteTypeOf: "Delete the {type}",
    deleteTypeOfConfirmation: "Do you wish to delete the {type}?",
    createTypeOf: "Creation of {type}",
    definitionTypeOf: "Definition of {type}",
    noFoundTypeOf: "No {type} found",
    newTypeOf: "New {type}",
    repeatedTypeOf: "There can't be more than one type of {type} with the same code or name",
    inUseTypeOf: "Can't delete this type of {type} because it's in use",
    typeOfDeletedOk: "Type of {type} deleted successfully",
    typeOfCreatedOk: "Type of {type} created successfully",
    typeOfUpdatedOk: "Type of {type} updated successfully",
    secuence: "Secuence",
    selectPayrollType: "Select payroll type",
    calculateProcess: "Calcute process",
    assetsAndDiscountsEntryByAPI: "Income and Deductions - Entry by API",
    bankDeletedOk: "Bank deleted successfully",
    bankCreatedOk: "Bank created successfully",
    bankUpdatedOk: "Bank updated successfully",
    dimension: "Dimension",
    planBenefit: "Plan benefit",
    collaboratorAcceptanceType: "Collaborator acceptance type",
    externalDocumentsHelperText:
        "For external documents, you will be able to choose if the acceptance type is neccesary when signing",
    selectTemplateRelatedToDocument: "Select template related to document",
    typeOfRequestRelatedToQuestion: "To which type of request is it related?",
    entry2: "entry",
    exit2: "exit",
    familyTypeCreation: "Family type creation",
    purposeDeletedOk: "Purpose deleted successfully",
    purposeCreatedOk: "Purpose created successfully",
    purposeUpdatedOk: "Purpose updated successfully",
    icariusPortal: "ICARIUS news portal",
    calificationToUse: "Calification to use",
    useColor: "Use color?",
    califications: "Califications",
    reasonDeletedOk: "Reason deleted successfully",
    reasonCreatedOk: "Reason created successfully",
    reasonUpdatedOk: "Reason updated successfully",
    turnDeletedOk: "Turn deleted successfully",
    turnCreatedOk: "Turn created successfully",
    turnUpdatedOk: "Turn updated successfully",
    scores: "Scores",
    authAbsenceDays: "Authorized absence days",
    imageSignatureNoDigital: "Image for signature not digital",
    pixels: "pixels",
    loginImage: "Login image",
    recommended: "recommended",
    setCorporateColor: "Set corporate color",
    doYouConsiderObservationsForAssistanceAnalysis: "Do you consider the next as observations for assistance analysis?",
    functionTypeCreation: "Function type creation",
    seniorityTo: "Seniority to (years)",
    absenceByTraining: "Absence by training",
    absenceCode: "Abscence code",
    absence: "abscence",
    medicalLicence: "medical licence",
    absenceTypeDeletedOk: "Absence type deleted successfully",
    absenceTypeCreatedOk: "Absence type created successfully",
    absenceTypeUpdatedOk: "Absence type updated successfully",
    permissionTypeDeletedOk: "Permission type deleted successfully",
    permissionTypeCreatedOk: "Permission type created successfully",
    permissionTypeUpdatedOk: "Permission type updated successfully",
    licenceTypeDeletedOk: "Licence type deleted successfully",
    licenceTypeCreatedOk: "Licence type created successfully",
    licenceTypeUpdatedOk: "Licence type updated successfully",
    balanceCC: "Balance available on current account",
    createKPIDefinition: "Create KPI definition",
    editKPIDefinition: "Edit KPI definition",
    kpiDefinitionGraphSQLHelper:
        "For SQL graph you must always select 2 columns, the first one of alphanumeric type will be used as the series name, the second one of numeric type will be used as value of the series, except in radar graphs, where there can be many numeric columns (Between 5 and 10 ideally). If it's a pie, horizontal, vertical or line graph and contains another KPIs, include a third alphanumeric column that contains the series code to later know which area of the graph was clicked. That code will be loaded in the #CODE1# variable and the name, 1st column, in #DESC1#. If you access a second graph, the same will happen, loading the variables #CODE2# and #DESC2#.",
    holidayType: "Holiday type",
    doYouWishToRquestBenefit: "Do you wish to request benefit {benefit}?",
    lastAccess: "Last access",
    moveToNoNecessaryWarning:
        "If you move the action to “Not necessary” bear in mind that you won't be able to move it to another status.",
    moveToDoneWarning1: "If you move the action to the Done column, it's because the task is finished.",
    moveToDoneWarning2: "You won't be able to move it to another status at a later time.",
    activateBySelection: "Activate by selection",
    allowConcurrentPayrollSameType: "Allow concurrent payroll of this type",
    enabledCollaboratorDetermination: "Enabled collaborators determination",
    payrollTypeDeletedOk: "Payroll type deleted successfully",
    payrollTypeCreatedOk: "Payroll type created successfully",
    payrollTypeUpdatedOk: "Payroll type updated successfully",
    selectPeriod: "Select period",
    doYouWantToRecompose: "Are you sure you want to recompose the historic acummulators of the period {period}",
    recomposingHistoricAccumulators: "Recomposing historic accumulators for {period}",
    recompositionFinished: "Recomposition of historic accumulators for {period} has finished",
    signDocumentWarning1: "Documents selected include simple and multiple aprobations.",
    signDocumentWarning2:
        "To sign the documentation, you must do it spliting groups of documents considering their aprobation type.",
    deleteRequestWarning:
        "If you confirm, the requester {appealer_name} and receptor of the request {responsible_name} will be notified that the {type} request with date {start_date} has been deleted, ¿Do you wish to continue?",
    deleteOpenRequestWarning: "Do you wish to delete the open request?",
    insurance: "Insurance",
    scheduleCodeForDate: "Schedule code for date",
    blockUserQuestion: "Do you wish to block {name}?",
    protectedOnEdit: "Protected on edit",
    deleteImageFieldQuestion: "Do you wish to delete image from field {name}?",
    deleteFileFieldQuestion: "Do you wish to delete file from field {name}?",
    manyRegistryWithSameFieldsWarning: "There cannot be more than one registry with these same fields",
    registriesDeletedOk: "Registries deleted successfully",
    registryCreatedOk: "El registro se ha creado correctamente",
    registryUpdatedOk: "El registro se ha actualizado correctamente",
    registryStartedOk: "El registro se ha iniciado correctamente",
    entryType: "Entry type",
    max40Char: "Amount of characters: {length}. Max allowed: 40.",
    repetitionControl: "Repetition control",
    dropdownSQLWarning1:
        "For this SQL, the first field from SELECT must be called Code, and it must contain the code for the dropdown list, and the second field must be called Name, and it must contain the description.",
    dropdownSQLWarning2: "If you use filter, include the field to filter as third field of the query",
    filterField: "Filter field",
    fieldDefinitionOfTable: "Field definition of table",
    cantChangeVisualComponent: "Can't change visual component because it's defined as filter field",
    cantDeleteFilterField: "Can't delete this field because it's defined as filter field",
    fieldDeletedOk: "Field deleted successfully",
    fieldCreatedOk: "Field created successfully",
    fieldUpdatedOk: "Field updated successfully",
    thirdPartyClassificationAlt: "Third party classification",
    conceptSetCreation: "Concept set creation",
    setType: "Set type",
    duplicateConceptSet: "Duplicate concept set",
    changeContractDataEmployeesQuestion: "Do you want to change the contract data to {length} collaborator(s)?",
    cantAddNewCollaboratorsToProcess1:
        "Can't add new collaborators to this process, there are advance activities for one or more collaborators already.",
    cantAddNewCollaboratorsToProcess2: "Create a new process to add new collaborators.",
    zeroHoursMinutes: "0,00 / 00:00 hours and minutes",
    currentBalance: "Current balance",
    positionNotEnoughSpaceWarning:
        "Destination position has not enough places for the massive change. It only has {amountInUse} free positions and it requires {amountNeeded}.",
    changePositionsQuestion: "Do you want to change the position to {length} collaborator(s)?",
    rehireQuestion: "Do you want to rehire {length} collaborator(s)?",
    changeWorkOrTaskQuestion: "Do you want to change work or task to {length} collaborator(s)?",
    changeCostCenterQuestion: "Do you want to change the cost center to {length} collaborator(s)?",
    payRollChangeWarning1:
        "You have modified the payroll eligibility and the employee is part of a current calculation process. It is necessary to fully recalculate the process if you wish to exclude this employee from it.",
    payRollChangeWarning2:
        "If you have disabled them from a type of payroll, you can also use the option to remove the employee from the calculation process without needing to perform a full recalculation.",
    markingSystemQuestion: "Do you want to change the marking system to {length} collaborator(s)?",
    salaryRequiredAndPositive: "Salary is required and must be a positive number",
    salaryMassiveChange: "Salary massive change",
    newSalary: "New salary",
    terminationQuestion: "Do you want to assign termination data to {length} collaborator(s)?",
    turnChangeQuestion: "Do you want to change turn data to {length} collaborator(s)?",
    fileWIthEmployeeCodeHelperText:
        "Files must begin with the employee code or the intern number followed by underscore (Ex. 12345_file_name.jpg)",
    workingDayQuestion: "Do you want to change the working day data to {length} collborator(s)?",
    massiveActions: "Massive/special actions",
    changeSalary: "Change salary",
    massiveChangeProcessWarning1:
        "You've changed data related to the activation of collaborators in calculation processes.",
    massiveChangeProcessWarning2:
        "Access those current calculation processes and update the collaborator list of collaborators selected for the process, because due to data you've changed, the selected collaborator list could've changed.",
    massiveChangeProcessWarning3: "After revision, we recommend you execute a total calculation process.",
    calculationProcesses: "Calculation processes",
    internNumberInUse:
        "Intern number in use, please assign a different one or leave it empty. Next one available is {nextInternalNumber}",
    internNumberInUse2: "Intern number in use, please assign a different one",
    inUseOnboardingWarning1: "Assigniation was not done.",
    inUseOnboardingWarning2: "You've selected employees assigned on a current onboarding process.",
    inUseOnboardingWarning3: "You must omit them from the selected list",
    createSpecialProcessParameter: "Create special process parameter",
    editSpecialProcessParameter: "Edit special process parameter",
    sqlParameterHelperText:
        'For this SQL query it\'s necessary that the fiest field in SELECT be called "Code", and it must contain the parameter code, and the second field be called "Name", and it must contain its description. Use AS to define an alias inside the SELECT and assign names to "Code" and "Name".',
    listSelectionType: "List selection type",
    requiredParameter: "Parameter required",
    specialProcessParameters: "Special process parameters",
    executeProcessQuestion: "Do you wish to execute the special process: {process}?",
    answersOf: "Answers of",
    npsRange1: "-100 a -1 (critical)",
    npsRange2: "0 a 49 (good)",
    npsRange3: "50 a 74 (very good)",
    npsRange4: "75 a 100 (excelent)",
    selectAtleastOneCollaborator: "Select at least one collaborator",
    createSkillBasedTraining: "Create skill-based training",
    byFilterAppliedPublicationsRelated: "According to applied filter/related publications",
    pollParticipationPercentage: "Poll participation percentage",
    pollTotalOver: "Amount of participants {answersAmount}, over a universe of {availableVoters}",
    competencyAssignedToGroup: "From the set of competencies for the position",
    assignedToPosition: "Assigned to position",
    skillToDevelop: "Skill to develop",
    selectedPolls: "Selected polls",
    createSkillBasedCourse: "Create skill-based course",
    createQueryDefinition: "Create query definition",
    editQueryDefinition: "Edit query definition",
    sqlSelectorsCouldBe: "For each SQL column, selector types could be",
    createQueryDefinitionParameter: "Create query parameter",
    editQueryDefinitionParameter: "Edit query parameter",
    queryParameters: "Query parameters",
    associateNewsToCollaborator: "Associate news to a collaborator",
    willIncludePhotoOf: "Will include photo of",
    viewAnswersAfterAnswering: "View answers after answering",
    anonymousFemale: "Anonymous",
    onlyForOnboarding: "Only for onboarding",
    relatedSpecialProcess: "Related special process",
    evaluatedGroupSelectedFromQuadrant: "Evaluated group selected from quadrant",
    amountOfCollaboratorsInQuadrant: "Amount of collaborators in this quadrant",
    yearsToCheck: "Years to check",
    directBoss: "Direct boss",
    analyticCloud: "Analytic cloud",
    evaluations: "Evaluations",
    globalAmountOfEvaluationsPerScore: "Global amount of evaluations by score",
    evaluatedGroupSelectedWithScore: "Evaluated group selected with score",
    amountOfCollaboratorsWithThisScore: "Amount of collaborators with this score",
    completeMarkTitle: "{name} - Complete mark of {entryOrExit1} for mark of {entryOrExit2} from {date} at {time}",
    markTitle: "{name} - Assistance mark for the day {date}",
    assistanceDateMustFitOpenCalendar: "Assistance date must relate to an open calendar",
    onlyMarksWithGeopositionWillShow:
        "Of all the attendance entries selected in the grid, only those with a geolocation record will be displayed on the map—for example, those made using the ICARIUS app.",
    deleteMarkQuestion: "Are you sure you want to delete for {name} their marks for the date {date}?",
    cantEditEmployeeHasNoOpenCalendar: "{name} has no open calendar, you can't edit the assistance mark.",
    employeeHasNoOpenCalendar: "{name} has no open calendar.",
    loanDiscount: "Loan discount",
    conceptEntryStructureAlt: "Concept entry structure",
    processApproval: "Process approval",
    specialAction: "Special action",
    entryMotive: "Entry motive",
    festivitiesTableTitle: "Holidays and festive days - Table {type} - Year {year}",
    deleteHolidayQuestion: "Do you wish to delete holiday {holiday} - {title}, for the table {type}?",
    newTableType: "New table type",
    duplicateQueryDefinition: "Duplicate query definition",
    createGeoanalysisDefinition: "Create geoanalysis query definition",
    editGeoanalysisDefinition: "Edit geoanalysis query definition",
    sqlSelectorTypes1: "For each SQL column, selector types can be: Lista,Fecha,Alfa,Num,Mon.",
    sqlSelectorTypes2:
        "If you want some of the columns to be unavailable for selection as a marker, choose from the list the columns according to their type, but select the ones marked as not eligible as a marker",
    createGeoanalysisParameter: "Create geoanalysis parameter",
    editGeoanalysisParameter: "Edit geoanalysis parameter",
    geoanalysisParameters: "Geoanalysis parameters",
    deleteSystemTable: "Delete system table",
    deleteUserTable: "Delete user table",
    systemTableCreation: "System table creation",
    userTableCreation: "User table creation",
    accessType: "Access type",
    importerActive: "Importer active",
    fieldsForDataFilterInGridHelperText: "Ex.: “U_cttipfun“ = ‘PROD’ and “U_ctcodof” IN('FA001','FA006')",
    dataGridSortingFieldsHelperText: 'Fields separated by semicolon. Ex.: "U_codemp","U_fecha"',
    relatedDetailTable: "Related detail table",
    sqlToExecuteWhenSavingHelperText:
        'Variable #CODE# contains value of field "Code" from the inserted or modified registry',
    sqlToExecuteWhenDeletingHelperText: "Variable #CODES# contains the codes of the selected registries",
    sqlToExecuteWhenDeleting: "SQL to execute when deleting",
    operationModeSql: "Operation mode SQL",
    operationModeSqlHelperText:
        "Must return exactly one row with column \"Code\" and value 'Y', 'M', 'V' or 'N' (Y: allows creation, modification and deletion; M: allows modification only; V or N: allows no writing). With no result, error or invalid structure: the active editor is used as always.",
    recordBlockSql: "Record block SQL",
    recordBlockSqlHelperText:
        'Used to keep returned records in view-only mode and prevent editing or deletion (must return as "Code" all records to block, zero or more rows). Any error, value or invalid structure is ignored.',
    recordBlockSqlVariablesHelperText:
        "Variables #CODEMP# and #EMPLOYEESLIST# are available, and #ColN# in detail tables. Use 'Protection explanation' AS 'Error' to customize an error message with the reason the record is blocked from deletion or modification",
    protectionSql: "Protection SQL",
    protectionSqlHelperText:
        'For each returned "Code", only this field is protected against modifications. It does not block deletion or other fields.',
    sqlVariablesAvailableHelperText:
        "Variables #CODEMP# and #EMPLOYEESLIST# are available, and #ColN# in detail tables",
    cannotModifyOrDeleteBlockedRecords: "One or more records cannot be modified or deleted because they are blocked.",
    duplicateTableDefinition: "Duplicate table definition",
    systemTableDefinition: "System table definition",
    userTableDefinition: "User table definition",
    newSystemTable: "New system table",
    newUserTable: "New user table",
    noSystemTableFound: "No system table found",
    noUserTableFound: "No user table found",
    tradeForPoints: "Trae for points",
    maxPercentageMoneyTrade: "Max % for money direct exchange",
    criticalIncidentLogShort: "Critical incidents log",
    createRecognitionPlan: "Create recognition plan",
    editRecognitionPlan: "Edit recognition plan",
    duplicatePlan: "Duplicate plan",
    planCharts: "Plan charts",
    pointsToObtainThem: "Points to obtain them",
    valueEachRecognition: "Value of each recognition",
    prizeDelivery: "Prize delivery",
    criticalIncidentLogNotes: "Critical incident log (Notes)",
    mandatoryRedemption: "Mandatory redemption",
    addCollaboratorsToPlan: "Add collaborators to plan",
    editPlanAssignation: "Edit plan assignation",
    transferCollaboratorToPlan: "Transfer collaborator to plan",
    destinationRecognitionPlan: "Destination recognition plan",
    createOnboardingProfile: "Create onboarding profile",
    editOnboardingProfile: "Edit onboarding profile",
    duplicateOnboardingProfile: "Duplicate onboarding profile",
    visualizationTree: "Visualization tree",
    stepCreation: "Step creation",
    materialsOrResources: "Materials or resources (You may select more than one)",
    addCollaboratorsToProcess: "Add collaborators to process",
    viewProcessCollaborators: "View process collaborators",
    createOnboardingProcess: "Create onboarding process",
    editOnboardingProcess: "Edit onboarding process",
    cantChangeActionMomentTypeOrCodeInUse1:
        'Can\'t change "Action or moment type" or "Action or moment code" of this material/resource, because it\'s related to steps on some onboarding profiles.',
    cantChangeActionMomentTypeOrCodeInUse2:
        "To change it, first delete the material/resource from the profile where they're in use.",
    evaluationsYear: "Evaluations year",
    performanceEvaluationProcess: "Performance evaluation process",
    dateChangeRequestMustBeBetweenDates: "To request schedule change, date must be between {dateFrom} and {dateTo}",
    requestedDayIsBiggerThanAvailable:
        "Requested day is bigger than available balance in the current account by {amount} day(s)",
    requestedDaysAreBiggerThanAvailable:
        "The {requested} requested days are bigger than available balance in the current account by {amount} day(s)",
    changeScheduleRequests: "Change schedule requests",
    clickOnScheduleToChangeOrAuth: "Click on schedule to edit it, or authorize it in case of schedule change requests.",
    doubleClickWhitespaceToPreAuthExtraHours: "Double click on whitespace on calendar to preauthorize extra hours.",
    extraHoursAuth: "extra hours authorized",
    descendantEvaluatorDirectBoss: "Descending evaluator (Direct boss)",
    willBeAssignedToManagers: "Will be assigned to direct bosses (Managers) automatically.",
    evaluatorSelectionForCollaborators: 'Evaluator selection for the type "{type}" ({length} collaborators)',
    assignReplaceEvaluator: "Asign/replace evaluator",
    createdFemale: "Created",
    seniorityRequiredToParticipate: "Seniority required to participate",
    possibleFinalScoresPerformance: "Possible final scores for performance evaluation: From {min} - to {max}",
    possibleFinalScoresPotential: "Possible final scores for potential evaluation: From {min} - to {max}",
    finalScoreTypePerformance: "Final score type performance",
    finalScoreTypePotential: "Final score type potential",
    createEvaluationProcess: "Create evaluation process",
    editEvaluationProcess: "Edit evaluation process",
    statusE1:
        "Make sure that the weights of all goals and objectives add up to 100%, and do the same for the weights of the specific job competencies if they are being used.",
    statusE2:
        "To verify that the goals and objectives weights total 100%, log in with the employer role and go to: Performance Management / Goals and Objectives and select the period.",
    statusE3:
        "To verify that the specific job competencies weights total 100%, log in with the employer role and go to: Performance Management / Performance Definitions / Specific Competencies.",
    statusE4:
        "Also make sure that each evaluated employee has an assigned evaluator for every type of evaluation. Keep in mind that, within the evaluation processes, you can remove certain individuals from specific types of evaluations if desired.",
    statusE5:
        "Remember to send a message to all evaluators indicating that the performance evaluation process will begin so they can start rating. To send the message, log in with the employer role and go to: Performance Management / Evaluation Processes and use the following button for the selected evaluation process:",
    statusE6: "State to which the process can return, if it is already in this state: None.",
    statusE7: "State to which the process can advance, if it is already in this state: Rated.",
    statusF1:
        "You should only move the process to this state if all performance ratings have been completed. Log in with the employer role to Performance Management / Performance Evaluations and check the rating progress using this button, which will display a grid with the evaluation statuses, the evaluated employees, and their evaluators.",
    statusF2:
        "Once you view the evaluation statuses, sort them by clicking on the evaluation status column, filter all the pending ones (highlighted in color), select all the records with that status, and send the automatic message to the evaluators requesting them to complete their pending evaluations as soon as possible.",
    statusF3: "To send the automatic message from the grid, use the following button:",
    statusF4:
        "Only if an evaluation is pending and does not need to be carried out for the evaluated person, you can delete it from Performance Management / Evaluation Processes / Assign collaborators to the process, using the delete button.",
    statusF5:
        "Keep in mind that if you keep the process in progress, you will still be able to access the summary and results, perform calibration, and provide feedback without changing the process state. (The last two are only possible if the evaluations have a final score).",
    statusF6:
        "For this reason, it is not necessary to move to 'Rated' in order to access the evaluation summary and results, calibrate, or provide feedback.",
    statusF7: "State to which the process can return, if it is already in this state: In progress.",
    statusF8: "State to which the process can advance, if it is already in this state: In calibration.",
    statusB1: "The calibration state is optional.",
    statusB2:
        "However, it is highly recommended to review certain evaluations (forming a committee between People Management and some evaluators) to ensure that the ratings given to the evaluated employees were fair, equitable, and free from bias by the evaluators, or to discuss in the committee the evaluations that may have been contested by the evaluated individuals.",
    statusB3:
        "You should consider that the calibration committee has the authority to modify the ratings of the evaluated employees if it deems necessary.",
    statusB4: "State to which the process can return, if it is already in this state: Rated.",
    statusB5: "State to which the process can advance, if it is already in this state: In feedback.",
    statusK1:
        "Before moving to this state, remember to create a new period for goals and objectives so that when the evaluator gives feedback to the evaluated employee, they can assign new goals and objectives for a new period, allowing those goals and objectives to be managed and later evaluated in the next performance evaluation process.",
    statusK2:
        "Before moving to 'In Feedback', verify from Performance Evaluations that all evaluations are in the 'Completed' state.",
    statusK3:
        "Keep in mind that if, during the feedback, an evaluated employee contests their evaluation, the evaluation can be recalibrated if necessary.",
    statusK4:
        "Remember to send a message to all evaluators indicating that the performance evaluation has moved to the feedback stage and that they must conduct evaluation interviews with each of their evaluated employees. To send the message, log in with the employer role to: Performance Management / Evaluation Processes and use the following button for the selected evaluation process:",
    statusK5: "State to which the process can return, if it is already in this state: In calibration.",
    statusK6: "State to which the process can advance, if it is already in this state: In talent classification.",
    statusT1: "Advance to this state to classify performance and potential in a 9-Box matrix.",
    statusT2: "State to which the process can return, if it is already in this state: In feedback.",
    statusT3: "State to which the process can advance, if it is already in this state: Closed.",
    statusR1:
        "When you move the process to this state, the performance evaluation will be completely finalized and the ratings can no longer be modified or recalibrated.",
    statusR2:
        "This state will be final, and all process data and ratings will remain available for information management purposes only.",
    statusR3: "State to which the process can return, if it is already in this state: In talent classification.",
    noValueCanBeLessThanMinValuePerformance: "No performance value can less be than the min of the score ({min})",
    noValueCanBeMoreThanMaxValuePerformance: "No performance value can be greater than the max of the score ({max})",
    noValueCanBeLessThanMinValuePotential: "No potential value can be less than the of min the score ({min})",
    noValueCanBeMoreThanMaxValuePotential: "No potential value can be greater than the max of the score ({max})",
    duplicateEvaluationProcess: "Duplicate evaluation process",
    feedbackEvaluationProcessStart: "Feedback evaluation process start",
    willInformFeedbackStarted:
        "We inform all evaluators that we will move the process {processName} to the feedback stage, so they can begin the performance review interviews.\n\nGo to Performance Management / Summary and Results and use the following buttons: “Final Summary” (to view the complete performance evaluation of each employee), and then the “Give Feedback” button (to leave written feedback for the evaluated person).\n\nThank you very much for your participation!",
    willInformProcessStarted:
        "We inform all evaluators that we will start the process {processName}, so they can begin the performance ratings.\n\nGo to Performance Management / Performance Evaluations and complete the rating forms for each of your evaluated employees.\n\nThank you very much for your participation!",
    collaboratorsNotInProcess: "Collaboratdors not in process",
    historicalMale: "Historical",
    currentMonth: "Current month ({from} to {to})",
    previousMonth: "Previous month ({from} to {to})",
    nextMonth: "Next month ({from} to {to})",
    currentQuarter: "Current quarter ({from} to {to})",
    currentSemester: "Current semester ({from} to {to})",
    currentYear: "Current year ({from} to {to})",
    previousQuarter: "Previous quarter ({from} to {to})",
    previousSemester: "Previous semester ({from} to {to})",
    previousYear: "Previous year ({from} to {to})",
    last24Months: "Last 24 months ({from} to {to})",
    last36Months: "Last 36 months ({from} to {to})",
    maxAllowed: "Max allowed",
    groupToDuplicate: "Group to duplicate",
    duplicateSpecificSkill: "Duplicate specific skill",
    noIndicatorsFound: "No indicators found",
    createSkillIndicator: "Create indicator for skill: {name} - Group: {group}",
    editSkillIndicator: "Edit indicator for skill: {name} - Group: {group}",
    skillIndicators: "Indicators for skill: {name} - Grupo: {group}",
    duplicateTransversalSkill: "Duplicate transversal skill",
    createTransversalSkill: "Create transversal skill",
    editTransversalSkill: "Edit transversal skill",
    createTransversalSkillIndicator: "Create indicator for transversal skill: {name}",
    editTransversalSkillIndicator: "Edit indicator for transversal skill: {name}",
    transversalSkillIndicators: "Indicators for transversal skill: {name}",
    assistanceAnalysisProcess: "Assistance analysis process",
    assistanceAnalysisPeriod: "Assistance analysis period",
    totalExtraHoursDone: "Total extra hours done",
    unauthorizedExtraHours: "Unauthorized extra hours",
    absenceHoursAlt: "Absence hours",
    maxValueAllowed: "Max value allowed",
    generalAssistanceAnalysis: "General assistance analysis",
    totalLiquidsNet: "Total Liquids/net",
    liquidNet: "Liquid/net",
    valuesOccurrences: "Values/Ocurrences",
    conceptAnalysis: "Concept analysis",
    calculationProcessName: "Calculation process name",
    topAndBottom: "Top & Bottom",
    appliedFilter: "Applied filter",
    invalidInfo: "You need to enter your user and client code to recover or assign the access PIN",
    invalidPin: "PIN must contain between 4 and 10 characters",
    templateAlreadyExists: "There is already a template with that name",
    selectSociety: "Select a society to continue",
    selectColor: "Select a color to continue",
    loginError: "You cannot login as a {role} with the Client, User and PIN entered",
    noCurrentPin: "You need to enter the current PIN",
    noNewPin: "You need to enter the new PIN",
    noNewPinConfirm: "You need to enter the new PIN again",
    pinsMustBeEqual: "Both PINs entered do not match",
    pinsMustBeDifferent: "Current PIN cannot be the same as the new one",
    pinMustHaveMinCharacters: "New PIN entered must contain between 4 and 10 characters",
    pinMustHaveMaxCharacters: "New PIN entered must contain between 4 and 10 characters",
    motiveMustHaveMinCharacters: "Motive entered must contain 254 characters maximum",
    motiveMustHaveMaxCharacters: "Motive entered must contain 254 characters maximum",
    noMotive: "You need to enter the motive",
    noPin: "You need to enter the PIN",
    pinMustBeAlphanumeric: "New PIN cannot contain characters other than numbers and/or letters",
    noEmployeesFound: "No employees have been found.",
    noLoansFound: "No loans have been found.",
    invalidTitle: "Title is invalid",
    invalidSubtitle: "Subtitle is invalid",
    invalidDataAlt: "Information is invalid",
    invalidAlt: "Image is invalid",
    defaultException: "There has been a problem, please try again later",
    invalidParams: "There has been a problem, please try again later",
    invalidToken: "Your session is not valid, try logging in again",
    tokenMissing: "There has been a problem, you must log in again",
    userNotFound: "Ask the administrator for permission in order to access",
    googleError: "Error trying to access with Google",
    defaultErrorDialogTitle: "Message",
    defaultError: "There has been a problem with the server, please try again later",
    invalid: "Invalid",
    pinValidationError: "Current PIN entered is invalid",
    completeWithValidInformation: "Complete with valid information",
    serverError: "Server Error",
    societyNotFound: "Society not found",
    loginInvalidCredentials: "Invalid Credentials",
    userAlreadyExists: "User already exists",
    googleDataError: "Google Error",
    unAuthorized: "Unauthorized",
    emptyEmployees: "No employees",
    invalidImages: "Invalid images",
    clientNotExist: "Client does not exist",
    validationErrorAlt: "Validation Error",
    noPollError: "Error obtaining poll",
    nameNotValid: "Enter template name",
    templateMustHaveMinCharacters: "Template name must contain between 4 and 60 characters",
    templateMustHaveMaxCharacters: "Template name must contain between 4 and 60 characters",
    mustSelectPermissions: "Select visualization role",
    noAssistanceFound: "No assistance registries found",
    tooManyLoginRequests:
        "Your user has been blocked after too many failed login attempts. Try again in {minutos} minutes",
    certificateNotCreated: "Certificate not created.",
    certificatesNotAvailable: "No certificates available",
    receiptsNotAvailable: "No payslips available",
    selectCertificateType: "Select a certificate type",
    receiptNotCreated: "Receipt not created.",
    receiptNoMail: "Documents from users with no email can't be selected",
    selectReceiptType: "Select a receipt type",
    selectCalcProcess: "Select a calculation method",
    noRequests: "No requests found",
    dateErrorRequests: "Dates not allowed",
    validationErrorRequests: "Enter valid data",
    errorDaysQuantityRequests: "Invalid Amount of days",
    overlapErrorRequests: "Dates overlap with another vacation request",
    requiredFieldEmpty: "There are empty required fields",
    tagRepeated: "There is a tag with the same name",
    totemAlreadyExists: "There is already a totem with the same code entered",
    verifyDateTime: "Verify dates and times",
    invalidUser: "Invalid user",
    signerAlreadyExists: "Duplicated signer",
    invalidDocs: "Invalid documents",
    errorGettingDocsType: "Error getting document types",
    noRequestedDocuments: "There are no requested documents",
    incorrectPin: "Wrong PIN",
    appealExistsRiseErrorRequest:
        "The request for a salary increase could not be registered since the selected collaborator has one in progress",
    appealExistsFireErrorRequest:
        "The termination request could not be registered as the selected collaborator has one in progress",
    certificateNoMail: "{amount} documents from a total of {total} will be signed",
    assistanceAlreadyDone: "You cannot register attendance today as you have a leave or vacation on this date",
    assistanceBlocked: "You cannot register your assistance, please contact an administrator",
    incorrectQuery: "The query you are trying to import is corrupt",
    noNextSigner: "You must select the next signer",
    recognitionTotalAmount: "Recognitions total amount",
    myVacationCurrentAccount: "My vacations current account",
    changeDivision: "Change business unit",
    managementCenterDivision: "Change publication center",
    allTablesMustBeginWithA1A: "All tables must begin with @A1A_",
    allFieldsMustBeginWithU: "All fields must begin with U_",
    sqlFilterLabel:
        "SQL to filter the editor and indicate which Collaborators, Managers, or Employers will have access",
    sqlFilterHelperText:
        "Generate a list of employee Codes who will be the only ones allowed to access the editor as a Collaborator, Manager, or Employer. Assign the name 'Code' to the SQL field",
    sqlFilterLabelPermissions: "SQL to filter the type of leave and indicate that Contributors may request it",
    sqlFilterHelperTextPermissions:
        "Generate a list of Employee Codes that will be the only ones who can access the leave. Assign the name Code to the SQL field.",
    sqlFilterLabelAdvance: "SQL to filter the advance type and indicate which employees can request it",
    sqlFilterHelperTextAdvance:
        "Generate a list of employee codes that will be the only ones who can access the advance. Assign the name Code to the SQL field.",
    tooltip: "Tooltip",
    viewEmployeesInManagementCenterPlural: "View employees at these publication centers",
    viewEmployeesInManagementCenter: "View employees at this publication center",
    employeesAssignedToManagementCenter: "Employees assigned to this publication center",
    employeesAssignedToManagementCenterPlural: "Employees assigned to thse publication centers",
    noEmployeesAssignedToManagementCenter: "There are no contributors assigned to this publication center",
    editImputation: "Edit accounting imputation",
    createImputation: "Create accounting imputation",
    alternativeFieldName: "Alternative field name",
    alternativeFieldNameHelperText: "You can use '#LANGUAGE#' and must use AS \"Title\" for the alternative title",
    alternativeMenuName: "Alternative menu name",
    alternativeMenuNameHelperText:
        "You can use '#LANGUAGE#' and must use AS 'MenuTitle' y 'FunctionTitle' for the menu and function customized by SQL",
    scheduleDefinitionInUse: "Cannot delete schedule because it's already in use",
    onlyRequestDocumentsCanHaveUnderscoreInCode: 'Only the Request documents can include the character "_" in its code',
    employerContributionGroup: "Employer contribution group",
    isEmployerContributionGroup: "It's employer contribution group",
    INTERVIEW_FEEDBACK_POINTS_ASSIGNATION_ENABLED:
        "Allow evaluatores to deliver points while in process of Interviews and Feedback",
    deliverPointsToRequestBenefits: "Deliver points to request benefits",
    employeeMustBeInPlan: "Selected employee must be in a recognition plan",
    pointsAssigned: "Points earned in medal table",
    usesMedalPoints: "Delivers points to medal table",
    completeImputations: "Complete imputations",
    missingAccountsTitle: "Missing accounts for the process: {processName}",
    completeImputationsSuccessfull:
        "The accounting imputations have been successfully completed. Complete the missing accounts and reprocess the calculation process",
    completeImputationsQuestionTitle:
        "Are you sure you want to complete the ‘Accounting imputations definition’ with these concepts that do not have a related account?",
    completeImputationsQuestion1:
        "By choosing ‘Yes’, note that in the ‘Accounting imputations definition’ all missing imputations shown in the grid will be added, and in the column ‘Account’ the value ‘No account’ will be set to help you locate the accounts you must complete from ‘Payroll/Accounting imputations’.",
    completeImputationsQuestion2:
        "Remember to review, when completing the accounts, the following columns if necessary: ‘Reference’, ‘Detailed information’, ‘Distribution’, or ‘Condition’.",
    completeImputationsQuestion3: "Do you confirm completing the accounting imputations?",
    imputationType: "Imputacion type",
    duplicatedAttendanceMarksDeletedSuccessfully: "Duplicated attendance marks delete successfully",
    deleteDuplicatedAttendanceMarks: "Delete duplicated assistance marks",
    deleteDuplicatedMarksQuestion: "There are duplicated assistance marks found, do you wish to delete them?",
    advanceOrAdvancedPaymentName: "Name of advance or payment in advance",
    advanceOrAdvancedPaymentType: "Type of advance or payment in advance",
    advanceOrAdvancedPaymentCode: "Code of advance or payment in advance",
    advanceOrAdvancedPaymentSettings: "Advances or payments in advance for requests",
    advanceOrAdvancedPaymentCreation: "Advances or payments in advance creation",
    advanceOrAdvancedPaymentNew: "New advance or payment in advance",
    noAdvancesOrAdvancedPayment: "No advances or payments in advance created",
    variableCommission: "Variable commission",
    balanceCommission: "Balance commission",
    afpCode: "AFP code",
    structureConceptsAddedSuccessfully: "Concepts modified successfully",
    addConcepts: "Add concepts",
    availableDays: "Available days",
    availableBalance: "Available balance",
    duplicateConceptInStructure: "Duplicate concept in structure",
    originConcept: "Origin concept",
    originID: "Origin ID",
    conceptToCreate: "Concept to create",
    duplicateConceptNameCodeInUse: "Cannot duplicate concept because name or code are in use",
    importAccountingImputations: "Import accounting imputations",
    noProcessedCollaboratorsToCheck: "No processed collaborators to check",
    trainingAndDevelopment: "Training and development",
    coursesMaster: "Courses master",
    themeArea: "Thematic area",
    themes: "Themes",
    length: "Duration",
    certification: "Certification",
    createCourse: "Create course",
    updateCourse: "Update course",
    finalizationCertificates: "Completion certificates",
    hasAssistanceCertificate: "With attendance certificate",
    assistancePercentageRequired: "Required attendance",
    hasKnowledgeCertificate: "With knowledge certificate",
    knowledgeCertificateMinScore: "Minimum score",
    knowledgeCertificateMaxScore: "Maximum score",
    knowledgeCertificateMinScoreToPass: "Minimum passing score",
    courseCreatedOk: "Course created successfully",
    courseUpdatedOk: "Course updated successfully",
    courseDeletedOk: "Course deleted successfully",
    modulesAndActivitiesFromCourse: "Modules and activities from course - {courseName}",
    modules: "Modules",
    doYouWantToDeleteCourse: "Do you want to delete the course?",
    doYouWantToDeleteModule: "Do you want to delete the module?",
    doYouWantToDeleteActivity: "Do you want to delete the activity?",
    createModule: "Create module",
    updateModule: "Update module",
    viewModule: "View module",
    nextOrderModule:
        "Next available: {nextOrder}. If you set an existing order for another module, the modules from that point onward will be shifted.",
    moduleCreatedOk: "Module created successfully",
    moduleUpdatedOk: "Module updated successfully",
    moduleDeletedOk: "Module deleted successfully",
    activityCreatedOk: "Activity created successfully",
    activityUpdatedOk: "Activity updated successfully",
    activityDeletedOk: "Activity deleted successfully",
    module: "Module",
    userFields: "User fields",
    pressEnterToAdd: "Write theme and then press Enter to add it",
    nextOrderActivity:
        "Next available in module: {nextOrder}. If you set an existing order for another activity, the activities from that point onward will be shifted.",
    selectResources: "Select resources",
    createActivity: "Create activity",
    updateActivity: "Update activity",
    viewActivity: "View activity",
    activityDependency: "Depends on completion of other activity",
    noDependency: "No dependency",
    enterContent: "Enter content",
    attempts: "Attempts",
    attempt: "Attempt",
    externalVideo: "External video",
    externalMedia: "External media",
    selectVideoFromLibrary: "Video from library",
    selectMediaFromLibrary: "File from library",
    uploadVideo: "Upload video",
    hasResources: "Has resources",
    courseInUseUpdate: "Course cannot be updated because it's associated to training",
    courseInUseDelete: "Course cannot be deleted because it's associated to training",
    courseInUse: "Course cannot be updated/deleted because it's associated to training",
    moduleInUse: "Module cannot be deleted because it's associated to activities",
    activityInUse: "Activity cannot be deleted because it's associated to other activities",
    courseDuplicatedData: "There's already a course with the same name",
    moduleDuplicatedData: "There's already a module with the same name",
    activityDuplicatedData: "There's already an activity with the same name",
    content: "Content",
    addSession: "Add session",
    sessions: "Sessions",
    sessionType: "Session type",
    questionsAmountToUse: "Number of questions to use",
    activityQuestionsAmountToUseHelperText:
        "If you select a number of questions lower than the total number of defined questions, at the time of taking the evaluation the questions to be used will be determined randomly.",
    useRandomOrder: "Use random order",
    useSelfCorrection: "Use self-correction",
    activityUseSelfCorrectionHelperText:
        "If your evaluation has questions of the descriptive type, you can NOT use self-correction. In this case, the evaluation will require manual correction by the instructor.",
    updateQuestion: "Update question",
    questionType: "Question type",
    addAnswer: "Add answer",
    doYouWantToDeleteQuestion: "Do you wish to delete the question?",
    recognitionPoints: "Recognition points",
    courseDuplicatedOk: "Course duplicated successfully",
    duplicateCourse: "Duplicate course: {courseName}",
    courseExportedOk: "Course exported successfully",
    courseImportedOk: "Course imported successfully",
    usedSpaceMB: "Used space (MB)",
    training: "Training",
    trainingSingular: "Training",
    trainingDuplicatedData: "There's already a training with the same name",
    instructor: "Instructor",
    createTraining: "Create training",
    updateTraining: "Update training",
    course: "Course",
    duplicateTraining: "Duplicate training: {trainingName}",
    modulesAndActivitiesFromTraining: "Modules and activities from training - {trainingName}",
    doYouWantToDeleteTraining: "Do you wish to delete the training?",
    trainingPublishedRequiredFields:
        "To set the training as Published, you must enter date from, date to and enter an instructor",
    trainingPublishedActivityRequiredFields:
        "To set the training as Published, you must enter its activities date, time and location",
    dateTo: "Date to",
    isInPersonActivity: "Activity is in person",
    additionalInfo: "Additional information",
    time: "Time",
    location: "Location",
    session: "Session",
    instructorsOrigin: "It's being shown people in groups tagged as “Trainers or couches",
    courseTree: "Visualization tree of course: {courseName}",
    courseMode: "Course mode",
    assignEmployeesToTraining: "Assign collaborators to training",
    assignEmployeesToTrainingWithTrainingName: "Assign collaborators to training: {trainingName}",
    trainingAssignmentDeleteQuestion:
        "Do you wish to remove this collaborator from the assigment, losing all their training progress?",
    enterLinkOrAddress: "Enter URL or address",
    uploadThumbnailFile: "Upload thumbnail file",
    thumbnail: "Thumbnail",
    trainingThumbnailExplanation: "File selected will be shown as an image representing the training course",
    myTraining: "My Training",
    activeTraining: "Active training",
    finishedTraining: "Finished training",
    myTrainingCertificatesExportedOk: "Certificates downloaded successfully",
    downloadCertificates: "Download certificates",
    noActiveTraining: "No active training found",
    noFinishedTraining: "No finished training found",
    complete: "Complete",
    incomplete: "Incomplete",
    trainingDefinition: "Training definition",
    courseName: "Course name",
    alertBodyTextHelperText:
        "If you have selected fields for the body of the email, for example 1, 2, 4, and you want to insert them in a specific position, use <DATA1> <DATA2> <DATA4> in the position where you want them.",
    stop: "Stop",
    play: "Play",
    notesAlt: "Notas",
    byAlt: "By",
    inPerson: "In person",
    virtual: "Virtual",
    accessSession: "Access session",
    noSessionData: "No info about session, contact your instructor",
    noSessionDataShort: "No info about session",
    activityDependencyToCompleteFirst: "To access this activity you must complete {activityName} first",
    resources: "Resources",
    answerSentSuccessfully: "Answer sent successfully",
    activityAlreadyAnswered: "Activity previously answered",
    activityPassed: "Activity passed",
    activityFailed: "Activity failed",
    enterAnswer: "Enter answer",
    solveExercise: "Solve exercise",
    solve: "Solve",
    activityPendingInstructor: "Activity solved and pending qualification",
    grade: "Grade",
    grades: "Grades",
    gradeActivity: "Grade",
    gradeOrViewActivity: "View or grade",
    score: "Score",
    noScore: "No score set",
    enterOptionalFeedback: "Enter feedback (optional)",
    enterRequiredFeedback: "Enter feedback (required)",
    minMaxPassValues: "Min.: {min}. Max.: {max}. Pass: {pass}",
    gradeSentSuccessfully: "Grade sent successfully",
    resolution: "Resolution",
    correct: "Correct",
    incorrect: "Incorrect",
    pendingGrades: "Pending grades",
    trainingInUseUpdate: "Training cannot be updated because participants have already completed activities",
    trainingInUseDelete: "Training cannot be deleted because participants have already completed activities",
    attemptUpdatedSuccessfully: "Data updated successfully",
    updateSession: "Update session",
    updateAttempt: "Update attempt",
    cannotAssignParticipantAsInstructor: "Cannot assign as instructor someone that is a participant",
    participants: "Participants",
    viewParticipants: "View participants",
    knowledge: "Knowledge",
    knowledgeCompleted: "Knowledge completed",
    knowledgeIncompleted: "Knowledge incompleted",
    assistanceCompleted: "Assistance completed",
    assistanceIncompleted: "Assistance incompleted",
    correctAnswer: "Correct answer",
    correctUnpickedAnswer: "Correct but unpicked answer",
    incorrectAnswer: "Incorrect answer",
    clicToOpenModulesAndActivities: "Clic on a course to see or define their modules and activities",
    activityNotSolved: "Not solved",
    noResolutionsMatchFilter: "No resolutions that matched filter",
    solvedPlural: "Solved",
    notSolved: "Not solved",
    approved: "Approved",
    approvedPlural: "Approved",
    failed: "Failed",
    failedPlural: "Failed",
    toGrade: "To grade",
    grading: "Grading",
    viewResolution: "View resolution",
    trainingMedalTablePoints: "Completing this training will give you {points} points in your medal table",
    ask: "Ask",
    deleteQuestionConfirmation: "Do you want to delete the question?",
    deleteAnswerConfirmation: "Do you want to delete the answer?",
    closeQuestionConfirmation: "Do you want to close the question?",
    noQuestionsMatchFilterQAndA: "No questions that matched filter",
    markAsSolved: "Mark as closed",
    questionsWithoutAnswer: "There are questions without answer",
    newAnswersToSee: "There are new questions to see",
    questionMarkedAsSolvedSuccessfully: "Question marked as solved successfully",
    questionCreatedSuccessfully: "Question created successfully",
    questionUpdatedSuccessfully: "Question updated successfully",
    questionDeletedSuccessfully: "Question deleted successfully",
    answerCreatedSuccessfully: "Answer created successfully",
    answerUpdatedSuccessfully: "Answer updated successfully",
    answerDeletedSuccessfully: "Answer deleted successfully",
    closedQuestions: "Closed questions",
    openQuestions: "Open questions",
    orderAlreadyInUse: "The order entered is already in use",
    defaultQuestions: "Default questions",
    thisActivityHasLengthOf: "This activity has a length of",
    activityCountdownExplanation1:
        "Once the timer is finished, you won't be able to solve the activity anymore and, in that case, the current attempt will be considered as failed.",
    activityCountdownExplanation2: "Press the button to start the activity and timer.",
    startActivity: "Start activity",
    timeIsUp: "Time is up",
    timeRemaining: "Time remaining",
    enterNotes: "Enter your notes",
    notesUpdatedSuccessfully: "Notes saved successfully",
    hasSavedNotes: "You have saved notes",
    noParticipantsFound: "No participants found",
    activity: "Activity",
    accessTraining: "Access training",
    viewStats: "View stats",
    stats: "Estadísticas",
    participant: "Participant",
    trainingPlural: "Training",
    noTrainingMatchFilter: "No training matches filters",
    statsByTraining: "Stats by training",
    statsByParticipant: "Stats by participant",
    clickColumnToViewMoreAboutTraining: "Click a column to view more training information",
    activitiesByTraining: "Activities by training",
    usersByTraining: "Participants by training",
    percentageUsersFinishedByTraining: "Percentage of participants that finished each training",
    totalFinishedPercentage: "Total finished percentage",
    percentageFinishedByTraining: "Finished percentage by training",
    activitiesFinishedByTraining: "Finished activities by training",
    activitiesFinished: "Finished activities",
    percentageFinishedByUser: "Percentage finished by participant",
    progress: "Progress",
    filtersAppliedSelectTrainingAgain: "Filteres applied, select trainings you want to see",
    youMustSelectTraining: "You must select a training",
    activityFinished: "Activity finished",
    activityName: "Activity name",
    participantCode: "Participant code",
    participantName: "Participant full name",
    viewAnswers: "View answers",
    positionDescriptionDownloaded: "Position description has been downloaded",
    noAnswersFound: "No answers found",
    nodeVisualization: "Node visualization",
    default: "Default",
    centrality: "Centrality",
    onaDestinatary: "Destinatary",
    skillClass: "Skill class",
    targetSkillSpecific: "Required level",
    pollNetworkType: "Poll network type",
    cannotShowScope: "Cannot show Scope in polls related to work groups or with a group of specific collaborators",
    responsibilities: "Responsibilities",
    expectedResults: "Expected Results",
    intellectualRequirements: "Intellectual Req.",
    physicalRequirements: "Physical Req.",
    workConditions: "Work Conditions",
    addTask: "Add Task",
    taskName: "Task",
    addResponsibility: "Add Responsibility",
    whichOnes: "Which Ones",
    descriptionOfExpectedResults: "Description of expected results",
    addIntellectualRequirement: "Add Intellectual Req.",
    addPhysicalRequirement: "Add Physical Req.",
    addWorkCondition: "Add Work Condition",
    general: "General",
    noWorkConditionsAdded: "No work conditions have been entered.",
    noTasksAdded: "No tasks have been entered.",
    noResponsibilitiesAdded: "No responsibilities have been entered.",
    noIntellectualRequirementsAdded: "No intellectual requirements have been entered.",
    noPhysicalRequirementsAdded: "No physical requirements have been entered.",
    noDataForFilter: "No data found for selected filters",
    searchSkill: "Search skill",
    selectedSkills: "Selected skills",
    relatedSkills: "Related skills",
    skillInUseInCourse: "Cannot delete skill because it's related to a course",
    hasRelatedSkills: "Has related skills",
    moduleVisualizationFilterHelperText:
        'SQL that must be met to visualize the module.\nEnter a complete SQL query in the format: SELECT TOP 1 "Code" FROM... WHERE...\nIf it returns at least one record for the logged-in user, the module will be displayed. If it returns no records, it will not be shown.\nUse the variable "#CODEMP#" to represent the code of the queried user.',
    menuVisualizationFilterHelperText:
        'SQL that must be met to visualize the menu.\nEnter a complete SQL query in the format: SELECT TOP 1 "Code" FROM... WHERE...\nIf it returns at least one record for the logged-in user, the menu will be displayed. If it returns no records, it will not be shown.\nUse the variable "#CODEMP#" to represent the code of the queried user.',
    menus: "Menus",
    menu: "Menu",
    exclusions: "Exclusions",
    editable: "Editable",
    sqlFilter: "SQL filter",
    path: "Path",
    childrenOf: "Parent",
    hiddenByChildren: "Hidden if no active children",
    employees: "Employees",
    menuUpdatedOk: "Menu updated successfully",
    visualizationFilter: "Visualization filter",
    menuData: "Menu data",
    modulesAndMenus: "Modules y menus",
    updateMenu: "Update menú",
    exclusionSQLHelperText:
        "Enter an SQL query that only returns employee codes to exclude.\nExpected format: SELECT ...AS 'Code' FROM... WHERE...",
    applyExclusionTo: "Apply exclusion to",
    submenu: "Submenu",
    employeeHasNoAcessToRole: "Employee has no access to selected role",
    createExclusion: "Create exclusion",
    updateExclusion: "Update exclusion",
    deleteExclusionQuestion: "Do you wish to delete the exclusion?",
    requiredMenu: "Menu is required",
    button: "Button",
    box: "Box",
    clickToSelectMenu: "Click on menu in tree to select it",
    visualizationEmployees: "Visualization employees",
    onaEmployees: "ONA employees",
    organizationalDevelopment: "Organizational development",
    skills: "Skills",
    globalRanking: "Global ranking",
    fulfillment: "Fulfillment",
    gap: "Gap",
    realLevel: "Real level (1-5)",
    requiredLevel: "Required level (1-5)",
    skill: "skill",
    collaboratorRanking: "Collaborators ranking",
    profileMatches: "Profile matches",
    surpassesProfile: "Superpasses profile",
    lowGap: "Low gap",
    suggestedCourses: "Suggested course",
    skillMatrix: "Skill matrix",
    lms: "L.M.S.",
    toImproveDevelopment: "To improve development",
    currentDevelopmentLevel: "Current development level",
    byPositionSkills: "By position skills",
    masteryLevel: "Mastery level",
    skillsRanking: "Skills ranking",
    dependency: "Dependency",
    blockedByPendingActivity: "Blocked by pending activity ({activityName})",
    pendingCorrection: "Pending correction",
    sessionHowToComplete: "To complete this activity, your instructor must mark your assistance.",
    sessionHowToCompleteAsInstructor: "You must mark participant's assistance to complete this activity for them.",
    cannotEditSession: "You cannot edit this session because it has marked assistances",
    readOnlyAdmin: "Read Only (Admin)",
    viewAssistance: "View assistance",
    privacyPolicyContent1:
        ' is an absolutely secure SaaS platform" that confidentially safeguards all your personal information.',
    privacyPolicyContent2:
        "It keeps all data related to your password and access identification encrypted, not allowing access to your data by third parties.",
    privacyPolicyContent3: 'In "Personal Data" you will be able to view all the information that ',
    privacyPolicyContent4:
        " has in your file as a collaborator and, additionally, it has all the information related to other processes where you may be participating, such as: payroll calculation processes, your performance evaluations, training, annotations made by your direct management, your digital folder (digitally signed documents: employment contracts, payroll calculation receipts, requests for permission or vacations, signed consents, etc.).",
    privacyPolicyContent5: "Who can access this information?",
    privacyPolicyContent6: "You, by entering the ",
    privacyPolicyContent7: " platform as a collaborator and identifying yourself correctly.",
    privacyPolicyContent8: "Your direct management (who logs in as a manager).",
    privacyPolicyContent9:
        "The People Management staff, in charge of your organization's personnel management, who log in as employers.",
    privacyPolicyContent10: "And no one else.",
    privacyPolicyContent11:
        'To do this, you must never share your access PIN, which you can change whenever you want from the side menu and through the "My PIN" menu item, once you are inside the platform. However, if you have not entered the platform or do not remember how to do it, from the LOGIN screen you can click on "Recover access PIN", first entering the CLIENT data and your USER; in this way, you will be able to restore a new access PIN, just follow the steps that ',
    privacyPolicyContent12: " will guide you through.",
    privacyPolicyContent13:
        "You can have full guarantee that none of your information is shared with third parties or external companies and for no purpose.",
    privacyPolicyContent14: "YOUR PERSONAL INFORMATION and PRIVACY is kept under strict confidentiality control.",
    privacyPolicyContent15:
        "Likewise, the database where your information is contained is unique, private and is stored in the cloud with one of the most secure providers worldwide, such as Amazon Web Services (AWS), who, by international rules and policies, only host these databases, but do not interfere with them in any way.",
    privacyPolicyContent16:
        'When you review your "Personal Data" you will have a button called "Request a correction" at your disposal, which, if you press it, will allow you to indicate what personal data you have viewed that is incorrect or inaccurate. Once this action is taken, ',
    privacyPolicyContent17:
        ' will send an alert email to the "People Management" staff of your organization so that they can proceed to change the data or correct it, and later notify you that the requested changes have been made, if applicable.',
    privacyPolicyContent18: "Right to portability",
    privacyPolicyContent19: "Your organization, if it suspends the SaaS service with ",
    privacyPolicyContent20: ", has the right to receive all the information that ",
    privacyPolicyContent21:
        " contains in the organization's database and be able to move to another platform or make use of that information as they determine most appropriate. We have the obligation to eliminate it completely when determined by your organization, and that must be within 90 calendar days of having received the requested database and that it was delivered by us, which will be duly documented.",
    privacyPolicyContent22: "Development environments",
    privacyPolicyContent23:
        " never uses third-party environments to develop its software; that is, it does not use the data of any of our clients. That is, we do not use the production servers that we maintain with AWS; quite the opposite, our own information is used and on development servers that are hosted with other providers and that are exclusive for the development and maintenance of our software.",
    tourBack: "Back",
    tourClose: "Close",
    tourFinish: "Finish",
    tourNext: "Next",
    tourSkip: "Skip",
    commandPaletteTourTitleSearch: "Smart Search",
    commandPaletteTourSearch: "Here you can instantly search for menus, routes, and screens.",
    commandPaletteTourTitleList: "Instant Results",
    commandPaletteTourList:
        "Your search results will appear here. You can navigate through them quickly using your keyboard.",
    commandPaletteTourTitleFooter: "Keyboard Shortcuts",
    commandPaletteTourFooter: "Use these shortcuts to navigate through the palette faster without using the mouse.",
    toNavigate: "to navigate",
    toSelect: "to select",
    toClose: "to close",
    toHelp: "for help",
    porcentajeRentabilidadProtegida: "Protected return percentage",
    porcentajeExpectativaDeVida: "Life expectancy percentage",
    porcentajeCapitalizaciónIndividual: "Individual capitalization percentage",
    duplicateExclusion: "Duplicate exclusion",
    exclusionDuplicateOk: "Exclusion duplicated successfully",
    icariusAssistant: "ICARIUS AI Assistant",
    howCanIHelp: "How can I help you?",
    writeYourMessage: "Write your message...",
    doNotShareInformation: "Do not share sensible information",
    groupOwner: "Group owner",
    enableGroupChatbot: "Enable chatbot",
    BOT_ASSISTANT_ENABLED: "Enable Chatbot for groups and digital warehouses",
    groupChatbotDisabledGeneralParameters: "Chatbot disabled from General Parameters",
    confirmSyncFiles: "Do you wish to sync selected files for ICARIUS AI Assistant?",
    syncFiles: "Sync files for ICARIUS AI",
    fileSyncStatus: "File sync status",
    filesSyncedSuccessfully: "Files sync finished successfully",
    fileInvalidFormat: "File with invalid format",
    cannotSelectMoreThanTwoFiles: "Cannot select more than two files",
    cancelMessage: "Cancel message",
    conversationDeletedOk: "Conversation deleted successfully",
    deleteConversation: "Delete conversation",
    attachFile: "Attach file",
    confirmDeleteConversation: "Do you wish to delete the conversation and new files uploaded?",
    suggestedQuestions: "Suggested questions",
    REQUEST_BLOCK: "The tally data entry app must request the block",
    REQUEST_VARIETY: "The tally data entry app must request the variety",
    generateOrUpdateWithAI: "Create or update with AI",
    updateQueryWithAI: "Update with AI",
    mustSelectSingleItemOrNone: "You must either select one item or none",
    questionsEnabledAfterFirstGeneration: "You will be able to edit questions after first AI query modification",
    invalidParamValues: "Invalid param values",
};

export default stringsEN;
